<template>
  <div class="home" id="home">   
    <div id="demo-content">
      <div class="out-service-res" v-show="!close_store" v-bind:style="{backgroundColor : color_botones }">
        <svg xmlns="http://www.w3.org/2000/svg" id="logo" width="512" height="512" viewBox="0 0 386 386.43371" fill="none">
          <path xmlns="http://www.w3.org/2000/svg" d="m316.449219 271.734375c7.554687-19.144531 11.449219-39.347656 11.449219-60.109375 0-48.785156-21.460938-92.632812-55.410157-122.671875l8.863281-8.863281 4.832032 4.832031c1.332031 1.332031 3.078125 2 4.824218 2 1.746094 0 3.496094-.667969 4.828126-2 2.664062-2.667969 2.664062-6.992187 0-9.65625l-19.3125-19.308594c-2.667969-2.664062-6.988282-2.664062-9.652344 0-2.667969 2.667969-2.667969 6.992188 0 9.652344l4.828125 4.828125-9.832031 9.832031c-25.609376-19.117187-56.976563-30.90625-90.984376-32.308593v-13.828126h17.066407c9.414062 0 17.066406-7.65625 17.066406-17.066406s-7.652344-17.066406-17.066406-17.066406h-47.785157c-9.414062 0-17.066406 7.65625-17.066406 17.066406s7.652344 17.066406 17.066406 17.066406h17.066407v13.828126c-37.453125 1.542968-71.691407 15.714843-98.578125 38.367187l-15.890625-15.890625 4.828125-4.828125c2.667968-2.664063 2.667968-6.984375 0-9.652344-2.664063-2.664062-6.988282-2.664062-9.652344 0l-9.644531 9.648438c-.003907.003906-.007813.003906-.011719.003906-.003906.003906-.003906.007813-.007812.011719l-9.644532 9.644531c-2.667968 2.667969-2.667968 6.988281 0 9.65625 1.332032 1.332031 3.078125 2 4.824219 2s3.496094-.667969 4.828125-2l4.828125-4.828125 15.449219 15.449219c-29.839844 29.691406-48.339844 70.765625-48.339844 116.082031 0 90.34375 73.496094 163.839844 163.839844 163.839844 20.730468 0 40.890625-3.882813 60-11.410156 12.015625 13.679687 29.578125 22.371093 49.171875 22.378906h.019531c36.121094 0 65.527344-29.390625 65.539062-65.519532 0 0 0 0 0-.003906.003907-19.589844-8.675781-37.152344-22.339843-49.175781zm-179.699219-254.667969c0-1.882812 1.53125-3.414062 3.414062-3.414062h47.785157c1.882812 0 3.414062 1.53125 3.414062 3.414062 0 1.882813-1.53125 3.414063-3.414062 3.414063h-47.785157c-1.882812 0-3.414062-1.53125-3.414062-3.414063zm27.308594 344.746094c-82.8125 0-150.1875-67.375-150.1875-150.1875s67.375-150.183594 150.1875-150.183594 150.183594 67.371094 150.183594 150.183594c0 17.894531-3.246094 35.300781-9.367188 51.902344-6.746094-3.734375-14.226562-6.25-22.148438-7.40625 3.570313-9.546875 6.054688-19.519532 7.25-29.753906 3.941407-33.636719-5.453124-66.792969-26.453124-93.359376-21-26.566406-51.09375-43.367187-84.726563-47.304687-28.261719-3.296875-56.070313 2.71875-80.363281 17.4375-3.226563 1.953125-4.253906 6.152344-2.300782 9.375 1.949219 3.222656 6.15625 4.261719 9.375 2.304687 21.671876-13.128906 46.445313-18.496093 71.699219-15.558593 30.015625 3.515625 56.859375 18.507812 75.601563 42.214843 18.742187 23.703126 27.121094 53.289063 23.605468 83.304688-1.207031 10.34375-3.804687 20.410156-7.71875 29.917969-.117187.289062-.09375.589843-.171874.886719-15.714844 1.117187-30.347657 7.703124-41.605469 18.953124-11.199219 11.191407-17.792969 25.738282-18.964844 41.367188-17.90625 7.554688-37.640625 10.34375-57.050781 8.082031-61.953125-7.253906-106.457032-63.558593-99.210938-125.515625.441406-3.742187-2.242187-7.136718-5.984375-7.574218-3.746093-.480469-7.136719 2.238281-7.574219 5.984374-8.128906 69.4375 41.75 132.539063 111.183594 140.664063 4.910156.578125 9.847656.859375 14.765625.859375 15.167969 0 30.195313-2.859375 44.371094-8.167969 1.144531 7.953125 3.664063 15.464844 7.40625 22.238281-16.566406 6.097657-33.9375 9.335938-51.800781 9.335938zm109.191406 10.96875c-.007812 0-.015625 0-.019531 0-28.609375-.011719-51.875-23.292969-51.867188-51.902344 0-13.859375 5.398438-26.886718 15.203125-36.679687 9.800782-9.792969 22.820313-15.1875 36.675782-15.1875h.019531c13.859375.003906 26.886719 5.402343 36.6875 15.207031 9.792969 9.800781 15.183593 22.832031 15.183593 36.6875-.007812 28.605469-23.28125 51.875-51.882812 51.875zm0 0" data-original="#000000" style="" stroke="white" stroke-width="5" />
          <path xmlns="http://www.w3.org/2000/svg" d="m107.324219 264.121094c1.628906 0 3.265625-.582032 4.570312-1.757813l37.082031-33.425781c3.464844 1.960938 7.410157 3.171875 11.664063 3.171875 13.175781 0 23.894531-10.71875 23.894531-23.894531 0-13.171875-10.71875-23.894532-23.894531-23.894532-13.171875 0-23.890625 10.722657-23.890625 23.894532 0 3.9375 1.046875 7.601562 2.746094 10.882812l-36.746094 33.128906c-2.800781 2.523438-3.019531 6.839844-.5 9.636719 1.351562 1.496094 3.210938 2.257813 5.074219 2.257813zm53.320312-66.148438c5.644531 0 10.238281 4.59375 10.238281 10.242188 0 5.644531-4.59375 10.238281-10.238281 10.238281-5.648437 0-10.242187-4.59375-10.242187-10.238281 0-5.648438 4.59375-10.242188 10.242187-10.242188zm0 0" data-original="#000000" style="" stroke="white" stroke-width="5"/>
          <path xmlns="http://www.w3.org/2000/svg" d="m56.941406 157.121094c1.082032.628906 2.269532.929687 3.433594.929687 2.351562 0 4.636719-1.214843 5.90625-3.386719 3.492188-5.988281 7.570312-11.691406 12.113281-16.949218 2.464844-2.851563 2.152344-7.164063-.699219-9.628906-2.859374-2.472657-7.164062-2.160157-9.628906.699218-5.09375 5.890625-9.664062 12.285156-13.578125 19-1.902343 3.253906-.800781 7.433594 2.453125 9.335938zm0 0" data-original="#000000" style="" stroke="white" stroke-width="5"/>
          <path xmlns="http://www.w3.org/2000/svg" d="m273.285156 279.894531c-3.773437 0-6.828125 3.054688-6.828125 6.824219v40.960938c0 3.769531 3.054688 6.828124 6.828125 6.828124 3.773438 0 6.824219-3.058593 6.824219-6.828124v-40.960938c0-3.769531-3.050781-6.824219-6.824219-6.824219zm0 0" data-original="#000000" style="" stroke="white" stroke-width="5"/>
          <path xmlns="http://www.w3.org/2000/svg" d="m280.109375 348.160156c0 3.769532-3.054687 6.828125-6.824219 6.828125-3.773437 0-6.828125-3.058593-6.828125-6.828125 0-3.769531 3.054688-6.828125 6.828125-6.828125 3.769532 0 6.824219 3.058594 6.824219 6.828125zm0 0"  data-original="#000000" style="" stroke="white" stroke-width="5"/>
        </svg>
          <h4>&#128549; Ups!!</h4>|
        <button v-bind:style="{color : color_botones }" @click="call()"><i class="fas fa-phone-alt"></i> {{ telefono_pedidos.length == 12 ? telefono_pedidos.substr(2,12) : telefono_pedidos }}</button>
        <h2>{{ company.name }}</h2>
      </div>
      <div id="loader-wrapper">
        <div id="loader"></div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>      
      </div>
      <div class="maintance" v-show="mantenimiento">
        <div class="content-maintance">
          <!--<img src="https://info.vinapp.co/wp-content/uploads/2021/04/LOGO-VINAPP.png" alt="">-->
          <h4>Estamos mejorando para ti</h4>
          <h5>Actualizaremos nuestro sistema para mejorar tu experiencia, estaremos contigo a las 6:00 AM</h5>
        </div>
      </div>
      <!-- Validacion observacion-->
      <div class="order-out" v-show="exit_component">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>Seleccione una combinacion.</h4>
          <div class="exit-options">
            <button @click="exit_component=false" >Cancelar</button>
            <button @click="saveOrderBD(false)" >Ok</button>
          </div>
        </div>
      </div>
      <!--- Fin Validacion-->
      <!-- Validacion Costeñito-->
      <div class="order-out" v-show="formNewClientModal && !mesero && this.pedidos_fuera_horario">
        <div class="canceled-info">
          <div style="color: #bdbdbd;
          display: flex;
          padding-left: 1rem;" @click="formNewClientModal=false">
            <i class="fas fa-times"></i>
          </div>
          <div class="container-logo" style="display: flex;background-color:#fff;">             
            <div style="margin-top: 20px;width: 60% !important;margin-bottom: 15px;" class="div-titulo"> 
                <label id="titulo1">{{companie_name}}</label>     
            </div>
            <div style="text-align: center;width: 40% !important;margin-top: -50px; z-index: 999;">
              <div style="display: inline-block;box-shadow: 2px 1px 10px 0px rgba(130,130,130,1);border-radius: 50%;overflow: hidden;padding: 15px;background-color: white;">
                  <picture>
                      <source rel="preconnect" v-bind:alt="url_images" type="image/webp" class="logos" id="logo5">
                      <source rel="preconnect" v-bind:alt="url_images" type="image/jp2" class="logos" id="logo6">
                      <img rel="preconnect"  style="height: 110px; width: 100px; margin-left:3px;border-radius: 50%;" class="logos" id="logo7">
                  </picture>              
              </div>               
            </div>
          </div>
          <label>Para <strong>celebrar juntos</strong>, te pedimos que compartas estos datos con nosotros.</label>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-mobile-alt form-control-feedback"></i>
              <input placeholder="Telefono" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="form.telefono">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-user form-control-feedback"></i>
              <input placeholder="Nombre" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="form.nombres">
            </div>
            <label style="text-align: left;margin-left: 10px;width:100%;" for="month">Cumpleaños:</label>
            <div id="month" style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;display: flex;">
              <div style="text-align: left;width:62%;padding-bottom: 10px;">
                <select id="month1" v-model="form.fecha_nacimiento_mes" @change="updateDays" class="izquierda">
                  <option v-for="(month, index) in months" :key="index" :value="month.value">{{ month.text }}</option>
                </select>
              </div>
              <div style="text-align: left;margin-left: 10px;width:30%;padding-bottom: 10px;">
                <select id="day" v-model="form.fecha_nacimiento_dia" class="izquierda">
                  <option v-for="(day, index) in daysInMonth" :key="index" :value="day">{{ day }}</option>
                </select>
              </div>
            </div>
          </div>
          <small v-show="validateformNewClient" style="color:red;">Por favor complete todos los campos.</small>
          <div style="width:100%;padding-bottom: 5px;">        
            <label style="font-size: 10px;font-weight: 350;margin-right: 10px;margin-left:10px;">Al dar click en Confirmar, aceptas nuestros <a v-bind:style="{color : color_botones, fontWeight: 500}" v-bind:href="'/terminos/'+company.name+'/'+company.id" target="_blank">Términos y condiciones</a> y las <a v-bind:style="{color : color_botones, fontWeight: 500}" v-bind:href="'/terminos/'+company.name+'/'+company.id" target="_blank">políticas de privacidad</a>.</label>
          </div>
          <div class="exit-options">
            <button @click="saveFormNewClient">Confirmar</button>
            <!--<button @click="formNewClientModal=false" >Cerrar</button>-->
          </div>
        </div>
      </div>
      <div class="order-out" v-show="exit_component_2">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>Gracias, tu pedido ha sido recibido.</h4>
          <div class="exit-options">
            <button @click="resetForm()" >Ok</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="exit_component_3">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong style="color: #218838">Exito: </strong>Gracias, tu pedido ha sido recibido.</h4>
          <h4><strong style="color: red;">Error: </strong>No se recibió confirmación de impresión.</h4>
          <div class="exit-options">
            <button @click="resetForm()" >Ok</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="confirmPrintModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>¿Esta seguro que desea confirmar la orden?</h4>
          <div class="exit-options">
            <button @click="printOrder()" >Ok</button>
            <button @click="confirmPrintModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editClientModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Datos del Cliente</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-user form-control-feedback"></i>
              <input placeholder="Nombre" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.name">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-hashtag form-control-feedback"></i>
              <input placeholder="Cedula" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.cedula">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-hashtag form-control-feedback"></i>
              <input placeholder="Nit" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.nit">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-mobile-alt form-control-feedback"></i>
              <input placeholder="Telefono" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.phone">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-home form-control-feedback"></i>
              <input placeholder="Direccion" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.address">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-home form-control-feedback"></i>
              <input placeholder="Barrio" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.Barrio">
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-envelope form-control-feedback"></i>
              <input placeholder="Email" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEditClient.email">
            </div>
          </div>
          <div class="exit-options">
            <button @click="updateDetailClient()" >Editar</button>
            <button @click="editClientModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editMeseroModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Mesero</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-user form-control-feedback"></i>
              <input placeholder="Mesero" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEdit.nombre_mesero">
            </div>
          </div>
          <div class="exit-options">
            <button @click="updateObservationOrder()" >Editar</button>
            <button @click="editMeseroModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editMesaModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Mesa</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <div v-show="mesas.length > 0 && (mesero || valida_mesa)" class="padre-puntos" style="text-align: left;margin-left: 10px;width:90%;padding-bottom: 10px;">
                <select class="select-icono" v-model="form.mesa" >
                  <option v-for="mesa in mesas" :key="mesa.number_table" :value="mesa.number_table"> Cambiar a la mesa {{ show_table_name ? mesa.name : mesa.number_table}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="exit-options">
            <button @click='updateTable()' >Editar</button>
            <button @click="editMesaModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editProductModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Cambiar producto de orden</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   

              <div v-show="mesas.length > 0 && (mesero || valida_mesa)" class="padre-puntos" style="text-align: left;margin-left: 10px;width:90%;padding-bottom: 10px;">
                <select class="select-icono" v-model="changeProduct.new_id_order" >
                  <option value="0" selected disabled>Seleccione la mesa</option>
                  <option v-for="mesa in mesas" :key="mesa.number_table" :value="mesa.number_table" :class="{ 'ocupada': esMesaOcupada(mesa.number_table) }">
                    Cambiar a la mesa {{ show_table_name ? mesa.name : mesa.number_table }} 
                    <span v-if="esMesaOcupada(mesa.number_table)" style="color: red;">- {{ obtenerNombreMesero(mesa.number_table) }}</span>
                  </option>

                </select>
              </div>

            </div>
          </div>
          <div class="exit-options">
            <button @click='validateChangeProductTable()' >Editar</button>
            <button @click="editProductModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="errorMesaModal">
        <div class="error-info">
          <i id="id_icons"></i>
          <h4><strong>ERROR</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;padding: 5px;width:100%;padding-bottom: 10px;">
              <h4 style="text-align: center;"><strong> {{ this.errorupdatetable }}</strong></h4>
            </div>
          </div>
          <div class="exit-options">
            <button @click="errorMesaModal=false" >Aceptar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="errorProductModal">
        <div class="error-info">
          <i id="id_icons"></i>
          <h4><strong>ERROR</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;padding: 5px;width:100%;padding-bottom: 10px;">
              <h4 style="text-align: center;"><strong> {{ this.errorupdateproduct }}</strong></h4>
            </div>
          </div>
          <div class="exit-options">
            <button @click="errorProductModal=false" >Aceptar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editObsModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Observaciones</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-align-justify form-control-feedback"></i>
              <input placeholder="Observaciones" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEdit.observacion">
            </div>
          </div>
          <div class="exit-options">
            <button @click="updateObservationOrder()" >Editar</button>
            <button @click="editObsModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editPayModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Forma de pago</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;padding-bottom: 10px;">                   
              <select class="select-icono" required="true" v-model="formEdit.id_type_forma_pago">        
                <option value="0" selected disabled>Seleccione una forma de pago</option>
                <option value="37" v-if="!kiosko && cash == true">Efectivo</option>
                <option value="38" v-if="!kiosko && transfer == true && !formPay.payOnline">Transferencia</option>
                <option value="169" v-if="formPay.payOnline && kiosko">Qr Bancolombia</option>
                <option value="39" v-if="dataphone == true && (!kiosko || kiosko_dataphone)"> Datáfono <span v-if="incremento_datafono > 0"> + ${{ incremento_datafono }} </span> </option>
                <option value="76" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago en Linea</option>
                <option value="141" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago Nequi</option>
                <option value="126" v-if="!kiosko && formPay.payOnline && payonlineaddress">Transf. Bancolombia</option>
                <option value="128" v-if="!kiosko && pay_epayco == true">Daviplata</option>
                <!--<option value="142" v-if="formPay.payOnline">Pago Tarjeta</option>
                <option value="143" v-if="formPay.payOnline">Pago Bancolombia</option>-->
              </select>
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-money form-control-feedback"></i>
              <input placeholder="0" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEdit.valor_forma_pago">
            </div>
          </div>
          <h4><strong>Segunda forma de pago</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;padding-bottom: 10px;">                   
              <select class="select-icono" required="true" v-model="formEdit.id_type_forma_pago_secundaria">        
                <option value="0" selected disabled>Seleccione una forma de pago</option>
                <option value="37" v-if="!kiosko && cash == true">Efectivo</option>
                <option value="38" v-if="!kiosko && transfer == true && !formPay.payOnline">Transferencia</option>
                <option value="169" v-if="formPay.payOnline && kiosko">Qr Bancolombia</option>
                <option value="39" v-if="dataphone == true && (!kiosko || kiosko_dataphone)"> Datáfono <span v-if="incremento_datafono > 0"> + ${{ incremento_datafono }} </span> </option>
                <option value="76" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago en Linea</option>
                <option value="141" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago Nequi</option>
                <option value="126" v-if="!kiosko && formPay.payOnline && payonlineaddress">Transf. Bancolombia</option>
        <option value="128" v-if="!kiosko && pay_epayco == true">Daviplata</option> 
                <!--<option value="142" v-if="formPay.payOnline">Pago Tarjeta</option>
                <option value="143" v-if="formPay.payOnline">Pago Bancolombia</option>-->
              </select>
            </div>
            <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-money form-control-feedback"></i>
              <input placeholder="0" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" disabled v-model="formEdit.valor_forma_pago_secundaria">
            </div>
          </div>
          <div class="exit-options">
            <button @click="updateObservationOrder()" >Editar</button>
            <button @click="editPayModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="editServiceModal">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4><strong>Servicio</strong></h4>
          <div id="datos-personales-edit" style="width: 100%">
            <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;padding-bottom: 10px;">                   
              <select class="select-icono" required="true" v-model="formEdit.type_service">        
                <option value="Valor">Valor</option>
                <option value="Porcentaje">Porcentaje</option>
              </select>
            </div>
            <div v-if="formEdit.type_service=='Valor'" style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-money form-control-feedback"></i>
              <input placeholder="0" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEdit.service">
            </div>
            <div v-if="formEdit.type_service=='Porcentaje'" style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">   
              <i class="fas fa-percent form-control-feedback"></i>
              <input placeholder="0" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="formEdit.percentage_service">
            </div>
          </div>
          <div class="exit-options">
            <button @click="updateObservationOrder()" >Editar</button>
            <button @click="editServiceModal=false" >Cancelar</button>
          </div>
        </div>
      </div>
      <div class="order-out" v-show="confirmPrintModalCash">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>Debe abrir la caja antes de confirmar la orden.</h4>
          <div class="exit-options">
            <button @click="confirmPrintModalCash=false" >Ok</button>
          </div>
        </div>
      </div>
     
       
       <!--- Fin Validacion-->   
      <div class="landscape-image" v-show="valida_stock">
        <div class="close-landscape">
        </div>
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>Al producto le falta stock.</h4>
          <div class="exit-options">
            <button @click="valida_stock = false" >Ok</button>
          </div>
        </div>
      </div>

      <!--- Fin Validacion-->   
      <div class="landscape-image" v-if="status_landscape">
        <div class="landscape-inner">
          <div class="close-landscape">
            <i class="fas fa-times" @click="status_landscape=false"></i>
          </div>
          <img :src="img_landscape" id="landscape_image">
        </div>
      </div>
      

      <div class="map-ubication-container" v-show="visible_map">
        <div class="map-container" id="map">
          
        </div>
        <div class="detail-direction">
            <div class="close-detail">
              <i class="fas fa-times" @click="closeMap()"></i>
            </div>
            <div class="input-complete">
              <h4>Ingrese la dirección</h4>
              <input type="text" placeholder="Ej: Parque cortijos, Valledupar" id="complete_direction">
            </div>
            <div class="separatore">
              <h4>- o -</h4>
            </div>
            <div class="actual-position-container" @click="SetcurrentPosition()">
              <div class="position-icon">
                <i class="fa fa-map-marker-alt"></i>
              </div>
              <div class="position-text">
                <h4>Ubicación actual</h4>
                <input type="text" name="" v-model="actual_ubication" disabled>
              </div>
              <div class="position-circle">
                <div class="circle">
                  <div class="esfere">
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="ubication-warning" v-if="out_zone">
              <span>Estás por fuera de las zonas de entrega</span>
            </div>
            <div class="ubication-warning" v-if="empty_map_fields">
              <span>Debe especificar una dirección</span>
            </div>
            <div class="button-direction-container">
              <button v-bind:style="{backgroundColor : color_botones}" @click="validatePosition()" id="id_btn_confirmar">Confirmar dirección</button>
            </div>
        </div>
      </div>

      <div class="map-ubication-container" v-show="visible_barrio">
        <div class="map-container">
          
        </div>
        <div class="detail-direction">
            <div class="input-complete">
              <h4>Ingrese la dirección</h4>
              <input type="text" placeholder="Ej: Parque cortijos, Valledupar" id="complete_direction" v-model="form.direccion">
            </div>
            <div class="input-complete">
              <h4>Barrio/Colonia</h4>
              <Select2 class="select-icono mi-selector selectBarrio" name="mi-selector" id="mi-selector" v-model="barrio_selected" :options="barrios_listado" style="width: 100%;background: #F1F3F4;color: #3A3A3A;font-size: 16px;padding: 14px 13px;border: none;border-radius: 7px;">
             </Select2>
             
            </div>
            <div class="ubication-warning" v-if="validacion_barrio">
              <span>Escoja una direccion</span>
            </div>
            <div class="ubication-warning" v-if="empty_map_fields">
              <span>Debe especificar una dirección</span>
            </div>
            <div class="button-direction-container">
              <button v-bind:style="{backgroundColor : color_botones}" @click="validarBarrio()" id="id_btn_confirmar">Confirmar dirección</button>
            </div>
        </div>
      </div>      

      <div class="container-horario" v-show="open_schedule">
        <div class="schedule-container">
          <div class="schedule-header">
            <div class="section-schedule">
              <div class="img-schedule-container">
                <img v-bind:alt="url_images" rel="preconnect" id="logo4">
              </div>
              <div class="header-info-name">
                <h4>{{companie_name}}</h4>
                <h5>Horarios de atención</h5>
              </div>
            </div>
            <div class="section-schedule-2">
              <i class="fas fa-times" @click="open_schedule = false" ></i><!--v-show="status_close_schedule"-->
            </div>  
          </div>
          <div class="schedule-content">
            <div class="single-schedule-day" v-for="(item,index) in schedule_list" :key="index" v-bind:id="'schedule_'+index">
              <div class="point-container">
                <i class="far fa-circle"></i>
              </div>
              <div class="schedule-information">
                <h4>{{ item.label }}</h4>
                <h5>{{ item.desde }} - {{ item.hasta }}</h5>
                <h5>{{ item.desde_pm }} - {{ item.hasta_pm }}</h5>
              </div>
              <div class="schedule-state">
                <h6 v-if="item.estado == false" class="schedule-danger">Cerrado</h6>
                <h6 v-else class="schedule-success">Abierto</h6>
              </div>
            </div>
          </div>
        </div>
      </div> 
    <add-new-data-sidebar 
          v-if="addNewDataSidebar" 
          @closeSidebar="addNewDataSidebar = $event"
          @addItemCart="
          carrito.push($event);
          addNewDataSidebar = false;
          getTotalProductos();
          getTotalItems();"
          :data="data, orderExistSelected"
          class="animation"
    ></add-new-data-sidebar>
    <ecommerce v-if="Ecommerce" :form="data"></ecommerce>
    <mensajeria v-if="status_message" :data="data_message"></mensajeria>
    <order-detail v-if="order_detail" :order="carrito"
    @closeOrderDetail="
        order_detail = $event
        validarCarrito()
      "
    ></order-detail>
    <loader-payment v-if="await_payment" :order="formOrder" :onFinish="finishLoaderPayment" />
    <loader-video v-if="loader_video" :mediaUrl="mediaUrl"  :onFinish="finishLoaderVideo" />
    <print-page v-if="print_page && license" :license="license" />
    <finish-order-nequi v-if="finishOrderNequi" :order_finish="carrito" :idTransactionOnline="idTransactionOnline"></finish-order-nequi>
    <LoginMain v-if="!loginStatus && mesero && activeLogin && !active_login_with_pin"></LoginMain>
    <LoginKeyboard v-if="mesero && active_login_with_pin && login_with_pin" :onFinish="finishSelectWaiterTable" ></LoginKeyboard>
    <TableWaiters v-if="popupActivoModeMesero && mesero" :onFinish="finishSelectWaiterTable" :idCompany="Number(id_company)" :idPoint="id_point_waiter"></TableWaiters>
    <finish-order-daviplata @ejecutarFuncion="enviarWhatsApp" v-if="finishOrderDaviplata" :order_finish="carrito" :idTransactionOnline="idTransactionOnline"></finish-order-daviplata>
    <finish-order v-if="finishOrder" :order_finish="carrito"></finish-order>
    <OrderTracking v-if="status_tracking"></OrderTracking>
    <DeliveryApp v-if="status_delivery" :delivery_data="info_delivery"></DeliveryApp>
    <DeliveryLogin v-if="status_delivery_login" @closeLogin="status_delivery_login = $event; status_delivery = true"></DeliveryLogin>
    <DeliveryCheckout v-if="status_delivery_checkout"></DeliveryCheckout>
    <OrderManagment v-if="status_managment" @closeMenu="status_seguimiento = $event" @closeManagment="status_managment = $event" @orderClone="searchProductClone($event)"></OrderManagment>
    <div id="content"  style="width: 100% !important;display: none" v-show="!addNewDataSidebar && !Ecommerce && !order_detail && !await_payment && !print_page && !status_message && close_store && !finishOrder && !mantenimiento && !status_tracking && !status_delivery && !status_managment && !status_delivery_login && !status_delivery_checkout && !finishOrderNequi && !finishOrderDaviplata && loginStatus">      

    <div id="pwa-ios-notify"  class="ios-notify abajo-izquierda" style="display: none !important;">    
        <h3 class="equis"><span aria-hidden="true" id="close" @click="Close()">&times;</span></h3>      
        <label class="info" id="info" >
        Para instalar esta Aplicación: <br>
        1. Presione el icono Compartir <img style="margin-top: -5px;" src="/share1.png"><br>
        2. De click en Agregar a inicio <i class="far fa-plus-square"></i> y luego agregar.<br>  
        </label>
    </div>
    <button type="button" @click.prevent="install" v-if="showInstallBanner && !delivery_app" style="font-size: 16px;;background-color: #1D8BFA;color: white;width: 100%;border: none;padding-top: 7px;font-weight: 500;"> + INSTALAR APP <br><label style="font-size: 14px;font-weight: 500;"><i class="fas fa-bullhorn" style="margin-right: 0.35rem;color:white;"></i>Promociones exclusivas (No te ocupa espacio).</label></button>
    <div class="back-delivery-button" v-if="delivery_app" @click="backDelivery()">
      <i class="fas fa-angle-left" v-bind:style="{color : color_botones}"></i>
      <h4 v-bind:style="{color : color_botones}">Volver</h4>
    </div>
    <div class="notify-schedule" @click="open_schedule = true" v-show="schedule_state && !banner_promo_status">
      <div class="esfere-container">
        <i class="fas fa-circle" v-show="schedule_closed"></i>
        <i class="fas fa-circle red" v-show="!schedule_closed"></i>
      </div>
      <h4 v-show="schedule_closed">Abierto</h4>
      <h4 v-show="!schedule_closed">Cerrado</h4>
    </div>
    <!--Mis pedidos opcion-->
      <div class="my-orders" v-show="!status_managment && seguimiento_pedido_wpp && !addNewDataSidebar && status_seguimiento" @click="status_managment = true">
        <h4><i v-bind:style="{color : color_botones}" class="fas fa-list"></i>Mis pedidos</h4>
      </div>
    <!---->
    <picture v-if="!banner_promo_status || portadas_promo.length == 0">
      <source rel="preconnect" v-bind:alt="url_images"  v-bind:srcset="portadas[1].includes('space') ? portadas[1] : url_images + portadas[1]" type="image/webp" class="portadas">
      <source rel="preconnect" v-bind:alt="url_images" v-bind:srcset="portadas[2].includes('space') ? portadas[2] : url_images + portadas[2]" type="image/jp2"  class="portadas">
      <img v-bind:alt="url_images" rel="preconnect" v-bind:src="portadas[0].includes('space') ? portadas[0] : url_images + portadas[0]"  class="portadas">     
    </picture> 

    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" v-show="banner_promo_status && portadas_promo.length > 0">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item" v-for="(item, index) in portadas_promo" :key="index" @click="getPromo(item)">
          <img class ="img-responsive" :src="url_images + item.imagenes">
          <button class="access-promo" v-if="item.id_product || item.id_product != 0" v-bind:style="{color : color_botones }" @click="getPromo(item)"><i class="fas fa-shopping-cart"></i>Agregar</button>
          <div class="notify-schedule" @click="open_schedule = true" v-show="schedule_state && banner_promo_status && portadas_promo.length > 0">
            <div class="esfere-container">
              <i class="fas fa-circle" v-show="schedule_closed"></i>
              <i class="fas fa-circle red-schedule" v-show="!schedule_closed"></i>
            </div>
            <h4 v-show="schedule_closed">Abierto</h4>
            <h4 v-show="!schedule_closed">Cerrado</h4>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>


    <div style="margin-top: -45px;width: 50% !important;margin-left: -60px !important;"> 
        <br>
    </div>
    <br>
    <div class="container-logo" style="display: flex;background-color:#fff;">             
        <div style="margin-top: 20px;width: 60% !important;margin-bottom: 15px;" class="div-titulo"> 
            <label id="titulo">{{companie_name}}</label>     
        </div>      
        <div style="text-align: center;width: 40% !important;margin-top: -50px; z-index: 999;">
          <div style="display: inline-block;box-shadow: 2px 1px 10px 0px rgba(130,130,130,1);border-radius: 50%;overflow: hidden;padding: 15px;background-color: white;">
              <picture>
                  <source rel="preconnect" v-bind:alt="url_images" type="image/webp" class="logos" id="logo1">
                  <source rel="preconnect" v-bind:alt="url_images" type="image/jp2" class="logos" id="logo2">
                  <img rel="preconnect"  style="height: 110px; width: 100px; margin-left:3px;border-radius: 50%;" class="logos" id="logo0">
              </picture>              
          </div>               
        </div>
    </div>
    <div style="text-align: left;padding-left: 10px;margin-top: -10px;background-color:#fff;">    
    <div id="detalle_company">
      <label style="text-align: left;font-size: 14px; margin-right: 10px;" id="direccion"><i class="fa fa-map-marker-alt" style="margin-right: 0.30rem;"></i> {{ direccion }}  </label> 
      <label style="text-align: left;font-size: 14px;" id="horario" v-show="!schedule_state"><i class="far fa-clock" style="margin-right: 0.30rem;" ></i>{{ horario }}</label>
      <!--ACTUALIZACION MESERO-->
      <div v-if="mesero" style="display: flex; align-items: center;">
        <label style="text-align: left;font-size: 14px;" id="mesas"><i class="fas fa-table" style="margin-right: 0.30rem;" ></i>Mesas: </label>
        <select @change="getOrderDetail(mesaMesero.id_order)" style="width:40%; margin-left: 0.5rem;" class="select-icono" v-model="mesaMesero">
          <option value="0" selected>Menú...</option>
          <template v-if="!view_other_tables">
            <option v-for="mesa in ordersTables" :key="mesa.number_table" :value="mesa">
              {{ show_table_name ? mesa.name_table : 'Mesa ' + mesa.number_table }}
              <span v-if="mesa.creacion" style="font-size:11px;color:#0B9BCF;font-weight:bold;">
                🕒 {{ mesaTimers[mesa.number_table] || '00:00' }}
              </span>
            </option>
          </template>
          <template v-else>
            <option v-for="mesa in ordersTables" :key="mesa.number_table" :value="mesa">
              {{ (show_table_name ? mesa.name_table : 'Mesa ' + mesa.number_table) + ' - ' + mesa.nombre_mesero }}
              <span v-if="mesa.creacion" style="font-size:11px;color:#0B9BCF;font-weight:bold;">
                🕒 {{ mesaTimers[mesa.number_table] || '00:00' }}
              </span>
            </option>
          </template>
        </select>
      </div>
    </div>         
    </div>
    
    <div v-if="mesaMesero==0" id="menu">   
      <!--<div style="text-align: left;width:100%;background-color: #fff;">
        <i class="fas fa-search form-control-feedback-search"></i>
        <input type="text" style="width:100%; margin-bottom:5px;" id="buscar" v-model="texto" @keyup="search()" class="form-control izquierda" placeholder="Buscar..." autocomplete="off">
      </div>-->
      <div class="search-content">
        <div class="detail-cupon">
          <div class="check-image" v-bind:style="{backgroundColor : color_botones}">
              <i class="fas fa-search"></i>
          </div>
          <div class="input-cupon">
              <input type="text" placeholder="Buscar...." id="buscar"  v-model="texto" @keyup="search()" autocomplete="off">
          </div>
        </div>
      </div>   
      
      <!--VIEW KIOSKO-->
      <div class="kiosko-view" v-show="kiosko">
        <div class="categorys-desktop" v-show="style1">
          <div 
            class="category-name" 
            v-for="(category) in categories" 
            :key="category.id_category" 
            v-show="category.products.length > 0" 
            @click="sectionCategory(category)" 
          >
            <div 
              class="category-image" 
              :class="{ active: categorySelected && categorySelected.id_category === category.id_category }"
            >
              <img 
                :src="category.imagen.includes('images/image-alt.jpg') 
                        ? logo_company
                        : category.imagen" 
                :alt="category.name" 
              />
            </div>
            <button>{{ category.name }}</button>
          </div>    
        </div>
        
        <div class="section-products-desktop" id="kiosko_products">
          <div
            class="store-container"
            v-if="categorySelected"
            :id="'category_' + categorySelected.id_category"
          >
            <div class="products-store-container-new">
              <div
                class="single-product-view-new"
                v-bind:id="'card_' + product.id"
                v-for="(product, index) in categorySelected.products"
                :key="product.id"
                @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale, product.status_variants, product.variantes, product.variantes_detail, product.variantes_combinations, product.status_addition, product.addition, product.addition_detail, product.address_included, product.stock, index)"
              >
                <div class="single-product-image-container-new">
                  <img
                    v-bind:alt="product.name"
                    rel="preconnect"
                    v-lazyload
                    :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images + '/' + product.galery_images[0]"
                  />
                </div>
                <div class="single-product-info-new">
                  <h4>{{ product.name }}</h4>
                  <p>{{ product.description }}</p>
                  <div style="display: none;" v-bind:id="'div_cantidades2_'+product.id">
                    <div class="cantidades-wrapper">
                      <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones, width : '25px', height : '25px' }">
                        <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                      </div>
                      <label v-bind:id="'product2_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 25px;">1</label>
                      <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones, width : '25px', height : '25px' }">
                        <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="single-product-price-options-new">
                  <h4>${{ formatPrice(product.value_sale) }}</h4>
                  <div
                    class="variants-option"
                    v-bind:style="{ backgroundColor: color_botones }"
                    v-if="product.status_variants || product.status_addition"
                  >
                    <i class="fas fa-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!--END VIEW KIOSKO-->

      <div class="desktop-view" v-show="desktop_main_view">
        <div class="categorys-desktop" v-show="style1">
          <div class="category-name" v-for="category in categories" v-bind:key="category.id_category" v-show="category.products.length > 0">
            <button v-bind:style="{backgroundColor : color_botones }" @click="section(category.id_category)">{{ category.name }}</button>
          </div>
        </div>
        <div class="second-condition" v-show="style2">
          <div class="categorys-desktop-2">
            <div class="category-name" v-for="category in primer_array" v-bind:key="category.id_category" v-show="category.products.length > 0">
              <button v-bind:style="{backgroundColor : color_botones }" @click="section(category.id_category)">{{ category.name }}</button>
            </div>
          </div>
          <div class="select-restante">
            <select @change="section(category_desktop)" v-model="category_desktop">
              <option value="0" selected disabled>Ver más</option>
              <option v-for="category in segundo_array" :key="category.id_category" :value="category.id_category" v-show="category.products.length > 0">{{ category.name }}</option>
            </select>
          </div>
        </div>
        <div class="section-products-desktop">
          <div class="store-container" v-for="(category) in categories" v-bind:id="'category_'+category.id_category" v-bind:key="category.id_category" v-show="category.products.length > 0">
            <div class="category-title">
              <h4>{{ category.name }}</h4>
            </div>
            <div class="products-store-container">
              <div class="single-product-view" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
                <div class="single-product-image-container">
                  <img v-bind:alt="product.name" rel="preconnect" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]">
                </div>
                <div class="single-product-info">
                  <h4>{{product.name}}</h4>
                  <p>{{product.description}}</p>
                </div>
                <div class="single-product-price-options">
                  <h4>${{formatPrice(product.value_sale)}}</h4>
                  <div class="variants-option" v-bind:style="{backgroundColor : color_botones}" v-if="product.status_variants || product.status_addition">
                    <i class="fas fa-plus"></i>
                  </div>
                  <div style="display: none;" v-bind:id="'div_cantidades2_'+product.id">
                    <div class="cantidades-wrapper">
                      <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                      </div>
                      <label v-bind:id="'product2_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 16px;">1</label>
                      <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 


      <div class="mobile-view" v-show="view_mobile">
        
        <div class="categorys-desktop-mobile">
          <div class="category-name-mobile" v-for="category in categories" v-bind:key="category.id_category" v-show="category.products.length > 0">
            <button v-bind:style="{backgroundColor : color_botones }" @click="sectionMobile(category.id_category)">{{ category.name }}</button>
          </div>
        </div>

        <div class="section-products-mobile">
          <div class="store-container-mobile" v-for="(category) in categories" v-bind:id="'category2_'+category.id_category" v-bind:key="category.id_category" v-show="category.products.length > 0">
            <div class="category-title-mobile">
              <h4>{{ category.name }}</h4>
            </div>
            <div class="products-store-container-mobile">
              <div class="single-product-view-mobile" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
                <div class="single-product-image-container-mobile">
                  <img v-bind:alt="product.name" rel="preconnect" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]">
                </div>
                <div class="single-product-info-mobile">
                  <h4>{{product.name}}</h4>
                  <p>{{product.description}}</p>
                </div>
                <div class="single-product-price-options-mobile">
                  <h4>${{formatPrice(product.value_sale)}}</h4>
                  <div class="variants-option" v-bind:style="{backgroundColor : color_botones}" v-if="product.status_variants || product.status_addition">
                    <i class="fas fa-plus"></i>
                  </div>
                  <div style="display: none;" v-bind:id="'div_cantidades3_'+product.id">
                    <div class="cantidades-wrapper">
                      <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                      </div>
                      <label v-bind:id="'product3_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 16px;">1</label>
                      <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-desktop-view">
        <div class="products-store-container">
          <div class="single-product-view" v-bind:id="'card_'+product.id"  v-for="(product) in product_list_aux" v-bind:key="product.id"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
            <div class="single-product-image-container">
              <img v-bind:alt="product.name" rel="preconnect" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]">
            </div>
            <div class="single-product-info">
              <h4>{{product.name}}</h4>
              <p>{{product.description}}</p>
            </div>
            <div class="single-product-price-options">
              <h4>${{formatPrice(product.value_sale)}}</h4>
              <div class="variants-option" v-bind:style="{backgroundColor : color_botones}" v-if="product.status_variants || product.status_addition">
                <i class="fas fa-plus"></i>
              </div>
              <div style="display: none;" v-bind:id="'div_cantidades2_'+product.id">
                <div class="cantidades-wrapper">
                  <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones}">
                    <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                  </div>
                  <label v-bind:id="'product2_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 16px;">1</label>
                  <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones}">
                    <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-mobile-view">
        <div class="products-store-container-mobile">
          <div class="single-product-view-mobile" v-bind:id="'card_'+product.id"  v-for="(product) in product_list_aux" v-bind:key="product.id"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
            <div class="single-product-image-container-mobile">
              <img v-bind:alt="product.name" rel="preconnect" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]">
            </div>
            <div class="single-product-info-mobile">
              <h4>{{product.name}}</h4>
              <p>{{product.description}}</p>
            </div>
            <div class="single-product-price-options-mobile">
              <h4>${{formatPrice(product.value_sale)}}</h4>
              <div class="variants-option" v-bind:style="{backgroundColor : color_botones}" v-if="product.status_variants || product.status_addition">
                <i class="fas fa-plus"></i>
              </div>
              <div style="display: none;" v-bind:id="'div_cantidades3_'+product.id">
                <div class="cantidades-wrapper">
                  <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones}">
                    <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                  </div>
                  <label v-bind:id="'product3_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 16px;">1</label>
                  <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones}">
                    <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loader-categories" v-show="categoriesDone">
          <!--<div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>-->
          <div id="main_loader"></div>
          <h4>Cargando categorías...</h4>
      </div>
      <!--Accordion wrapper-->

      <div  v-show="show_category_kiosko">
        <div class="categorys-desktop" v-show="style1">
          <div 
            class="category-name" 
            v-for="(category) in categories" 
            :key="category.id_category" 
            v-show="category.products.length > 0" 
            @click="sectionCategory(category)" 
          >
            <div 
              class="category-image" 
              :class="{ active: categorySelected && categorySelected.id_category === category.id_category }"
            >
              <img 
                :src="category.imagen.includes('images/image-alt.jpg') 
                        ? logo_company
                        : category.imagen" 
                :alt="category.name" 
              />
            </div>
            <button>{{ category.name }}</button>
          </div>    
        </div>
        
        <div class="section-products-desktop" id="kiosko_products">
          <div
            class="store-container"
            v-if="categorySelected"
            :id="'category_' + categorySelected.id_category"
          >
            <div class="products-store-container-new">
              <div
                class="single-product-view-new"
                v-bind:id="'card_' + product.id"
                v-for="(product, index) in categorySelected.products"
                :key="product.id"
                @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale, product.status_variants, product.variantes, product.variantes_detail, product.variantes_combinations, product.status_addition, product.addition, product.addition_detail, product.address_included, product.stock, index)"
              >
                <div class="single-product-image-container-new">
                  <img
                    v-bind:alt="product.name"
                    rel="preconnect"
                    v-lazyload
                    :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images + '/' + product.galery_images[0]"
                  />
                </div>
                <div class="single-product-info-new">
                  <h4>{{ product.name }}</h4>
                  <p>{{ product.description }}</p>
                  <div style="display: none;" v-bind:id="'div_cantidades2_'+product.id">
                    <div class="cantidades-wrapper">
                      <div class="minus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-minus" @click="restarCantidadDesktop(product.id)"></i>
                      </div>
                      <label v-bind:id="'product2_'+product.id" style="margin-bottom: 0;margin-left: 7px;margin-right: 7px;font-size: 16px;">1</label>
                      <div class="plus-quantity" v-bind:style="{backgroundColor : color_botones}">
                        <i class="fas fa-plus" @click="sumarCantidad(product.id)"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="single-product-price-options-new">
                  <h4>${{ formatPrice(product.value_sale) }}</h4>
                  <div
                    class="variants-option"
                    v-bind:style="{ backgroundColor: color_botones }"
                    v-if="product.status_variants || product.status_addition"
                  >
                    <i class="fas fa-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      

    <div v-for="(category,index) in categories" class="accordion accordion-flush" v-bind:id="'accordionEx_'+category.id_category" role="tablist" aria-multiselectable="true" v-bind:key="category.id_category" v-show="!desktop_main_view && !kiosko && !show_category_kiosko ">      
        <!-- Accordion card -->
        
      <div class="card" v-if="category.products.length > 0">
          <!-- Card header -->
          <div class="card-header" style="/*opacity:0.7*/" role="tab" v-bind:id="'headingTwo'+category.id_category" v-bind:style="{backgroundColor : color_botones }" v-if="category.products.length > 0 && company.type != 27">
            <a class="collapsed" style="color:#ffffff;" data-toggle="collapse" v-bind:data-parent="'#accordionEx_'+category.id_category" v-bind:href="'#collapseTwo'+category.id_category"
              aria-expanded="false" aria-controls="collapseTwo1" @click="apiConversionP(/*category.id_category, index*/)">
              <h5 class="mb-0">
                {{ category.name }} <i class="fas fa-angle-down"></i>
              </h5>
            </a>
          </div>

        <div v-if="company.type == 26 || company.type == 40 || company.type == 72">
        <!-- Card body -->
        <div class="container-categorys-default" v-if="!default_categorys">
          <div v-bind:id="'collapseTwo'+category.id_category" class="collapse show" role="tabpanel"
            v-bind:data-parent="'#accordionEx_'+category.id_category" v-if="index == 0" >
            <div class="card-body">
              <div class="card-padre" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id">   
                <table style="width:100%; cursor: pointer;" class="products">
                    <tr>
                        <td style="width: 15%;"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
                          
                          <img v-bind:alt="product.name" rel="preconnect"  style="height: 110px; width: 100px; margin-left:3px;border-radius: 10px;" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)">   
                          <div class="inventory" v-if="product.sale_off">
                              <h4>agotado</h4>
                          </div>
                          <div class="land-scape-eye" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"> <!-- v-show="!product.status_addition && !product.status_variants"-->
                            <i class="fas fa-search" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"></i>
                          </div>
                        </td> 
                        <td style="padding-left: 10px;width: 85%" @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)">                                                 
                              <div >
                                <label style="margin-bottom : 0 !important;"><b>{{product.name}}</b></label>
                                <p class="description text-justify" style="margin-right:3px;">{{product.description}}</p>                             
                              </div>
                              <div class="stock-actual" v-if="inventory_day">
                                <p class="description">Unidades disponibles: {{ product.stock_sumatory < 1 ? 0 : product.stock_sumatory}}</p>
                              </div>                           
                              <div style="display: flex; justify-content:flex-start; flex-wrap:wrap;">
                                <p @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" class="price" v-bind:style="{color: color_botones, fontWeight: 700}" style="margin-right: 10px; margin-bottom: 5px;"><span v-show="old_price_status && product.old_price > 0" class="old-price">$ {{formatPrice(product.old_price)}} -</span> $ {{formatPrice(product.value_sale)}}</p>
                                <div class="input-group mb-6 mr-sm-6"  style="width:65%;margin-top: -15px;display:none;padding-left: 13px;" v-bind:id="'div_cantidades_'+product.id">
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="restarCantidad(product.id)" class="fas fa-minus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>
                                  <label style="text-align:center;width: 39% !important;margin-top:10px;padding-right: 5px;padding-left: 5px;font-size: 18px;font-weight: 500;" v-bind:id="'product_'+product.id">1</label>
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="sumarCantidad(product.id)" class="fas fa-plus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>        
                                </div>
                              </div>
                              <div style="text-align: right;">
                                  
                              </div>
                          </td>
                    </tr>          
                </table>          
                <center>            
                </center>
              </div>        
            </div>
          </div>
          <div v-bind:id="'collapseTwo'+category.id_category" class="collapse" role="tabpanel"
            v-bind:data-parent="'#accordionEx_'+category.id_category" v-else>
            <div class="card-body">
              <div class="card-padre" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id">   
                <table style="width:100%;padding-top: -20px;cursor: pointer;" class="products" >
                    <tr>
                        <td style="width: 15%;">
                          
                          <img  v-bind:alt="product.name" v-lazyload rel="preconnect" style="height: 110px; width: 100px; margin-left:3px;border-radius: 10px;" :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)">   
                          <div class="inventory" v-if="product.sale_off">
                              <h4>agotado</h4>
                          </div>
                          <div class="land-scape-eye" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)" > <!-- v-show="!product.status_addition && !product.status_variants"-->
                            <i class="fas fa-search" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"></i>
                          </div>
                        </td> 
                        <td style="padding-left: 10px;width: 85%" @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)">                                                 
                              <div >
                                <label style="margin-bottom : 0 !important;"><b>{{product.name}}</b></label>
                                <p class="description text-justify" style="margin-right:3px;">{{product.description}}</p>
                              </div>
                              <div class="stock-actual" v-if="inventory_day">
                                <p class="description">Unidades disponibles: {{ product.stock_sumatory }}</p>
                              </div>                           
                              <div style="display: flex; justify-content:flex-start; flex-wrap:wrap;">
                                <p @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" class="price" v-bind:style="{color: color_botones, fontWeight: 700}" style="margin-right: 10px; margin-bottom: 5px;"><span v-show="old_price_status && product.old_price > 0" class="old-price">$ {{formatPrice(product.old_price)}} -</span> $ {{formatPrice(product.value_sale)}}</p>
                                <div class="input-group mb-6 mr-sm-6"  style="width:65%;margin-top: -15px;display:none;padding-left: 13px;" v-bind:id="'div_cantidades_'+product.id">
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="restarCantidad(product.id)" class="fas fa-minus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>
                                  <label style="text-align:center;width: 39% !important;margin-top:10px;padding-right: 5px;padding-left: 5px;font-size: 18px;font-weight: 500;" v-bind:id="'product_'+product.id">1</label>
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="sumarCantidad(product.id)" class="fas fa-plus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>        
                                </div>
                              </div>
                          </td>
                    </tr>              
                </table>          
                <center>            
                </center>
              </div>        
            </div>
          </div>
        </div>
        <div class="default-categorys-container-new" v-if="default_categorys">
          <div v-bind:id="'collapseTwo'+category.id_category" class="collapse" role="tabpanel"
            v-bind:data-parent="'#accordionEx_'+category.id_category" v-if="index == 0" >
            <div class="card-body">
              <div class="card-padre" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id">   
                <table style="width:100%; cursor: pointer;" class="products">
                    <tr>
                        <td style="width: 15%;"> <!-- @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" -->
                          
                          <img v-bind:alt="product.name" rel="preconnect"  style="height: 110px; width: 100px; margin-left:3px;border-radius: 10px;" v-lazyload :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)">   
                          <div class="inventory" v-if="product.sale_off">
                              <h4>agotado</h4>
                          </div>
                          <div class="land-scape-eye" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"> <!-- v-show="!product.status_addition && !product.status_variants"-->
                            <i class="fas fa-search" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"></i>
                          </div>
                        </td> 
                        <td style="padding-left: 10px;width: 85%" @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)">                                                 
                              <div >
                                <label style="margin-bottom : 0 !important;"><b>{{product.name}}</b></label>
                                <p class="description text-justify" style="margin-right:3px;">{{product.description}}</p>                             
                              </div>
                              <div class="stock-actual" v-if="inventory_day">
                                <p class="description">Unidades disponibles: {{ product.stock_sumatory < 1 ? 0 : product.stock_sumatory}}</p>
                              </div>                           
                              <div style="display: flex; justify-content:flex-start; flex-wrap:wrap;">
                                <p @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" class="price" v-bind:style="{color: color_botones, fontWeight: 700}" style="margin-right: 15px; margin-bottom: 10px;"><span v-show="old_price_status && product.old_price > 0" class="old-price">$ {{formatPrice(product.old_price)}} - </span>$ {{formatPrice(product.value_sale)}}</p>
                                <div class="input-group mb-6 mr-sm-6"  style="width:65%;margin-top: -10px;display:none;" v-bind:id="'div_cantidades_'+product.id">
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="restarCantidad(product.id)" class="fas fa-minus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>
                                  <label style="text-align:center;width: 39% !important;margin-top:10px;padding-right: 5px;padding-left: 5px;font-size: 18px;font-weight: 500;" v-bind:id="'product_'+product.id">1</label>
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="sumarCantidad(product.id)" class="fas fa-plus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>        
                                </div>
                              </div>
                              <div style="text-align: right;">
                                  
                              </div>
                          </td>
                    </tr>          
                </table>          
                <center>            
                </center>
              </div>        
            </div>
          </div>
          <div v-bind:id="'collapseTwo'+category.id_category" class="collapse" role="tabpanel"
            v-bind:data-parent="'#accordionEx_'+category.id_category" v-else>
            <div class="card-body">
              <div class="card-padre" v-bind:id="'card_'+product.id"  v-for="product in category.products" v-bind:key="product.id">   
                <table style="width:100%;padding-top: -20px;cursor: pointer;" class="products" >
                    <tr>
                        <td style="width: 15%;">
                          
                          <img  v-bind:alt="product.name" v-lazyload rel="preconnect" style="height: 110px; width: 100px; margin-left:3px;border-radius: 10px;" :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)">   
                          <div class="inventory" v-if="product.sale_off">
                              <h4>agotado</h4>
                          </div>
                          <div class="land-scape-eye" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"> <!-- v-show="!product.status_addition && !product.status_variants"-->
                            <i class="fas fa-search" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"></i>
                          </div>
                        </td> 
                        <td style="padding-left: 10px;width: 85%" @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)">                                                 
                              <div >
                                <label style="margin-bottom : 0 !important;"><b>{{product.name}}</b></label>
                                <p class="description text-justify" style="margin-right:3px;">{{product.description}}</p>
                              </div>
                              <div class="stock-actual" v-if="inventory_day">
                                <p class="description">Unidades disponibles: {{ product.stock_sumatory }}</p>
                              </div>                           
                              <div style="display: flex; justify-content:flex-start; flex-wrap:wrap;">
                                <p @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" class="price" v-bind:style="{color: color_botones, fontWeight: 700}" style="margin-right: 10px; margin-bottom: 5px;"><span v-show="old_price_status && product.old_price > 0" class="old-price">$ {{formatPrice(product.old_price)}} - </span>$ {{formatPrice(product.value_sale)}}</p>
                                <div class="input-group mb-6 mr-sm-6"  style="width:65%;margin-top: -10px;display:none;padding-left: 13px;" v-bind:id="'div_cantidades_'+product.id">
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="restarCantidad(product.id)" class="fas fa-minus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>
                                  <label style="text-align:center;width: 39% !important;margin-top:10px;padding-right: 5px;padding-left: 5px;font-size: 18px;font-weight: 500;" v-bind:id="'product_'+product.id">1</label>
                                  <div class="input-group-prepend" style="align-items: center;">
                                    <i @click="sumarCantidad(product.id)" class="fas fa-plus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                                  </div>        
                                </div>
                              </div>
                              <div style="text-align: right;">
                                  
                              </div>
                          </td>
                    </tr>              
                </table>          
                <center>            
                </center>
              </div>        
            </div>
          </div>
        </div>
      </div><!-- fin if company tipo restaurante[26]-->
      </div>
    </div><!-- fin div categorias-->


      <div v-show="filter_option" class="filter-default-categorys">
        <div class="card-body">
          <div class="card-padre" v-bind:id="'card_'+product.id"  v-for="(product,index) in product_list_aux" v-bind:key="product.id">   
            <table style="width:100%;padding-top: -20px;cursor: pointer;" class="products" >
                <tr>
                    <td style="width: 15%;">
                      
                      <img  v-bind:alt="product.name" v-lazyload rel="preconnect" style="height: 110px; width: 100px; margin-left:3px;border-radius: 10px;" :data-src="product.galery_images[0].includes('space') ? product.galery_images[0] : url_images +'/'+ product.galery_images[0]" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)">   
                      <div class="inventory" v-if="product.sale_off">
                          <h4>agotado</h4>
                      </div>
                      <div class="land-scape-eye" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"> <!-- v-show="!product.status_addition && !product.status_variants"-->
                        <i class="fas fa-search" @click="showAlert(product.galery_images,product.addition,product.variantes_combinations)"></i>
                      </div>
                    </td> 
                    <td style="padding-left: 10px;width: 85%" @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)">                                                 
                          <div >
                            <label style="margin-bottom : 0 !important;"><b>{{product.name}}</b></label>
                            <p class="description text-justify" style="margin-right:3px;">{{product.description}}</p>
                          </div>
                          <div class="stock-actual" v-if="inventory_day">
                            <p class="description">Unidades disponibles: {{ product.stock_sumatory }}</p>
                          </div>                           
                          <div style="display: flex; justify-content:flex-start; flex-wrap:wrap;">
                            <p @click="agregarProductoCarrito(product.id, product.name, product.description, product.value_sale,product.status_variants,product.variantes,product.variantes_detail,product.variantes_combinations,product.status_addition,product.addition,product.addition_detail,product.address_included,product.stock,index/*,product.validacion_stock*/)" class="price" v-bind:style="{color: color_botones, fontWeight: 700}" style="margin-right: 10px; margin-bottom: 5px;"><span v-show="old_price_status && product.old_price > 0" class="old-price">$ {{formatPrice(product.old_price)}} - </span>$ {{formatPrice(product.value_sale)}}</p>
                            <div class="input-group mb-6 mr-sm-6"  style="width:65%;margin-top: -10px;display:none;padding-left: 13px;" v-bind:id="'div_cantidades_'+product.id">
                              <div class="input-group-prepend" style="align-items: center;">
                                <i @click="restarCantidad(product.id)" class="fas fa-minus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                              </div>
                              <label style="text-align:center;width: 39% !important;margin-top:10px;padding-right: 5px;padding-left: 5px;font-size: 18px;font-weight: 500;" v-bind:id="'product_'+product.id">1</label>
                              <div class="input-group-prepend" style="align-items: center;">
                                <i @click="sumarCantidad(product.id)" class="fas fa-plus-circle" v-bind:style="{color : color_botones, fontSize: '30px'}"></i>   
                              </div>        
                            </div>
                          </div>
                          <div style="text-align: right;">
                              
                          </div>
                      </td>
                </tr>              
            </table>          
            <center>            
            </center>
          </div>        
        </div>
      </div>
      <br><br><br>
      <div id="footer" class="" v-if="this.carrito.length > 0">
        <button class="btn-footer" @click="verPedido()" v-bind:class="{ 'btn-kiosko': kiosko }"  v-bind:style="{backgroundColor : color_botones}" style="text-align: center !important;" >
          <label style="width: 30% !important;text-align: left !important;">{{items}}</label><label style="width: 30% !important;text-align: center !important;">Ver Orden</label><label style="width: 30% !important;text-align: right !important;" >$ {{ formatPrice(total_productos)}}</label>
        </button>
      </div>
    </div> <!-- End menu -->
    <div v-else>
      <div class="loader-categories" v-if="categoriesDone">
        <!--<div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>-->
        <div id="main_loader"></div>
        <h4>Cargando Orden...</h4>
      </div>
      <div v-else>
        <!-- BOTONES OPCIONES DE MESERO-->
        <div style="display: flex; align-items: center; padding: 5px;" v-if="print_waiter_bill">
          <div id="btn_agregar" class="shop-product" :style="{ backgroundColor: botones}" @click="accountPrint(formOrder)" >
            <h5><strong>Imprimir Cuenta</strong></h5>
          </div>
          <!--<div id="btn_agregar" class="shop-product" :style="{ backgroundColor: botones}" @click="confirmPrint(formOrder)" >
            <h5><strong>Confirmar</strong></h5>
          </div>
          <div id="btn_agregar" class="shop-product" :style="{ backgroundColor: botones}" @click="PrintCommand(formOrder,true,false)" >
            <h5><i class="fas fa-print"></i><strong> Cocina</strong></h5>
          </div>
          <div id="btn_agregar" class="shop-product" :style="{ backgroundColor: botones}" @click="PrintCommand(formOrder,false,true)" >
            <h5><i class="fas fa-print"></i><strong> Bar</strong></h5>
          </div>-->
        </div>
        
        <table style="margin: 10px 10px 20px 10px;">
          <tr>
            <td style="width: 40%;text-align: left;"><strong>Cliente: </strong></td>
            <td style="width: 70%;text-align: left;" v-bind:style="{color : color_letra}"> {{ formOrder.client.name }}</td>
            <td><i v-if="edit_tables_waiter" @click="editClient()" v-bind:style="{color : color_botones}" class="fas fa-edit"></i></td>
          </tr>
          <tr>
            <td style="width: 40%;text-align: left;"><strong>Mesero: </strong></td>
            <td style="width: 70%;text-align: left;" v-bind:style="{color : color_letra}"> {{ formOrder.nombre_mesero }}</td>
            <td><!--<i @click="editMeseroModal=true" v-bind:style="{color : color_botones}" class="fas fa-edit"></i>--></td>
          </tr>
          <tr>
            <td style="width: 40%;text-align: left;"><strong>Mesa: </strong></td>
            <td style="width: 70%;text-align: left;" v-bind:style="{color : color_letra}"> {{ show_table_name ? formOrder.name_table : 'Mesa ' + formOrder.id_table }} </td>
            <td><i v-if="change_table_waiter" @click="openEditMesaModal()" v-bind:style="{color : color_botones}" class="fas fa-edit"></i></td>
          </tr>
          <tr>
            <td style="width: 40%;text-align: left;"><strong>Forma de pago: </strong></td>
            <td style="width: 70%;text-align: left;" v-bind:style="{color : color_letra}"><label style="margin:0"> {{ formOrder.type_forma_pago }}</label><label  style="margin:0" v-if="formOrder.type_forma_pago_secundaria">-{{formOrder.type_forma_pago_secundaria}}</label></td>
            <td><i v-if="edit_tables_waiter" @click="editPayModal=true" v-bind:style="{color : color_botones}" class="fas fa-edit"></i></td>
          </tr>
          <tr>
            <td style="width: 40%;text-align: left;"><strong>Observaciones: </strong></td>
            <td style="width: 70%;text-align: left;" v-bind:style="{color : color_letra}"> {{ formOrder.commentary }}</td>
            <td><i @click="editObsModal=true" v-bind:style="{color : color_botones}" class="fas fa-edit"></i></td>
          </tr>
        </table>
        <h5 style="text-align: left;margin-left: 10px;">Detalle de la Orden</h5>
        <table table style="width:95%;margin-left: 10px;">
          <tr v-for="(item) in formOrder.details" id="detalle-pedido" v-bind:key="item.index">        
            <td style="width: 70%;text-align: left;cursor: pointer;" v-if="item.nombre_mesero != null">{{ item.quantity }} x {{ item.name_product }} - {{ item.nombre_mesero }}&nbsp;&nbsp;&nbsp;{{ item.observations ? " (Obs: "+item.observations+") " : "" }}</td>
            <td style="width: 70%;text-align: left;cursor: pointer;" v-else>{{ item.quantity }} x {{ item.name_product }}&nbsp;&nbsp;&nbsp;{{ item.observations ? " (Obs: "+item.observations+") " : "" }}</td>
            <td style="width: auto;text-align: right;">
              <i v-if="!botonDeshabilitado && delete_product_waiter" @click="DeleteorUpdate(item)" v-bind:style="{color : color_botones}" class="fas fa-trash-alt"></i>
            </td>
            <td style="width: auto;text-align: right;">
              <i @click="modalEditProductActive(item)" v-bind:style="{color : color_botones}" class="fas fa-edit"></i>
            </td>

            <td v-if="company.type == 72 /*Carniceria*/" style="width: 10%;text-align: right;"></td>
            <td v-else style="width: 30%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ item.total }}</td>
            
          </tr><br>
          <tr v-if="formOrder.service">
            <td style="width: auto;text-align: right;"><i v-if="edit_tables_waiter" @click="editServiceModal=true" v-bind:style="{color : color_botones}" class="fas fa-edit"></i></td>
            <td style="width: auto;text-align: right;">Servicio</td>
            <td style="width: 40%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formatPrice(formOrder.service) }}</td>
          </tr>
          <tr v-if="formOrder.total_discount">
            <td></td>
            <td style="width: auto;text-align: right;">Descuento</td>
            <td style="width: 40%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formOrder.total_discount }}</td>
          </tr>
          <tr v-if="formOrder.total">
            <td></td>
            <td style="width: auto;text-align: right;"><strong>Total</strong></td>
            <td style="width: 40%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formatPrice(formOrder.total) }}</td>
          </tr>
        </table>
      </div>
    </div>
<div style="display:none" id="pedido">
  <div style="text-align: left;margin-left: 10px;margin-top: -10px;"> 
    <label style="text-align: left;font-size: 14px; margin-right: 10px;"><i class="fa fa-map-marker-alt" style="margin-right: 0.50rem;"></i>{{ direccion }}</label>
    <label style="text-align: left;font-size: 14px;"><i class="far fa-clock" style="margin-right: 0.30rem;"></i>{{ horario }}</label>   
  </div>
  <h5 style="text-align: left;margin-left: 10px;">Seleccione forma de entrega</h5>
  <table style="width:95%;margin-left: 10px;"> 
  <tr style="display: flex; justify-content: space-between;"> 
    <td v-if="!autoservicio" style="width: 27%;"><button v-bind:style="{backgroundColor : color_botones}" :disabled="!mesero" id="btn-mesa" class="boton-pedido" style="width: 100%;" @click="mesaPedido()"><i class="fa fa-mouse-pointer" id="check-mesa" style="margin-left: -12px;display: none;"></i>&nbsp;Mesa</button></td> 
    <td v-else style="width: 34%;"><button v-bind:style="{backgroundColor : color_botones}" id="btn-mesa" class="boton-pedido-auto" style="width: 100%;" @click="mesaPedido()"><i class="fa fa-mouse-pointer" id="check-mesa" style="margin-left: -22px;display: none;"></i>&nbsp;Autoservicio</button></td> 
    <td style="width: 34%;"><button v-bind:style="{backgroundColor : color_botones}" id="btn-domicilio" :disabled="kiosko" class="boton-pedido" style="width: 100%;" @click="enviarDomicilio()"><i class="fa fa-mouse-pointer" id="check-domicilio" style="margin-left: -12px;" ></i>&nbsp;Domicilio</button></td>
    <td style="width: 34%;"><button v-bind:style="{backgroundColor : color_botones}" id="btn-recogerlo" class="boton-pedido" style="width: 100%;" @click="recogerPedido()"><i class="fa fa-mouse-pointer" id="check-recogerlo" style="margin-left: -12px;display: none;"></i>&nbsp;Recogerlo</button></td>
    
  </tr>
  </table>
  <br>
  <h5 style="text-align: left;margin-left: 10px;">Detalle de la Orden</h5>
  <table table style="width:95%;margin-left: 10px;">
    <tr v-for="(item) in this.carrito" id="detalle-pedido" v-bind:key="item.index">        

        <td style="width: 70%;text-align: left;cursor: pointer;">{{ item.cantidad }} x {{ item.name_product }}&nbsp;&nbsp;&nbsp;{{ item.observation_optional ? " (Obs: "+item.observation_optional+") " : "" }}<i @click="removeItem(item.id_product,item.name_product)" v-bind:style="{color : color_botones}" class="fas fa-trash-alt"></i></td>
        <td v-if="company.type == 72 /*Carniceria*/" style="width: 10%;text-align: right;"></td>
        <td v-else style="width: 30%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formatPrice((item.valor*item.cantidad)+item.addition_v) }}</td>
    </tr>
    <tr v-if="this.form.descuento > 0">
    <td style="width: 40%;text-align: left;">Descuento - {{ this.coupon.coupon }}</td>
        <td style="width: 70%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formatPrice(this.form.descuento) }}</td>
    </tr>
    <tr id="tr_domicilio" v-show="this.domicilio > 0">
    <td style="width: 40%;text-align: left;" v-if="form.id_companie != 7717">Domicilio</td>
    <td style="width: 40%;text-align: left;" v-else>Servicio</td>
        <td style="width: 70%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">$ {{ formatPrice(this.domicilio) }}</td>
    </tr> 
    <tr id="tr_priority_shipping" v-if="priority_shipping && !mesero">
    <td style="width: 40%;text-align: left;"><label><input type="checkbox" id="tr_priority_shipping" v-model="tr_priority_shipping" @change="checkBox_priority_shipping()"> Prioritario ⚡<br><p style="font-size: 12px">El restaurante priorizara tu preparacion y entrega</p></label></td>
        <td style="width: 70%;text-align: right;" v-bind:style="{color : color_letra, fontWeight: 700}">+$ {{ formatPrice(value_priority_shipping) }}</td>
    </tr>  
  </table>
  <br>
  <div v-show="coupons && !mesero"  style="width: 95%;padding-right: 10px;padding-left: 13px;margin-bottom: 15px;" class="butoncupon">
    <button  v-bind:style="{borderColor: color_botones}" class="botonmostrar" style="padding: 10px;background-color: white;border-style: dashed;margin-right: 5px;">SUMAR CUPÓN DE DESCUENTO</button>
    <button v-bind:style="{borderColor: color_botones}" class="botoncerrar ocultarcupon" style="padding:10px;background-color: white;font-weight: 400;border-style: dashed;">
      <i class="fas fa-times" v-bind:style="{color: color_botones}" style="font-size: 23px;"></i>
    </button>
  </div>  
  <div class="cupon-contain ocultarcupon">
    <div style="width: 65%;text-align: center;">
      <input type="text" v-model="textCoupon" placeholder="Código del cupon" style="border-right: none;border-left: none;border-top: none;width:80%;padding-top: 8px;border-color: skyblue;">
    </div>    
    <div class="loading-coupon" @click="validateCoupon()" v-bind:style="{backgroundColor: color_botones}">
      <h4 class="text-coupon">Añadir Cupón</h4>
      <i class="fas fa-spinner loading-icon"></i>
    </div>
  </div>

  <div class="content-messages" style="width: 100%; padding: 0px 10px 0px 10px;margin-top: 10px;">
      <div v-if="couponSuccess" class="cupon-success" style="width: 100%; padding: 15px; background-color:#1AA15F;border-radius: 10px;">
        <h5 style="color: #fff; font-weight: 500;font-size: 14px;margin-bottom: 0 !important;">
          <i class="fas fa-check" style="margin-right: 5px;"></i>{{ couponText }}</h5>
      </div>
      <div v-if="couponError" class="cupon-wrong" style="width: 100%; padding: 15px; background-color:#FF0000;border-radius: 10px;">
        <h5 style="color: #fff; font-weight: 500;font-size: 14px;margin-bottom: 0 !important;">
          <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i>{{ couponText }}</h5>
      </div>
  </div>
  <br>
  <table style="width:95%;margin-left: 10px;"> 
  <tr style="display: flex; justify-content: center;margin-bottom: 10px;">  
    <td style="width: 100%;text-align: center;justify-content: center;display: flex;">
      <button 
        v-bind:style="{backgroundColor : color_botones}" 
        class="boton-detalle pin-button send-button "
        style="width: 100% !important; padding-top: 7px !important; padding-bottom:9px !important;" 
        @click="confirmarPedido"
      >
        <label v-if="company.type != 72" style="width: 20% !important;text-align: left !important;">{{this.carrito.length}}</label>
        <label class="pin-text" style="width: 45% !important;text-align: center !important;">Confirmar Orden</label>
        <label v-if="company.type != 72" style="width: 30% !important;text-align: right !important;">$ {{ formatPrice(this.total)}}</label>
      </button>
    </td>    
  </tr>  
  <tr>
    <td style="width: 100%;"><button v-bind:style="{backgroundColor : color_botones}" class="boton-detalle" style="width: 100%;" @click="showProductos()"><i class="fas fa-arrow-left" style="margin-right: 0.35rem"></i>Volver a tienda</button></td>
  </tr>
  </table>
  
</div>
    <div id="datos-personales" style="display:none;width: 100%">        
       <h4 style="text-align: left;margin-left: 10px;font-weight: 600" v-if="form.id_user_mesero == null">Confirmando Orden</h4> 
       <h4 style="text-align: left;margin-left: 10px;font-weight: 600" v-else>Confirmando Orden - Mesero: {{ form.nombre_mesero }} </h4>
       <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;padding-bottom: 10px;" 
          v-show="multipuntos && (formaEntrega.domicilio || formaEntrega.recogerlo || formaEntrega.mesas)">
          <select @change="changePoint" :disabled="mesero" id="pointsList" class="select-icono" required v-model="point_selected">
            <option value="0" disabled selected>Seleccione el punto</option>
            <option v-for="p in filteredPoints" :key="p.name" :value="p.name">
              {{ p.name }}
            </option>
          </select>
          <small id="validatePunto" style="color:red;display: none;">Debe selecionar un punto.</small>
          <small id="jornadaPunto" style="color:red;display: none;">Este punto se encuentra fuera del horario de atención.</small>
      </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="(orderExistSelected == null || orderExistSelected == undefined)">      
      <i class="fas fa-user form-control-feedback"></i>
      <input placeholder="Nombres" type="text" id="nombre" class="izquierda" autocomplete="off" required="true" v-model="form.nombres" >
      <small id="validateNombre" style="color:red;display: none;">Campo nombres es obligatorio.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="statusCedula && (orderExistSelected == null || orderExistSelected == undefined)">      
      <i class="fas fa-hashtag form-control-feedback"></i>
      <input
        placeholder="No. de cédula"
        type="tel"
        id="cedula"
        class="izquierda"
        autocomplete="off"
        required="true"
        v-model="form.cedula"
        :disabled="cedulaBlocked"
        @input="onCedulaInput"
      >      
      <small id="validateCedula" style="color:red;display: none;">Campo cédula es obligatorio.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="input_nit && (orderExistSelected == null || orderExistSelected == undefined)">
      <i class="fas fa-hashtag form-control-feedback"></i>
      <input
        placeholder="Nit"
        type="tel"
        id="telefono"
        class="izquierda"
        autocomplete="off"
        required="true"
        v-model="form.nit"
        :disabled="nitBlocked"
        @input="onNitInput"
      > 
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" class="nacimiento-container" v-show="statusNacimiento && (orderExistSelected == null || orderExistSelected == undefined)">
      <i class="far fa-calendar-alt form-control-feedback"></i>
      <input type="text" id="nacimiento" v-model="form.fecha_nacimiento" class="izquierda" placeholder="Fecha de nacimiento (dd-mm-yyyy)" autocomplete="off">
      <small id="validatenacimiento" style="color:red;display: none;">Campo Fecha de nacimiento es obligatorio.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="(orderExistSelected == null || orderExistSelected == undefined)">   
      <i class="fas fa-mobile-alt form-control-feedback"></i>   
      <input placeholder="Telefono" type="number" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="form.telefono"  @change="cambiarNumero()">
      <small id="validateTelefono" style="color:red;display: none;">Campo teléfono es obligatorio.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="mesas.length > 0 && mesero" v-if="form.id_user_mesero == null && !select_waiters && !active_login && !active_login_with_pin" >   
      <i class="fas fa-user form-control-feedback"></i>   
      <input placeholder="Nombre del mesero" type="text" id="telefono" class="izquierda" autocomplete="off" required="true" v-model="form.nombre_mesero">
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" class="padre-puntos" v-show="mesas.length > 0 && mesero && select_waiters" v-if="select_waiters && mesero && !active_login_with_pin" >  
      <select @change="updateWaiter($event)" class="select-icono" style="width: 95%;">
        <option value="0" selected disabled>{{ multipuntos && point_selected == 0  ? 'Seleccione un punto primero' : 'Seleccione un mesero' }}</option>
        <option v-for="waiter in waiters" :key="waiter.id" :value="waiter.id">
            {{ waiter.name }}
        </option>
      </select>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-if="formPay.payOnline || statusEmail" v-show="(orderExistSelected == null || orderExistSelected == undefined)">
      <i class="fas fa-envelope form-control-feedback"></i>
      <input placeholder="Email" type="email" id="email" class="izquierda" autocomplete="off" required="true" v-model="form.email">      
      <small id="validateEmail" style="color:red;display: none;">Campo email es obligatorio.</small>
      <small id="validateEmail1" style="color:red;display: none;">Debe introducir un email valido.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%; margin-bottom: 10px;" v-if="this.estado_domicilio == true || estado_domicilio_mesero == true">    
      <i class="fas fa-home form-control-feedback"></i>    
      <input placeholder="Dirección" type="text" id="direccion_pedido" class="izquierda" autocomplete="off" required="true" v-model="form.direccion">
      <small id="validateDireccion" style="color:red;display: none;">Campo dirección es obligatorio.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;margin-bottom: 10px;" v-if="statusBarrio && !mesero && estado_domicilio == true">
      <i class="fas fa-map-marker-alt form-control-feedback"></i>
      <input placeholder="Barrio" type="text" id="barrio" class="izquierda" autocomplete="off" required="true" v-model="form.barrio">      
      <small id="validateBarrio" style="color:red;display: none;">Campo barrio es obligatorio.</small>
    </div>
    
    <div v-show="statusFecha && !optMesa && !kiosko" style="width: 100%;text-align: left;margin-left: 10px;"><label style="font-weight: 500;margin-top: 10px;">Fecha de Entrega</label></div>
    <div style="text-align: left;margin-left: 10px;width:95%;margin-bottom:10px;border: 1px solid gray;border-radius: 5px; padding-top: 5px; padding-right: 10px;" v-show="statusFecha && !optMesa && !kiosko">  
      <ejs-datepicker @change="setDate()" :min="minDate"  :value="dateVal" :focus='onFocus'  id="entrega" :format="dateFormat" style="border: none !important;width: 90% !important;"></ejs-datepicker>
    </div>
    <div v-show="statusFecha && !optMesa && !kiosko" style="width: 100%;text-align: left;margin-left: 10px;"><label style="font-weight: 500;">Hora de Entrega</label></div>
    <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;margin-bottom:10px;display: flex;justify-content: space-between;" v-show="statusFecha && !optMesa && !kiosko">
      <div style="width: 34%;" class="div-fecha-entrega">
      <select @change="setMinutesForHours()" class="select-icono" id="horaEntrega">        
      </select>
      </div>        
      <div style="width: 34%;" class="div-fecha-entrega"><select class="select-icono" id="minutoEntrega"></select></div>       
      <div style="width: 25%;" class="div-fecha-entrega">
        <select class="select-icono" v-model="horarioEntrega" id="horarioEntrega">        
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>                       
    </div>
    <div v-show="statusFecha && !optMesa && !kiosko" style="text-align: left;margin-left: 10px;"><small id="validateFecha" style="color:red;display: none;">Debe definir una hora de entrega.</small></div>
    <div class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;padding-bottom: 10px;" v-show="(orderExistSelected == null || orderExistSelected == undefined)">                   
      <select class="select-icono" required="true" v-model="form.id_type_forma_pago" @change="verifyTypePayment()">        
        <option value="0" selected disabled>Seleccione una forma de pago</option>
        <option value="37" v-if="!kiosko && cash == true">Efectivo</option>
        <option value="38" v-if="!kiosko && transfer == true && !formPay.payOnline">Transferencia</option>
        <option value="169" v-if="formPay.payOnline && kiosko">Qr Bancolombia</option>
        <option value="39" v-if="dataphone == true && (!kiosko || kiosko_dataphone)"> Datáfono <span v-if="incremento_datafono > 0"> + ${{ incremento_datafono }} </span> </option>
        <option value="76" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago en Linea</option>
        <option value="141" v-if="!kiosko && formPay.payOnline && payonlineaddress">Pago Nequi</option>
        <option value="126" v-if="!kiosko && formPay.payOnline && payonlineaddress">Transf. Bancolombia</option>
        <option value="128" v-if="!kiosko && pay_epayco == true">Daviplata</option>
        <!--<option value="142" v-if="formPay.payOnline">Pago Tarjeta</option>
        <option value="143" v-if="formPay.payOnline">Pago Bancolombia</option>-->
      </select>
      <small id="validateForma" style="color:red;display: none;">Debe selecionar un forma de pago.</small>
    </div> 
    
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="form.id_type_forma_pago == '141'"> 
      <i class="fas fa-mobile-alt form-control-feedback"></i>   
      <input placeholder="Numero de Nequi" type="tel" id="valNequiPayment" class="izquierda" autocomplete="off" required="true" v-model="valNequiPayment">
      <small id="validateNumeroNequi" style="color:#ff0000;display: none;">Debe agregar su numero de cuenta Nequi.</small>
      <br>
      <small style="color:blue;">Ahora debes entrar a tu App Nequi, dar click en Notificaciones y aceptar el pago, luego comenzaremmos a preparar tu pedido 🥳.</small> 
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="form.id_type_forma_pago == '128'">
      <div style="display: flex; flex-wrap: nowrap;">
        <select style="width: 20%; margin-right: 10px;" class="select-icono" required="true" v-model="form.type_document">
          <option value="CC" selected>CC</option>
          <option value="NIT">NIT</option>
        </select>
        <input style="width: 72%!important;" placeholder="Numero de Documento" type="tel" id="cedula" autocomplete="off" required="true" v-model="form.documento">
      </div>
      <small id="documento" style="color:red;display: none;">Debe agregar su numero de documento.</small>
      <br>
      <small style="color:blue;">Te llegara un codigo de confirmacion a tu numero celular.</small> 
    </div>
    <!--
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;display: flex;" v-show="form.id_type_forma_pago == '142'">
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">
      <i class="fas fa-mobile-alt form-control-feedback"></i>   
      <input placeholder="Nombre y Apellido" type="tel" id="valNameTarjeta" class="izquierda" autocomplete="off" required="true" v-model="valNequiPayment">
      <small id="validateNombreTarjeta" style="color:red;display: none;">Debe agregar su numero de nombre.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">
      <i class="fas fa-mobile-alt form-control-feedback"></i>   
      <input placeholder="Numero de Tarjeta" type="tel" id="valNumTarjeta" class="izquierda" autocomplete="cc-number" required="true" v-model="valTarjetaPayment" maxlength="16" minlength="16" pattern="[0-9]">
      <small id="validateNumeroTarjeta" style="color:red;display: none;">Debe agregar su numero de tarjeta.</small>
      <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">
        <i class="fas fa-mobile-alt form-control-feedback"></i>   
        <input placeholder="Codigo de seguridad" type="tel" id="valCodTarjeta" class="izquierda" autocomplete="off" required="true" v-model="valTarjetaPayment" pattern="[0-9] {3}">
        <small id="validateCodTarjeta" style="color:red;display: none;">Debe agregar su numero de tarjeta.</small>
    </div>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;">
      <i class="far fa-calendar-alt form-control-feedback"></i>
      <input type="tel" id="valDateTarjeta" v-model="form.fecha_expiracion"  maxlength="9" minlength="5" class="izquierda" placeholder="Fecha de expiración" autocomplete="cc-exp">
      <small id="validatenacimiento" style="color:red;display: none;">Campo Fecha de expiracion es obligatorio.</small>
    </div>  
    </div>
    -->


    <div v-show="mesas.length > 0 && (mesero || valida_mesa) && showSelectTable && !this.active_login_with_pin" class="padre-puntos" style="text-align: left; margin-left: 10px; width: 95%; padding-bottom: 10px;">
      <select class="select-icono" v-model="form.mesa" >
        <option value="0" selected disabled>Seleccione la mesa</option>
        <option v-for="mesa in mesas" :key="mesa.number_table" :value="mesa.number_table" :class="{ 'ocupada': esMesaOcupada(mesa.number_table) }" :disabled="mesaOcupadaPorOtroMesero(mesa.number_table)">
          Mesa {{ mesa.number_table }} 
          <span v-if="esMesaOcupada(mesa.number_table)" style="color: red;">- {{ obtenerNombreMesero(mesa.number_table) }}</span>
        </option>
      </select>
      <small id="validateMesa" style="color:red;display: none;">Debe seleccionar una mesa.</small>
    </div>
    
    
    <div v-show="numberAccount && banks.length > 0" class="padre-puntos" style="text-align: left;margin-left: 10px;width:95%;">
        <select class="select-icono" name="select" id="select-bank" @change="copyAccount()" v-model="bank_type">    
          <option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
          <option :value="bank.account" v-for="bank in banks" :key="bank.id">{{ bank.bank }}</option>
        </select> 
       <div style="margin-top: 10px;text-align: left">
        <label v-bind:style="{color : color_botones}" style="display: none;font-size: 16px;font-weight: 500;" id="notify-copy">Número de cuenta copiado!</label>
       </div>
    </div>
    <div class="transfer-alert" v-if="form.id_type_forma_pago == 38 && transfer_support">
      <i class="fas fa-info"></i>
      <h4>Enviar soporte de transferencia.</h4>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 10px;" v-show="howPay">
      <i class="fas fa-money-bill form-control-feedback"></i>
      <input placeholder="¿Con cuanto pagas?" type="number" id="how-pay" v-model="valHowPay" class="izquierda" autocomplete="off" required="true" >
      <small id="validateCuantoPaga" style="color:red;display: none;">Debe agregar con cuanto vas a pagar.</small>
    </div>
    <div style="text-align: left;margin-left: 10px;width:100%;padding-bottom: 5px;">        
        <textarea placeholder="Ingrese un comentario(opcional)" id="comentario" rows="2" v-model="form.comentario"></textarea>
    </div>    
    <div style="width:100%;padding-bottom: 5px;">        
    <label style="font-size: 13px;font-weight: 350;text-align: left;margin-right: 10px;margin-left:10px;">Al dar click en enviar, aceptas nuestros <a v-bind:style="{color : color_botones, fontWeight: 500}" v-bind:href="'/terminos/'+company.name+'/'+company.id" target="_blank">Términos y condiciones</a> y las <a v-bind:style="{color : color_botones, fontWeight: 500}" v-bind:href="'/terminos/'+company.name+'/'+company.id" target="_blank">políticas de privacidad</a>.</label>
    </div>
    <div v-show="!checkout && form.id_type_forma_pago != '141' && form.id_type_forma_pago != '126' && form.id_type_forma_pago != '128' && form.id_type_forma_pago != '169'" class="container-button" @click="saveOrderBD(false)">
      <div class="send-button" v-bind:style="{backgroundColor : wa_redirect_auto ? '#64B161' : color_botones + '!important' }">
        
        <i class="fas fa-check hide"></i>
        <i v-if="wa_redirect_auto" class="fab fa-whatsapp what"></i>
        <label class="send-text">{{wa_redirect_auto?'Enviar por WhatsApp':'Confirmar Orden'}}</label>
      </div>
    </div>
    <div v-show="checkout" style="text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;">    
      <button class="btn-wonpi" @click="pay()">Paga Aquí</button>     
    </div> 
    <div v-show="validacionMonto">
      <br>
      <small style="color:red;">El monto a pagar debe ser mayor a 1500.</small> 
    </div>
    <div v-show="form.id_type_forma_pago == '141' && valNequiPayment.trim() != ''" style="text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;" class="send-button2">    
      <button id="paynequi" class="btn-wonpi" @click="payNequi()">Paga Aquí</button>     
    </div>
    <div v-show="form.id_type_forma_pago == '126' || form.id_type_forma_pago == '169'" style="text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;" class="send-button2"> 
      <button class="btn-wonpi" @click="applyMethodPay()">Paga Aquí</button>     
    </div>
    <div v-show="form.id_type_forma_pago == '128'" style="text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;" class="send-button2"> 
      <button class="btn-wonpi" @click="payDaviplata()">Paga Aquí</button>     
    </div>
    <div v-show="(form.id_type_forma_pago == '141' && valNequiPayment.trim() != '') || form.id_type_forma_pago == '126' || form.id_type_forma_pago == '128' || form.id_type_forma_pago == '169'">
       <br>
    </div>
    <div class="out-service">
      <h4>Este punto está fuera del horario</h4>
    </div>

    <div style="text-align: left;margin-left: 10px;width:95%;margin-bottom: 10px;">
      <button v-bind:style="{backgroundColor : color_botones}" class="boton-detalle" style="width: 100%;" @click="volverAlPedido()"><i class="fas fa-arrow-left" style="margin-right: 0.35rem"></i>Volver a la Orden</button>      
    </div>
    
  </div>

  <div class="footer-page">
    <h4>Tecnología <a href="https://info.vinapp.co" target="_blank">VinApp</a></h4>
  </div>
  <a ref="whatsappLink" href="https://api.whatsapp.com/send?phone=573001405992" target="_blank" rel="noopener noreferrer" style="position: absolute; left: -9999px;"><i class="fab fa-whatsapp"></i></a>  
  <div id="notification" style="background-color:#404040;color:white;padding: 10px;display: none">
    Una nueva versión está disponible.&nbsp;&nbsp;&nbsp;<a id="reload" style="color:#A1C2FA;" @click="reload()">ACTUALIZAR</a></div>
    <HelloWorld msg="Vincom Store"/>    
    </div><!-- FIN DEL content-->           
    </div><!-- FIN DEL demo-content-->     
  </div>
</template>

<!--style-->
  <style scoped>

    .pin-button.button-loading {
        position: relative; /* Para posicionar el loader */
        overflow: hidden;   /* Evita que el giro se salga del botón */
        min-width: 50px;   /* Ancho mínimo para que no colapse */
        width: auto !important; /* Quita el 100% en carga */
        padding: 0 !important;  /* Elimina padding para que no afecte el círculo */
    }

    /* Círculo de carga (similar al Botón 2) */
    .pin-button.button-loading::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin: -10px 0 0 -10px;
        border: 3px solid rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        border-top-color: white;
        animation: rodar 1s linear infinite;
    }

    /* Animación de giro (igual que en el Botón 2) */
    @keyframes rodar {
        to { transform: rotate(360deg); }
    }

    /* Botón deshabilitado durante confirmación de orden (mesero) */
    .pin-button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
    }

    .btn-footer.btn-kiosko {
      font-size: 20px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    #home{
      overflow: hidden;
    }

    .category-image.active {
      border: 3px solid #ffca1c; /* Cambia al color de tu elección */
      transform: scale(1.1); /* Aumenta el tamaño ligeramente */
      font-weight: 600; /* Aplica peso extra si necesario */
    }

  
    .category-image {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f5f5f5;
      border: 2px solid #ccc;
    }

    .category-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

.products-store-container-new {
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  gap: 20px;
}

.single-product-view-new {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: 10px;
}

.single-product-image-container-new {
  flex-shrink: 0;
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.single-product-image-container-new img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.single-product-info-new {
  flex-grow: 1;
  text-align: left;
  padding: 10px;
}

.single-product-info-new h4{
      font-size: 15px;
      font-weight: 600;
    }

    .single-product-info-new p{
      font-size: 12px;
      font-weight: 400;
      color: #A0A0C0;
    }

    .single-product-price-options-new h4{
      font-size: 14px;
      font-weight: 500;
      color: #801414;
      margin-bottom: 0;
    }

    .variants-option-new i{
      color: #fff;
      font-size: 9px;
    }

.single-product-price-options-new {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

    .single-product-view2 {
    width: 18%;
    background: #fff;
    border-radius: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    overflow: hidden;
    margin-right: 17px;
    margin-bottom: 25px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    /* Asegurar flexibilidad inicial */
    min-height: 150px;
    height: auto;
  }


    .Select2-container {
      width: 100% !important;
    }

    .ocupada {
      font-weight: bold;
      background-color: #FFCCCC;
      
    }
    *:focus{
      outline: none;
    }

    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');


    .shop-product{
		width: 25%;
		background: #000;
		padding: 17px 15px 17px 15px;
		border-radius: 7px;
		align-self:center;
    margin: 5px;
	}

	.shop-product h5{
		font-size: 18px;
		font-weight: 500;
		color: white;
		margin-bottom: 0 !important;
		align-self:center;
	}
    .landscape-image{
      width: 100%;
      height: 100vh;
      position: fixed;
      background: rgba(0, 0, 0, 0.6);
      z-index: 99999999999999999;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }

    .landscape-inner {
  position: relative; /* Esto es clave */
  width: 75%;
  height: auto;
  opacity: 1 !important;
  z-index: 999999999999999999;
}

.landscape-inner img {
  width: 100%;
  height: auto;
  opacity: 1 !important;
}

.close-landscape {
  position: absolute;
  top: 10px;
  right: 10px; /* Agregado para alinear a la derecha */
  z-index: 100; /* aseguramos que esté por encima de la imagen */
}

.close-landscape i {
  color: #fff;
  font-size: 19px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5); /* opcional, para visibilidad */
  padding: 5px;
  border-radius: 50%;
}


    /*Estilos de horarios*/

    .single-product-price-options-mobile{
      width: 100%;
      padding: 0px 15px 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .single-product-price-options-mobile h4{
      font-size: 14px;
      font-weight: 500;
      color: #801414;
      margin-bottom: 0;
    }

    .single-product-info-mobile{
      width: 100%;
      text-align: left;
      padding: 10px 10px 0px 10px;
    }

    .single-product-info-mobile h4{
      font-size: 15px;
      font-weight: 600;
    }

    .single-product-info-mobile p{
      font-size: 12px;
      font-weight: 400;
      color: #A0A0C0;
    }

    .single-product-image-container-mobile{
      width: 100%;
    }

    .single-product-image-container-mobile img{
      width: 100%;
      height: auto;
    }

    .single-product-view-mobile{
      width: 45%;
      background: #fff;
      border-radius: 10px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
      overflow: hidden;
      margin-bottom: 25px;
      margin-right: 15px;
      align-self: flex-start;
      cursor: pointer;
      transition: all .3s ease-in-out;
    }

    .products-store-container-mobile{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }

    .category-title-mobile{
      width: 100%;
      padding-bottom: 15px;
      text-align: left;
    }

    .category-title-mobile h4{
      font-size: 17px;
      font-weight: 600;
      font-family: 'Poppins', sans-serif;
      text-transform: capitalize !important;
    }

    .store-container-mobile{
      width: 100%;
      display: block;
    }

    .section-products-mobile{
      width: 100%;
      padding: 30px 15px;
      background: #FAFAFD;
    }

    .mobile-view{
      width: 100%;
      height: auto;
      padding: 0px 0px 25px 0px;
      /*background: #FAFAFD;*/
    }

    .categorys-desktop-mobile{
      width: 100%;
      padding: 10px 0px 10px 0px;
      background: #fff;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      border-bottom: 1px solid #D3D3E6;
      text-align: left;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }

    .category-name-mobile{
      margin-right: 10px;
      display: inline-block;
    }

    .category-name-mobile button{
      border: 1px solid #ddd;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      border-radius: 20px;
      padding: 8px 25px;
    }

    .search-content{
      width: 100%;
      padding: 10px 5px;
    }

    .detail-cupon{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border:1.3px solid #b2b2b2;
      padding:5px;  
      border-radius: 25px;
      /*border-bottom-right-radius: 25px;
      border-bottom-left-radius: 30px;
      border-top-left-radius: 30px;*/
    }

    .check-image{
      width: 37px;
      height: 37px;
      border-radius:50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .check-image i{
      color: #fff;
      font-size: 14px;
      margin-left: 5px;
    }

    .input-cupon{
      width: 75%;
      text-align: left;
    }

    .input-cupon input{
      height: 30px;
      font-size: 17px;
      border:none;
      padding-left: 10px;
    }

    .footer-page{
      width: 100%;
      text-align: center;
      padding-top: 30px;
      padding-bottom: 15px;
    }

    .footer-page h4{
      font-size: 15px;
      font-weight: 500;
      font-family: 'Poppins', sans-serif;
    }

    .red{
      color: #E93A43 !important;
    }

    .old-price{
      color: #9C9C9C;
      text-decoration-line: line-through;
    }

    .login-content h4{
      color: #fff;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 25px;
    }

    .red-schedule{
      color: #EB3941 !important;
    }

    .actual-day{
      border: 1px solid #1A73E8;
    }

    .header-info-name{
      display: block;
      text-align: left;
    }

    .header-info-name h5{
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 14px;
      margin-left: 15px;
    }

    .container-horario{
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      background: rgba(0, 0, 0, .6);
      position: fixed;
      bottom: 0;
      z-index: 900000000;
    }

    .schedule-container{
      width: 100%;
      height: 85vh;
      background: #fff;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      background: #F8F8F8;
      overflow-y: scroll;
    }

    .schedule-header{
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      background: #fff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    }

    .schedule-header i{
      font-size: 18px;
      color: #000;
    }

    .schedule-header h4{
      color: #000;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 21px;
      margin-bottom: 0;
      margin-left: 15px;
    }

    .section-schedule{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .img-schedule-container{
      width: 55px;
      height: 55px;
      padding: 5px;
      border-radius: 50%;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    }

    .img-schedule-container img{
      width: 100%;
      height: auto;
    }

    .schedule-content{
      width: 100%;
      display: block;
      padding: 20px 20px 0px 20px;
    }

    .single-schedule-day{
      width: 100%;
      height: auto;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #fff;
      border-radius: 7px;
      padding: 11px 15px;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
      margin-bottom: 10px;
    }

    .point-container{
      padding-right: 20px;
    }

    .point-container i{
      color: #801414;
    }

    .schedule-information{
      width: 75%;
    }

    .schedule-information h4{
      color: #000;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 14px;
    }

    .schedule-information h5{
      color: #000;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 12px;
    }

    .schedule-state h6{
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 12px;
    }

    .schedule-success{
      color: #28A745;
    }

    .schedule-danger{
      color: #EB3941;
    }



    /*Fin estilos horarios*/


    /*Estilos desktop view*/

    .desktop-view{
      width: 100%;
      position: relative;
      height: auto;
    }

    .second-condition{
      width: 100%;
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 50000000;
    }

    .categorys-desktop{
      width: 100%;
      display: flex;
      gap: 15px;
      padding: 10px 20px;
      background: #fff;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      border-bottom: 1px solid #D3D3E6;
      text-align: left;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 50000000;
    }

    .categorys-desktop-2{
      width: 80%;
      padding: 10px 20px;
      background: #fff;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      border-bottom: 1px solid #D3D3E6;
      text-align: left;
    }

    .select-restante{
      width: 20%;
      padding: 10px 0px;
      text-align: center;
      background: #fff;
      border-bottom: 1px solid #D3D3E6;
    }

    .select-restante select{
      width: 100%;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      border: none;
    }

    .category-name {
      margin-right: 15px;
      display: inline-flex; 
      flex-direction: column;
      align-items: center;
      text-align: center; 
    }

    

    .category-name button {
      border: none;
      font-size: 12px;
      color: gray;
      background-color: transparent;
      margin-top: 10px;
      /*border: 1px solid #ddd;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      border-radius: 20px;
      padding: 8px 25px;
      background-color: black;*/
    }

    .category-name-button {
      border: none;
      font-size: 10px;
      color: "gray";
      background-color: transparent;
    }


    .section-products-desktop{
      width: 100%;
      padding: 40px 20px;
      background: #FAFAFD;
    }

    .store-container{
      width: 100%;
      display: block;
    }

    .category-title{
      width: 100%;
      padding-bottom: 15px;
      text-align: left;
    }

    .category-title h4{
      font-size: 19px;
      font-weight: 600;
      text-transform: capitalize !important;
    }

    .products-store-container{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      cursor: pointer;
    }

    .cantidades-container{
      display: none;
    }

    .cantidades-wrapper{
      display: flex;
      align-items: center;
    }

    .single-product-view{
      width: 18%;
      background: #fff;
      border-radius: 10px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
      overflow: hidden;
      margin-right: 17px;
      margin-bottom: 25px;
      align-self: flex-start;
      cursor: pointer !important;
      transition: all .3s ease-in-out;
    }

    .single-product-view:hover{
      transform: translateY(-25px);
      transition: all .3s ease-in-out;
    }

    .single-product-image-container{
      width: 100%;
    }

    .single-product-image-container img{
      width: 100%;
      height: 100%;
    }

    .single-product-image-container2{
      width: 100%;
    }

    .single-product-info{
      width: 100%;
      text-align: left;
      padding: 10px 10px 0px 10px;
    }

    .single-product-info h4{
      font-size: 15px;
      font-weight: 600;
    }

    .single-product-info p{
      font-size: 12px;
      font-weight: 400;
      color: #A0A0C0;
    }

    .single-product-price-options{
      width: 100%;
      padding: 0px 15px 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .single-product-price-options h4{
      font-size: 14px;
      font-weight: 500;
      color: #801414;
      margin-bottom: 0;
    }

    .variants-option{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .variants-option i{
      color: #fff;
      font-size: 9px;
    }

    .plus-quantity{
      width: 17px;
      height: 17px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .plus-quantity i{
      color: #fff;
      font-size: 8px;
    }

    .minus-quantity{
      width: 17px;
      height: 17px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .minus-quantity i{
      color: #fff;
      font-size: 8px;
    }

    /*Fin estilos desktop view*/

    .fixed-menu{
        width: 85%;
        margin: 0 auto;
        position: fixed;
        bottom: 15px;
        left: 0;
        right: 0;
        padding: 10px 10px;
        border-radius: 7px;
        background: #fff;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 1000;
      }

      .single-menu-option{
        width: 33%;
        text-align: center;
        display: block;
      }

      .single-menu-option i{
        font-size: 18px;
        color: #236FC3;
      }

      .single-menu-option h4{
        font-size: 12px;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        color: #3D4762;
      }

    .close-detail{
      width: 100%;
      text-align: right;
      padding: 7px 8px;
    }

    .close-detail i{
      font-size: 21px;
      color: #DEE1E6;
    }

    .ubication-warning{
      width: 100%;
      text-align: center;
      padding: 5px;
    }

    .ubication-warning span{
      font-size: 15px;
      color: red;
      font-weight: 500;
    }

    .button-direction-container{
      width: 100%;
      padding-top: 15px;
      text-align: center;
    }

    .button-direction-container button{
      padding: 9px 21px;
      color: #fff;
      font-weight: 500;
      font-size: 17px;
      border-radius: 6px;
      border: none;
    }

    .detail-direction{
      width: 100%;
      height: auto;
      padding: 5px;
    }

    .input-complete{
      width: 97%;
      margin: 0 auto;
      text-align: left;
    }

    .input-complete h4{
      font-weight: 500;
      font-size: 16px;
      color: #353535;
      margin-bottom: 10px !important;
    }

    .separatore{
      width: 97%;
      margin: 0 auto;
      text-align: center;
      padding: 10px 0px 10px 0px;
    }

    .separatore h4{
      font-weight: 400;
      font-size: 14px;
      color: #353535;
      margin-bottom: 0 !important;
    }

    .input-complete input,select{
      width: 100%;
      background: #F1F3F4;
      color: #3A3A3A;
      font-size: 16px;
      padding: 14px 13px;
      border: none;
      border-radius: 7px;
    }

    .actual-position-container{
      width: 97%;
      margin: 0 auto;
      /*border: 1px solid #ddd;*/
      background: #F1F3F4;
      padding: 10px 5px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .position-icon{
      width: 10%;
      text-align: center;
    }

    .position-icon i{
      font-size: 22px;
      color: #353535;
    }

    .position-text{
      width: 82%;
      text-align: left;
      padding: 0px 6px;
    }

    .position-text h4{
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 500;
    }

    .position-text input{
      border: none;
      width: 100%;
      font-size: 15px;
      color: #353535;
    }

    .position-text input:disabled{
      background: transparent;
    }

    .position-circle{
      width: 8%;
      text-align: center;
    }

    .border{
      border: 1px solid #003466 !important;
    }

    .blue-color{
      background: #003466 !important;
    }

    .circle{
      width: 22px;
      height: 22px;
      border-radius: 50%;
      border: 1px solid #EBEBEB;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
    }

    .esfere{
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #EBEBEB;
    }



    /*#carouselExampleControls img{
      width: 100%;
      height: auto;
    }*/

    .map-ubication-container{
      width: 100%;
      height: 100vh;
      background: #fff;
      display: block;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
    }

    .map-container{
      width: 100%;
      height: 55vh;
      border: 1px solid #ddd;
    }

    .gotop{
      top: 80px !important;
    }


    @media only screen and (min-width: 355px) and (max-width: 500px){
      .map-container{
        height: 45vh;
      }

      .desktop-view{
        display: none !important;
      }
    }

    .notify-schedule{
      background: #fff;
      padding: 7px 18px 7px 7px;
      border-radius: 4px;
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 4;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      animation:animate 3s linear infinite;
      cursor: pointer;
    }

    .my-orders{
      background: #fff;
      padding: 7px 18px 7px 7px;
      border-radius: 4px;
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 4;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      animation:animate 3s linear infinite;
      cursor: pointer;
    }

    .my-orders i{
      font-size: 12px;
      margin-right: 5px;
    }

    .my-orders h4{
      font-size: 12px;
      font-weight: 500;
      color: #3A3A3A;
      margin-bottom: 0;
    }

    .notify-schedule h4{
      font-size: 12px;
      font-weight: 500;
      color: #3A3A3A;
      margin-bottom: 0;
    }

    .esfere-container{
      width: 15px;
      height: 15px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px;
      border: 1px solid #ddd;
      margin-right: 4px;
    }

    .esfere-container i{
      font-size: 8px;
      color: #28A745;
    }



    .access-promo{
      background: #fff;
      border: none;
      padding: 5px 15px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      position: absolute;
      bottom: 15px;
      left: 15px;
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: center;
      animation:animate 3s linear infinite;
    }

    .access-promo i{
      font-size: 15px;
      margin-right: 5px;
    }

    #carouselExampleControls{
      height: 30vh;
      /*overflow: hidden !important;*/
    }

    #carouselExampleIndicators{
      height: 30vh;
    }

    .carousel-inner{
      height: 30vh;
    }

    .carousel-item{
      width: 100%;
      height: 30vh;
    }

    @keyframes animate{
      0%{
        box-shadow: 0 0 0 0 rgba(255,255,255, .5), 0 0 0 0 rgba(255,255,255, .5);
      }
      40%{
        box-shadow: 0 0 0 13px rgba(255,255,255, 0), 0 0 0 0 rgba(255,255,255, .5);
      }
      80%{
        box-shadow: 0 0 0 13px rgba(255,255,255, 0), 0 0 0 13px rgba(255,255,255, 0);
      }
      100%{
        box-shadow: 0 0 0 0 rgba(255,255,255, 0), 0 0 0 13px rgba(255,255,255, 0);
      }
    }



    /*.img-responsive{
      width: 100%;
      object-fit: cover;
      height: 30vh;
    }*/
    @supports(object-fit: cover){
      .carousel-item img{
        width: 100% !important;
        height: 30vh !important;
        object-fit: cover;
        object-position: center center;
      }
    }

    .transfer-alert{
      width: 95%;
      padding: 8px 15px;
      text-align: left;
      display: flex;
      align-items: flex-start;
      background: red;
      margin-left: 10px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    input[type="date"].has-value{
      width: 95% !important;
      background: #fff;
    }

    input[type="date"]:not(.has-value):before{
      color: #757575;
      content: attr(placeholder);
      width: 95% !important;
    }

    .transfer-alert h4{
      font-size: 15px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 0;
    }

    .transfer-alert i{
      color: #fff;
      margin-right: 5px;
      font-size: 15px;
    }

    .back-delivery-button{
      padding: 7px 18px;
      border: 1px solid #ddd;
      background: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: fixed;
      top: 25px;
      left: 25px;
      border-radius: 7px;
      z-index: 500;
      box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    }

    .back-delivery-button h4{
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 500;
    }

    .back-delivery-button i{
      margin-right: 5px;
    }

    #main_loader{
      display: block;
      margin: 0 auto;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      border: 3px solid transparent;
      /*border-top-color: #0B9BCF;*/
      -webkit-animation: spin 2s linear infinite;
      animation: spin 2s linear infinite;
    }

    .loader-categories{
      width: 100%;
      padding: 80px 20px;
      text-align: center;
    }

    .loader-categories h4{
      padding-top: 10px;
      font-size: 15px;
      font-weight: 500;
    }

    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 64px;
      height: 64px;
      margin: 8px;
      border: 8px solid #003366;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #003366 transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .maintance{
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: url("https://info.vinapp.co/wp-content/uploads/2021/06/Hexagon.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .content-maintance{
      display: block;
      padding: 20px;
    }

    .content-maintance img{
      width: 15%;
      margin-bottom: 20px;
    }

    .content-maintance h4{
      font-family: 'Poppins', sans-serif;
      color: #5FE8CA;
    }

    .content-maintance h5{
      font-family: 'Poppins', sans-serif;
      color: #5FE8CA;
    }

    .content-maintance h4{
      font-size: 30px;
      font-weight: 600;
    }

    .products td:nth-child(1){
      position: relative;
    }

    .land-scape-eye{
      width: 5%;
      height: 30px;
      text-align: center;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
    }

    .land-scape-eye i{
      color: #fff;
      font-size: 18px;
      transform: rotate(360deg) !important;
    }

    .inventory{
      width: 100%;
      height: 30px;
      background: red;
      text-align: center;
      padding: 5px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
    }

    .inventory h4{
      color: white;
      font-size: 16px;
      font-weight: 500;
      font-family: 'Poppins', sans-serif;
      margin-bottom: 0;
    }

    .out-service-res{
      width: 100%;
      height: 100vh;
      background: #000;
      display: block;
      text-align: center;
      padding-top: 20px;
      position: absolute;
      top: 0;
      z-index: 40;
    }
    .order-out{
      width: 100%;
      height: 110vh;
      position: fixed;
      top: 0;
      z-index: 9999;
      background-color: rgba(0, 0, 0, .6);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .out-service-res svg{
      width: 40%;
      margin-top:-60px;
    }

    .out-service-res h4{
      color: #fff;
      font-size: 25px;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      margin-top: -150px;
    }

    .out-service-res h5{
      color: #fff;
      font-size: 16px;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      margin-top: 5px;
    }

    .out-service-res h2{
      color: #fff;
      font-size: 22px;
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
    }

    .out-service-res button{
      font-family: 'Poppins', sans-serif;
      font-size: 18px;
      font-weight: 500;
      border:none;
      border-radius: 8px;
      padding: 7px 25px;
      margin-top: 10px;
      margin-bottom:90px;
    } 

    #logo path:nth-child(1){
      stroke-dasharray: 4056;
      stroke-dashoffset:4056;
      animation: line_anim 3s ease forwards;
    }
    #some path:nth-child(2){
      stroke-dasharray: 321;
      stroke-dashoffset:321;
      animation: line_anim 3s ease forwards;
    }
    #some path:nth-child(3){
      stroke-dasharray: 87;
      stroke-dashoffset:87;
      animation: line_anim 3s ease forwards;
    }
    #some path:nth-child(4){
      stroke-dasharray: 124;
      stroke-dashoffset:124;
      animation: line_anim 3s ease forwards;
    }

    #some path:nth-child(5){
      stroke-dasharray: 42;
      stroke-dashoffset:42;
      animation: line_anim 3s ease forwards;
    }


    @keyframes line_anim{
      to{
        stroke-dashoffset:0;
      }
    }

    input#entrega{
      font-size: 16px;
    }
    .bank-select{
      width: 90%;
      padding: 3px;        
      background: #f3f3f3;
      border-radius: 6px;
      margin: 0 auto;
    }

    .bank-select select{
      width: 100%;
      color: #12243C;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 8px;
      padding-right: 19px;
      cursor: pointer;
      color: #757575;
      background: transparent;
      border: none;
      appearance: none;
      -webkit-appearance: none;
      background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
      background-repeat: no-repeat;
      background-size: 28px;
      background-position-x: 100%;
        background-position-y: 12px;
    }
    .btn-wonpi{
      display: inline-block;
        height: 40px;
        line-height: 40px;
        background-color: rgb(26, 69, 148);
        border: 0px;
        border-radius: 10px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
        font-size: 16px;
        padding: 0px 16px;
        color: white;
        cursor: pointer;
        -webkit-font-smoothing: subpixel-antialiased;
        width: 100%;
    }
    .btn-wonpi::before {
      content: "";
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image : url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 229.5 229.5'%3E%3Cpath fill='%23fff' d='M214.419 32.12A7.502 7.502 0 0 0 209 25.927L116.76.275a7.496 7.496 0 0 0-4.02 0L20.5 25.927a7.5 7.5 0 0 0-5.419 6.193c-.535 3.847-12.74 94.743 18.565 139.961 31.268 45.164 77.395 56.738 79.343 57.209a7.484 7.484 0 0 0 3.522 0c1.949-.471 48.076-12.045 79.343-57.209 31.305-45.217 19.1-136.113 18.565-139.961zm-40.186 53.066l-62.917 62.917c-1.464 1.464-3.384 2.197-5.303 2.197s-3.839-.732-5.303-2.197l-38.901-38.901a7.497 7.497 0 0 1 0-10.606l7.724-7.724a7.5 7.5 0 0 1 10.606 0l25.874 25.874 49.89-49.891a7.497 7.497 0 0 1 10.606 0l7.724 7.724a7.5 7.5 0 0 1 0 10.607z'/%3E%3C/svg%3E");
      background-size:contain;
      background-repeat: no-repeat;
      vertical-align: middle;
      margin-right: 8px;
      transform: translateY(-2px);
    }

    .out-service{
      border: 2px solid red;
      width: 95%;
      padding: 8px;
      background: #fff;
      margin: 0 auto;
      border-radius: 10px;
      margin-bottom: 10px;
    }

    .out-service h4{
      margin-bottom: 0 !important;
      font-weight: 500;
      font-size: 15px;
      color: red;
    }

    .container-button{
      width: 95%;
      padding: 10px 0px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }

    .send-button{
      width: 100%;
      background: #64B161;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button i:nth-child(1){
      color: #0DC142;
    }

    .send-button i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }

    .send-button2{
      width: 100%;
      background: #1A4594;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button2 label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button2 i:nth-child(1){
      color: #1A4594;
    }

    .send-button2 i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }

    .button-loading{
      width: 50px;
      height: 50px;
      border: 2px dashed #64B161;
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 1s;
    }

    .button-loading2{
      width: 65px;
      height: 65px;
      border: 2px dashed #64B161;
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 1s;
    }

    .hide{
      display: none;
    }

    .opacidad{
      opacity: .8;
    }

    .rodar{
      animation: rodar 2s linear infinite;
    }
    .rodar2{
      animation: rodar 2s linear infinite;
    }

    @keyframes rodar2 {
      100%{
        transform: rotate(360deg);
      }
    }

    @keyframes rodar {
      100%{
        transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% { 
        -webkit-transform: rotate(0deg);  /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: rotate(0deg);  /* IE 9 */
        transform: rotate(0deg);  /* Firefox 16+, IE 10+, Opera */
      }
      100%{
        -webkit-transform: rotate(360deg);  /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: rotate(360deg);  /* IE 9 */
        transform: rotate(360deg);  /* Firefox 16+, IE 10+, Opera */
      }
    }

    @media only screen and (min-width: 1280px) and (max-width: 1920px){

      .notify-schedule{
        right: 220px;
      }

      .my-orders{
        left: 220px;
      }

      .container-horario{
        width: 70%;
        margin: 0 auto;
      }

      ::-webkit-scrollbar {
        width: 5px;
        height: 6px;
        background: transparent;
      }

      ::-webkit-scrollbar-thumb{
        background: #ddd;
      }

      ::-webkit-scrollbar-thumb:hover{
        cursor: pointer;
      }


      #carouselExampleControls{
        height: 70vh;
        /*overflow: hidden !important;*/
      }

      #carouselExampleIndicators{
        height: 70vh;
      }

      .carousel-inner{
        height: 70vh;
      }

      .carousel-item{
        width: 100%;
        height: 70vh;
      }

      @supports(object-fit: cover){
        .carousel-item img{
          width: 100% !important;
          height: 70vh !important;
          object-fit: cover;
          object-position: center center;
        }
      }  

      #home{
        width: 70% !important;
        height: auto;
        margin: 0 auto;
      }
      #footer{
        width: 70% !important;
        margin: 0 auto;
      }
      .container-button{
        margin-left: 10px;
      }

      .out-service-res svg{
        width: 20%;
      }
      .order-out svg{
        width: 20%;
      }

      .out-service-res{
        width: 70%;
        margin: 0 auto;
      }
      .order-out{
        width: 70%;
        margin: 0 auto;
      }
      .landscape-image {
        height: 100vh;
        width: 70%;
        position: fixed;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99999999999999999;
        display: flex
    ;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
      }
      .landscape-inner img {
        width: 100%;
        margin-top: 5%;
        height: auto;
        opacity: 1 !important;
      }
      .close-landscape {
        position: absolute;
        top: 6%;
        right: 10px; /* Agregado para alinear a la derecha */
        z-index: 100; /* aseguramos que esté por encima de la imagen */
      }

      .close-landscape i {
        color: #fff;
        font-size: 19px;
        cursor: pointer;
        background: rgba(0, 0, 0, 0.5); /* opcional, para visibilidad */
        padding: 5px;
        border-radius: 50%;
      }

    }

    .animation{
      animation: cambiar .4s linear;
    }

    @keyframes cambiar {
      0%{
        transform: translateX(-100%);
      }
      100%{
        transform: translateX(0);
      }
    }
    .cupon-contain{
      width: 100%;
      padding-right: 20px;
      padding-left: 13px;
      display: flex;
      transition: all 3s ease-in-out;
    }

    .loading-coupon{
      width: 35%;
      text-align: center;    
      border-radius: 10px;
      padding: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loading-coupon h4{
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 0 !important;
    }

    .loading-coupon .loading-icon{
      color: #fff;
      font-size: 23px;
      animation: rotate 2s linear infinite;
    }

    .hide{
      display: none;
    }

    @keyframes rotate {
      100%{
        transform: rotate(360deg);
      }
    }

    .ocultarcupon{
      display: none;
    }

    .botonmostrar:focus{
      outline: none;
      box-shadow: none;
    }
    .div-fecha-entrega select:focus{
      outline: none !important;
      border: 1px solid skyblue !important;
    }
    .modal-dialog{
      top: 10% !important;
    }
    .name-product h3{
      font-weight: 500;
      font-size: 25px;
      letter-spacing: 2px;
    }
    .product-variants h5{
      font-size: 19px;
      font-weight: 400;
      letter-spacing: 1px;
    }
    .precio-variantes h3{
      color: #ffffff;
      font-size: 24px;

    }
    .restar{
      margin-top: -5px;
    }
    .variants-father{
      padding-left: 10px;
      padding-right: 10px;
      height: 50px !important;
    } 
    .numero-variants{
      padding-left: 15px;
      padding-right: 15px;
      text-align: center;
      line-height: 3.3em;
      vertical-align: middle;
    }
    .numero-variants label{
      color: #ffffff;
    }
    .cantidad-variants{
      font-size: 22px;
    }
    @media screen and (-webkit-min-device-pixel-ratio:0) { 
        .select-variantes select {
        background-color: white !important;
        border-color: 1px solid gray !important;
        width: 100%;
        -webkit-appearance: none;
        }
    }
    .select-variantes select:focus{
      outline: none !important;
      box-shadow: none !important;
    }
    .div-tallas{
      border: 1px solid gray;
    }
    .div-tallas:hover{
      border: 1px solid black;
    }
    .imagen-atras{
      background:url('https://back.vinapp.co/atras.png');
      background-repeat: no-repeat;
    }
    .imagen-siguiente{
      background:url('https://back.vinapp.co/siguiente.png');
      background-repeat: no-repeat;
    }
    .col-6{
      padding-right: 5px !important;
      padding-left: 5px !important;
    }

   
    @media screen and (-webkit-min-device-pixel-ratio:0) { 
        .padre-puntos select {
        background-color: white !important;
        border-color: 1px solid gray !important;
        width: 100%;
        -webkit-appearance: none;
        }
    }

    .ancho{
      padding-left: 10 !important;
      padding-right: 10 !important;
    }
    .select-icono{
      border: 1px solid black !important;
      /*background-image: url('https://static.xx.fbcdn.net/rsrc.php/v3/y1/r/wXep7WJFXEs.png');*/
      background-repeat: no-repeat;
      background-position: right;

    }
    .select2-container{
      z-index: 1 !important;
    }
    .select-icono:focus{
      outline: none;
      border: 1px solid skyblue !important;
    }
    .form-control-feedback {
    position: absolute;
    padding: 12px;
    pointer-events: none;  
    }
    .form-control-feedback-search {
    position: absolute;
    padding: 10px;
    pointer-events: none;
    margin-right: 100px !important;
    }
    .form-control-feedback-drop-down{
    position: absolute;
    padding: 10px;
    pointer-events: none;
    margin-right: 100px !important;
    }

    .izquierda{
      padding-left: 35px!important;
    }
    body{
      padding:0;
      margin:0;
    }
    .logos{
      width: 80px !important; 
      height: 80px !important;
    }
    .portadas{
      width: 100%;
      height: auto;

    }
    @supports(object-fit: cover){
      .portadas{
        height: 100%;
        object-fit: cover;
        object-position: center center;
      }
    }

    @media only screen and (min-width: 1920px){
      #footer{
       width: 66%;
      }
    }
    #footer{
      position: fixed;
      width: 100%;
      bottom: 0;
      background: #fff;
      padding: .75rem;
      z-index: 50000001;
    }
    .btn-footer{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 16px;
      font-weight: 600;
      padding-left: 18px;
      padding-right: 18px;        
      width: 100%;
      border-radius: 10px;
      padding-top: 5px;
    }
    .text-account{
      margin-left: 10px !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      color: #2C3E50
    }
    .modal-price{
      font-size: 22px;
      font-weight: 500;
    }
    .modal-header {
      border: none !important;
    }
    .modal-content {
      background-color: #ffffff !important;    
    }
    .modal-picture-img img{
      border-radius: 20px !important;
      box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.14) !important;
      animation: float 6s ease-in-out infinite;
    }  
    @keyframes float {
      0% {
        transform: translatey(0px);
      }
      50% {
        transform: translatey(-10px);
      }
      100% {
        transform: translatey(0px);
      }
    }
    .sumar-restar {
     border-radius: 50% !important;
     margin-right: 10px !important;
     padding-left: 17px !important;
     padding-right: 17px !important;
     margin-top:15px !important;
     border: 1px solid white !important;
    }
    .sumar{
      padding-top: 5px !important;
    } 

    .modal-content{
      border-radius: 20px !important;
    }
    .products td{
      padding: 5px;
    }
    .card-padre {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      /*max-width: 380px;*/   
      height: auto;
      display: inline-block;    
      text-align: left;
      font-family: arial;
      margin-left: 10px;
      display: block;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
    }
    .card-padre-ecommerce {
      width: 100% !important;
      height: auto !important;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);           
      text-align: center;
      font-family: arial;    
      display: block;    
      border-radius: 10px;
    }  
    .price {
      color: grey;
      font-size: 13px;
      margin-bottom: 0 !important;
      padding-bottom: 10px;
    }
    .description{
       color: grey;
       font-size: 12px;
    }
    .card-padre button {
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 12px;
      font-weight: 600;
      padding-left: 25px;
      padding-right: 25px;
      padding-top: 7px;
      padding-bottom:7px;
      border-radius: 18px;
    }
    .boton-detalle{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 16px;
      font-weight: 600;
      padding-left: 16px;
      padding-right: 16px;
      padding-top: 7px;
      padding-bottom:7px;
      font-family: FontAwesome;
      font-family: "Font Awesome 5 Free";
      border-radius: 10px;    
    }  
    .boton-detalle-variant{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 16px;
      font-weight: 600;
      padding-left: 25px;
      padding-right: 25px;
      padding-top: 7px;
      padding-bottom:7px;
      font-family: FontAwesome;
      font-family: "Font Awesome 5 Free";
      border-radius: 20px;    
    } 
    .boton-detalle-variant2{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;        
      border-radius: 50px;    
    }  
    .boton-pedido{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 13px;
      font-weight: 400;
      padding-left: 25px;
      padding-right: 25px;
      padding-top: 7px;
      padding-bottom:7px;
      font-family: FontAwesome;
      font-family: "Font Awesome 5 Free";
      border-radius: 10px;    
    }  
    .boton-pedido-auto{
      border: none;
      outline: 0;    
      color: white;    
      text-align: center;
      cursor: pointer;    
      font-size: 13px;
      font-weight: 400;
      padding-left: 32px;
      padding-right: 20px;
      padding-top: 7px;
      padding-bottom:7px;
      font-family: FontAwesome;
      font-family: "Font Awesome 5 Free";
      border-radius: 10px;    
    }
    .boton-pedido:focus{
      outline: none;
      box-shadow: none;
    }
    .boton-pedido-auto:focus{
      outline: none;
      box-shadow: none;
    }
    input#nombre{
      width: 95% !important;
    }
    input#telefono{
      width: 95% !important;
    }
    input#nacimiento{
      width: 95% !important;
    }
    input#cedula{
      width: 95% !important;
    }
    input#email{
      width: 95% !important;
    }
    input#barrio{
      width: 95% !important;
    }
    input#how-pay{
      width: 95% !important;
    }
    input#direccion_pedido{
      width: 95% !important;
    }
    textarea#comentario{
      width: 95% !important;
    }
    select#punto{
     width: 95% !important; 
    }
    div#datos-personales input,textarea, select{
      padding: 8px;
      border-radius: 5px;
      border: 1px solid gray;    

    } 
    div#datos-personales-edit input,textarea, select{
      padding: 8px;
      border-radius: 5px;
      border: 1px solid gray;    

    }  
    .div-titulo{
      justify-content: center !important;
      text-align: center !important;
      padding-left: 5px;
    }
    #titulo{
      text-align: left !important;
      font-size: 24px;
      font-weight: 600;

    }  
    #titulo1{
      text-align: left !important;
      font-size: 16px;
      font-weight: 600;

    }  
    input#nombre:focus{
      border: 1px solid skyblue;
    }
    input#telefono:focus{
      border: 1px solid skyblue;
    }
    input#cedula:focus{
      border: 1px solid skyblue;
    }
    input#email:focus{
      border: 1px solid skyblue;
    }
    input#barrio:focus{
      border: 1px solid skyblue;
    }
    input#how-pay:focus{
      border: 1px solid skyblue;
    }

    input#direccion_pedido:focus{
      border: 1px solid skyblue;
    }
    textarea#comentario:focus{
      border: 1px solid skyblue;
      outline: 0px !important;
    }

    select#punto:focus{
      border: 1px solid skyblue; 
    }


    .card-padre button:hover {
      opacity: 0.7;
    }
    .card-body{
      padding: 0 !important;
      padding-top: 10px !important;
    }

    .descripcion{
      margin-top: -15px;
    }

    .ios-notify{      
      background-color: #1D8BFA;
      color: white;     
      width: 90%;
      margin-left: 18px;
      border-radius: 15px;
      position: fixed !important;    
      margin-bottom: 0 !important;            
      padding-left: 40px !important;          
      padding-right: 40px !important;
      bottom: 10px;    
      height: 160px;   
      padding-bottom: 40px !important;
      text-align: left;
    }  
    .abajo-izquierda:before {
        content: "";
        position: absolute;
        bottom: -15px;
        text-align: center;
        left: 0;
        right: 0;
        margin: auto;
        width: 0;
        height: 0;
        border-width: 25px 25px 0;
        border-style: solid;
        border-color: #1D8BFA transparent transparent;
           
      }
      .info{          
        font-size: 16px;
        font-weight: 600;   
         
      }
      .equis{
        font-size: 24px;
        font-weight: 600;
        text-align: right !important;
        line-height: 10px;
        padding-top: 15px;
      }


    .error-info{
      background: #fff;
      width: 50%;
      margin: 0 auto;
      padding-top: 20px;
      text-align: center;
      display: block;
      border-radius: 10px;
    }

    .error-info h4{
      font-family: 'Poppins', sans-serif;
      font-size: 18px;
      font-weight: 500;
      padding-top: 14px;
    }

    .error-info button{
      width: 100%;
      border-bottom: none;
      border-left: none;
      border-right: none;
      background: transparent;
      border-top: 1px solid #E8E8E8;
      margin-top: 10px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-family: 'Poppins', sans-serif;
    }

    .canceled-info{
      background: #fff;
      width: 80%;
      margin: 0 auto;
      padding-top: 20px;
      text-align: center;
      display: block;
      border-radius: 10px;
    }

    .canceled-info h4{
      font-family: 'Poppins', sans-serif;
      font-size: 17px;
      font-weight: 500;
      padding-top: 14px;
    }

    .canceled-info button{
      width: 100%;
      border-bottom: none;
      border-left: none;
      border-right: none;
      background: transparent;
      border-top: 1px solid #E8E8E8;
      margin-top: 10px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-family: 'Poppins', sans-serif;
    }

    .exit-options{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  </style>


<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { printUSB } from "./util/print-web.js";
import Vue from 'vue'
import Vuesax from 'vuesax'
//import axios from 'axios';
import axios from '@/config/axios';
import { osName } from 'mobile-device-detect';
import moment from 'moment'
//import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import AddNewDataSidebar from './sidebar';
import LoaderPayment from './LoaderPayment.vue';
import LoaderVideo from './LoaderVideo.vue';
import PrintPage from './PrintPage.vue';
import Ecommerce from './Ecommerce';
import $ from 'jquery';
import lazyload from '../directives/lazyload';
import OrderDetail from './OrderDetail';
import Mensajeria from './Mensajeria.vue';
import FinishOrder from './FinishOrder.vue';
import FinishOrderNequi from './FinishOrderNequi.vue';
import FinishOrderDaviplata from './FinishOrderDaviplata.vue';
import OrderTracking from './OrderTracking.vue';
import DeliveryApp from './DeliveryApp.vue';
import OrderManagment from './OrderManagment.vue';
import DeliveryLogin from './DeliveryLogin.vue';
import DeliveryCheckout from './DeliveryCheckout.vue';
import JQuery from 'jquery';
//import Schedule from './Schedule.vue';
//import Linktree from './Linktree.vue';
import LoginMain from './LoginT.vue';
import LoginKeyboard from './LoginKeyboard.vue';
import TableWaiters from './TableWaiters.vue';
//Vue.use(DateTimePickerPlugin);
Vue.use(DatePickerPlugin);
import 'vuesax/dist/vuesax.css' //Vuesax styles
import vSelect from 'vue-select';
  Vue.use(Vuesax, {
    // options here
})
let installEvent;
export default {
  name: 'Home',
  metaInfo: {
      title: 'My Awesome Webapp',
  },
  components: {
    PrintPage,
    LoaderPayment,
    LoaderVideo,
    LoginMain,
    HelloWorld,
    AddNewDataSidebar,
    Ecommerce,
    OrderDetail,
    Mensajeria,
    FinishOrder,
    FinishOrderNequi,
    FinishOrderDaviplata,
    OrderTracking,
    DeliveryApp,
    OrderManagment,
    DeliveryLogin,
    DeliveryCheckout,
    vSelect,
    LoginKeyboard,
    TableWaiters,
    /*Linktree,
    Schedule*/
  },
  data() {
    return {
      reset_page: false,
      id_point_waiter: localStorage.getItem('id_point_waiter'),
      id_company: localStorage.getItem('id_company'),
      popupActivoModeMesero: false,
      orderExistSelected: null,
      login_with_pin: true,
      active_login_with_pin: false,
      print_waiter_bill:false,
      show_table_name: localStorage.getItem('show_table_name') === 'true' || localStorage.getItem('show_table_name') === true,
      multiply_addition_product:false,
      waiters: [],
      active_login: false,
      select_waiters: false,
      payonlineaddress: false,
      kiosko_dataphone: false,
      show_category_kiosko:false,
      companie_decimales: false,
      selectedDevice: null,
      license: null,
      mediaUrl: '',
      print_page:false,
      await_payment:false,
      status_qr_bancolombia: false,
      loader_video:false,
      kiosko: false,
      mode_mesa: false,
      id_point_companie: null,
      incremento_datafono_companie: 0,
      incremento_datafono: 0,
      delete_product_waiter:false,
      edit_tables_waiter:true,
      change_table_waiter: true,
      edit_other_table:true,
      observacion_xproducto: false,
      mesas_ocupadas: '',
      rawCategories: "",
      barrio_selected : "",
      companiesFormNewClient: localStorage.getItem(`companies_form_new_client`) ? JSON.parse(localStorage.getItem('companies_form_new_client')) : [],
      showSelectTable: false,
      mesaSelected: null,
      print_comanda_mesero: false,
      loginStatus:false,
      activeLogin:false,
      point_selected: 0,
      months: [
        {text:"Enero", value:1}, {text:"Febrero", value:2}, {text:"Marzo", value:3}, {text:"Abril", value:4}, {text:"Mayo", value:5}, {text:"Junio", value:6}, {text:"Julio", value:7}, {text:"Agosto", value:8}, {text:"Septiembre", value:9}, {text:"Octubre", value:10}, {text:"Noviembre", value:11}, {text:"Diciembre", value:12}
      ],
      logo_company: '',
      formEditClient:{
        id_order: '',
        name:'', 
        cedula:'', 
        nit:'', 
        phone:'', 
        address:'', 
        barrio:'', 
        email:'',
        date_born:'Fecha de Cumpleaños',
      },
      formEdit:{
        nombre_mesero:'',
        valor_forma_pago:0,
        percentage_service:0,
        type_service:'Valor',
      },
      validateformNewClient:false,
      editMeseroModal:false,
      errorMesaModal:false,
      errorProductModal:false,
      editMesaModal:false,
      editProductModal: false,
      editServiceModal:false,
      editPayModal:false,
      editObsModal:false,
      botonDeshabilitado:false,
      listFormaPago:[{id:37,value:'Efectivo', cantidad: 0},{id:38,value:'Transferencia', cantidad: 0},{id:39,value:'Datáfono', cantidad: 0},{id:141,value:'Nequi', cantidad: 0},{id:126,value:'Bancolombia', cantidad: 0},{id:128,value:'Daviplata', cantidad: 0},{id:148,value:'Rappi', cantidad: 0},{id:76,value:'Pago en linea', cantidad: 0}],
      botones:null,
      confirmPrintModal:false,
      editClientModal:false,
      formNewClientModal:false,
      confirmPrintModalCash:false,
      ordersTables:[],
      mesaTimers: {},
      timerInterval: null,
      view_other_tables:false,
      nombre_mesero:null,
      valNequiPayment: "",
      valTarjetaPayment: "",
      exit_component:false,
      mesaMesero:0,
      v_restar_producto: true,
      id_order_bot:null,
      valida_mesa:false,
      mesas_cache:[],
      valida_stock:false,
      exit_component_2:false,
      exit_component_3:false,
      status_landscape: false,
      img_landscape:'',
      validacionMonto:false,
      mapLatitude: "",
      mapLongitude: "",
      individual_addition: false,
      priority_shipping: false,
      pay_epayco: false,
      auto_take_delivery:false,
      tr_priority_shipping: false,
      value_priority_shipping: "",
      rodar_contador: 0,
      view_mobile: false,  
      olayaPark: false,
      bank_type:0,
      bank_name:"",
      input_nit:false,
      cedulaBlocked:false,
      nitBlocked:false,
      activate_observation:true,
      texto:"",
      product_list: [],
      product_list_aux: [],
      enable_waiter_print:false,
      activate_pick_it_up: false,
      old_price_status: false,
      status_close_schedule: true,
      pedidos_fuera_horario: false,  
      schedule_closed: false,
      schedule_list: [],
      schedule_state: false,
      open_schedule: false,
      mesaDomicilio: false,
      status_seguimiento: true,
      desktop_main_view: false,
      letter_main_view:false,
      category_desktop:0,
      primer_array: [],
      segundo_array: [],  
      style1: false,
      style2: false,
      delivery_time: false,  
      default_categorys: false,
      filter_option: false,
      status_delivery_checkout: false,
      status_delivery_login: false,
      seguimiento_pedido_wpp: false,
      wa_redirect: false,
      wa_redirect_auto: false,
      status_managment: false,
      status_contraentrega:false,
      out_zone: false,
      id_zone: 0,
      zone_name: "",
      zone_cost: 0, 
      empty_map_fields: false,
      status_current_position: false,
      map_contador: 0, 
      place_aux:"",
      actual_ubication: "Calculando...",  
      status_map: true,
      visible_map: false,
      banner_promo_status: false,
      portadas_promo: [],  
      transfer_support: false,
      delivery_app: false,
      restaurant_list: [],  
      status_delivery: false,
      info_delivery: {},
      mesas: [],
      mesero: false,
      portPrint: null,
      portDashboard: null,
      socketUnified: false,
      custom_quantity: false,  
      categoriesDone: false,  
      unitys: 0,
      inventory_day: false,
      status_tracking: false,
      //id_tracking: localStorage.getItem(`id_estado_order`) ? localStorage.getItem('id_estado_order') : "",
      mantenimiento: false,
      currency: "COP",
      finishOrder: false,
      finishOrderNequi: false,
      finishOrderDaviplata: false,
      finish_order: true,
      close_store_text: "",  
      close_store: true,
      seguimiento_pedido: false,
      combination_default_first: false,
      delivery_message: false,
      status_message: false,
      data_message:{},  
      couponSuccess: false,
      couponError: false,
      couponText: '',
      store: {},
      valHowPay:"",
      howPay: false,
      data: {},
      addNewDataSidebar: false,
      Ecommerce: false,
      order_detail: false,
      objProductSidebar:"",
      priority:false, 
      minutos: 60,           
      waterMark : 'Seleccione fecha de entrega.', 
      dateFormat : 'yyyy-MM-dd',
      dateVal : moment().format('YYYY-MM-DD'),    
      minDate : moment().format('YYYY-MM-DD'),    
      statusCedula: false,
      statusNacimiento: false,
      statusEmail: false,
      statusFecha: false,
      statusBarrio: false,
      varianteColor: false,
      varianteTalla: false,
      arrayPrices:[],
      arrayCombinaciones:[],
      nameVariantEcommerce: "",
      statusTalla: false,
      statusColor: false,
      countVariants: 0,
      jornada: false,
      horarios: [],
      coupons: false,
      textCoupon: "",
      autoservicio: false,
      formasPago:[
        {id: 37, text: 'Efectivo'},
        {id: 38, text: 'Transferencia'},
        {id: 39, text: 'Datáfono'},
        {id: 76, text: 'Pago en linea'},
        {id: 141, text: 'Nequi'},
        {id: 126, text: 'Bancolombia'},
        {id: 128, text: 'Daviplata'},
      ],
      diasSemana:[
        {id:42 , text: 'Lunes'},
        {id:43 , text: 'Martes'},
        {id:44 , text: 'Miercoles'},
        {id:45 , text: 'Jueves'},
        {id:46 , text: 'Viernes'},
        {id:47 , text: 'Sabado'},
        {id:48 , text: 'Domingo'}
      ],
      cash:false,
      transfer:false,
      dataphone:false,
      showInstallBanner: false,
      points: [],
      punteroMapaDomicilio:false,
      countOrderProcess:0,
      loading: true,
      nameOS: osName,
      browser:"",
      company : "",
      categories: [],
      visible_barrio: false,
      barrios_listado:[],
      validacion_barrio:false,
      activar_barrio:false,
      categories_aux:[],
      categories_axios: [],
      carrito : [],
      domicilio: 0,
      url_images: process.env.VUE_APP_API_URL + "/",
      logos: [
        `${process.env.VUE_APP_API_URL}/logo.jpg`,
        `${process.env.VUE_APP_API_URL}/logo.jpg`,
        `${process.env.VUE_APP_API_URL}/logo.jpg`
      ],
      splash: [],
      portadas: ['portada.jpg','portada.jpg','portada.jpg'],
      color_botones :"",
      color_letra : "",
      total: 0,
      total_productos: 0,
      estado_domicilio : true,
      estado_domicilio_mesero : false,
      mensaje:"",
      telefono_pedidos:"",
      direccion: "",
      horario: "",
      descripcion: "",
      items:0,
      companie_name: "",
      statusValidation: false,
      seguimiento_id_companie: localStorage.getItem('id_company'),
      id_punto_mesero: localStorage.getItem('punto'),
      form :{
        nombres: '',
        cedula: "",
        fecha_nacimiento: "",
        id_user_mesero: localStorage.getItem('id_user_mesero'),
        fecha_nacimiento_dia: localStorage.getItem(`fecha_nacimiento_dia`) ? localStorage.getItem('fecha_nacimiento_dia') : null,
        fecha_nacimiento_mes: localStorage.getItem(`fecha_nacimiento_mes`) ? localStorage.getItem('fecha_nacimiento_mes') : null,
        email: "",          
        barrio: "",          
        telefono: '',
        direccion: '',
        nombre_mesero:'',
        comentario: '',
        id_companie:'',
        nit:'',
        mesa: 0,
        id_point:0,
        latitude: 'No',
        longitude: 'No',
        id_type_forma_pago: 0,
        descuento: 0,
        id_coupon: "",
        type_document:"CC",
        documento:"",
        wp_reference: "",
        id_type_platform_delivery: 0,
        name_point: "",
      },
      modal:{
        id_product : '',
        description: '',
        price : 0,
        priceaux : 0,
        name : '',
        img1: 'No-image-available.png',
        img2: 'No-image-available.png',
        img3: 'No-image-available.png',
        cantidad : 0,
        variantes: [],
        variant_detail: [],
        variant_combination: [],
        combination: '',
        statusCombination: false
      },
      coupon:{
        id_companie: "",
        id_coupon: "",
        coupon: "",
        phone: "",
        total: "",
        cart: []
      },
      formaEntrega:{
        domicilio: true,
        recogerlo: false,
        mesas: false
      },
      banks: [],
      categorySelected: [],
      namePoint: '',
      errorupdatetable: '',
      errorupdateproduct: '',
      telefonoPuntoPrincipal:'',
      banderaMesaMultiPuntos:true,
      multipuntos: false,
      idPuntoPrincipal:'',
      optMesa:false,
      optLocal:false,
      checkout: false,        
      formPay:{
        id_order: false,
        payOnline: false,
        wompiPublicKey: '',
        wompiCurrency: '',
        wompiReference: '',
        redirectUrl: ''
      },
      dateCalendar: "",
      horarioEntrega: "AM",
      managmentTable: false,
      socketTable: "",
      socketPrint: "",
      numberAccount: false,
      addressIncluded: false,
      submitSaveOrder: true,
      idTransactionOnline: null,
      tablesUsed: [],
      changeProduct:{
        id_order: '',
        id_order_detail: '',
        new_id_order: '0'
      },
    }
  },
  directives:{
    lazyload
  },
  watch:{

    'addNewDataSidebar':function(val){
      if(!val && this.kiosko){
        location.href = '#kiosko_products';
      }
    },
    
    'form.direccion': function(newDireccion, oldDireccion) {
      // Verificar si ya se ha seleccionado un barrio
      if (this.form.barrio === null) {
        // Actualizar el modelo del barrio solo si aún no se ha seleccionado
        this.form.barrio = ""; // O el valor predeterminado que desees
      }
    },
    valHowPay : function(val){
      if (this.currency == "COP" && !this.companie_decimales) {
        val = val.toString().replaceAll('.','');
        if(val!="") this.valHowPay = new Intl.NumberFormat("de-DE").format(val);
      }
    },
    horarioEntrega: function(val){      
      this.verifyHorarioEntrega(val)
    },
    'formEdit.valor_forma_pago': function(){
      this.calcularValor();
    },
    "formEdit.percentage_service":function(val){
      if(val!=0 && val!=null){
          const subtotal = parseFloat(this.formOrder.total)-parseFloat(this.formOrder.service)
          this.formEdit.service=parseFloat((this.formEdit.percentage_service)/100)*parseFloat(subtotal);
      }
    },
  },
  computed: {
    filteredPoints() {
      if (!this.multipuntos) return [];

      const tipo = this.formaEntrega;
      let filtro = () => false;

      if (tipo.domicilio) filtro = p => p.domicilios == 1;
      if (tipo.recogerlo) filtro = p => p.recogidas == 1;
      if (tipo.mesas) filtro = p => p.mesas == 1;

      return this.points.filter(filtro);
    },
    daysInMonth() {
      // Lógica para obtener los días en función del mes seleccionado
      const daysInMonth = new Date(
        new Date().getFullYear(),
        this.form.fecha_nacimiento_mes,
        0
      ).getDate();
      return Array.from({ length: daysInMonth }, (_, index) => index + 1);
    }
  },
  methods:{
    async resetForm() {
      console.log('resetform');
      this.reset_page = true;
      if(location.pathname.includes('punto=')){
    
        const pathname = location.pathname;
        const regex = /punto=([^\/]*)/;
        const match = pathname.match(regex);
        if (match && match[1]) {
          const puntoValue = match[1];
          this.id_point_companie = puntoValue;
          this.$route.params.mesa = undefined;
          this.$route.params.punto = puntoValue;

          const regexMesa = /punto=[^\/]*\/([^\/]*)/;
          const matchMesa = pathname.match(regexMesa);
          if (matchMesa && matchMesa[1]) {
            this.$route.params.mesa = matchMesa[1];
          }
        }
      }
      document.getElementById("datos-personales").style.display = "none";  
      this.exit_component_2 = false;
      this.exit_component_3 = false;
      this.carrito = [];
      this.submitSaveOrder = true;
      this.form = {
        nombres: '',
        cedula: '',
        fecha_nacimiento: '',
        id_user_mesero: localStorage.getItem('id_user_mesero'),
        fecha_nacimiento_dia: localStorage.getItem('fecha_nacimiento_dia') ? localStorage.getItem('fecha_nacimiento_dia') : null,
        fecha_nacimiento_mes: localStorage.getItem('fecha_nacimiento_mes') ? localStorage.getItem('fecha_nacimiento_mes') : null,
        email: '',          
        barrio: '',          
        telefono: '',
        direccion: '',
        nombre_mesero: '',
        comentario: '',
        nit: '',
        mesa: 0,
        id_point: 0,
        latitude: 'No',
        longitude: 'No',
        id_type_forma_pago: 0,
        descuento: 0,
        id_coupon: '',
        type_document: 'CC',
        documento: '',
        wp_reference: '',
        id_type_platform_delivery: 0,
        name_point: ''
      };
      await this.setupCompanie();
      this.showProductos();
    },


    async loadPrinter() {
      const printerData = localStorage.getItem('selectedPrinter');
      if (printerData) {
        const { vendorId, productId } = JSON.parse(printerData);

        try {
          const devices = await navigator.usb.getDevices();
          const matchedDevice = devices.find(
            (device) =>
              device.vendorId === vendorId && device.productId === productId
          );

          if (matchedDevice) {
            this.selectedDevice = matchedDevice;
          } else {
          }
        } catch (error) {
        }
      } else {
      }
    },

    finishLoaderPayment(status = false){
      // this.await_payment = false;
      if(status == true){
        this.saveDocument(this.formOrder)
      }else{
        alert("PAGO RECHAZADO POR FAVOR CREE UNA NUEVA ORDEN");
      }
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
    finishSelectWaiterTable(form = null){
      if(form){
        this.nombre_mesero = form.nombre_mesero;
        this.form.nombre_mesero = form.nombre_mesero;
        this.form.id_user_mesero = form.id_user_mesero;
        this.id_punto_mesero = form.punto;
        this.getTablesByMesero();
        this.form.mesa = form.tableselected;
        this.orderExistSelected = form.order_selected;
        this.popupActivoModeMesero = false;
        this.login_with_pin = false;
        if(form.edit_table){
          this.mesaMesero = this.ordersTables.find(m => m.id_order === form.order_selected.id_order);
          this.getOrderDetail(form.order_selected.id_order);
        }
        this.active_login_with_pin = true;
      }else{
        localStorage.clear();
        location.reload();
      }

    },
    finishLoaderVideo(status = false){
      this.loader_video = false;
      
    },
    async openEditMesaModal(){
      const id_point_waiter = localStorage.getItem('id_point_waiter');
      await this.getUsedTables(id_point_waiter);
      // Asegurar que show_table_name esté actualizado desde localStorage y convertido a booleano
      const storedValue = localStorage.getItem('show_table_name');
      this.show_table_name = storedValue === 'true' || storedValue === true;
      await this.$nextTick();
      this.editMesaModal = true;
    },
    print(){ //PARA REALIZAR PRUEBAS
			var data = {
				"error": false,
				"message": "OK",
				"data": {
					"copy": false,
					"num_copy_comanda": 0,
					"id_order": "4974754",
					"id_company": 7703,
					"account_status": true,
					"id_point": 1139,
					"commentary": "",
					"is_print": true,
					"valor_forma_pago": "$325.046",
					"valor_forma_pago_secundaria": "$0",
					"id_company_print": 7703,
					"nit": "900557875-3",
					"fecha_entrega": null,
					"vendedor": null,
					"id_type_platform_delivery": 154,
					"id_locator": null,
					"logo_company_print": "https:\/\/back.vinapp.co\/store\/200x11786467-2024-05-09-14-22-45.jpg",
					"document_date": "2024-09-19 14:13",
					"text_final": "Esta factura de venta se asimila en sus efectos a la letra de cambio (ART. 621 Y 774 de C.C)",
					"type_forma_pago": "Dat\u00e1fono:",
					"business": "Vicente Asiatico Parrilla SAS",
					"nit_business": "Nit: 901822126-5",
					"point": "Vicente Asiatico Parrilla SAS",
					"mesero": "ANGIE MOLH",
					"city_point": "Ciudad: VALLEDUPAR",
					"address_point": "Direccion: Carrera 6 12 05 Parque Novalito",
					"phone_point": "Telefono: 3016683586",
					"resolution": "Resolucion:18764070474531",
					"document_number": "FE640 | Comanda: 3",
					"invoice_number": "FE640",
					"tascode": "57410a4528af88cc2a329dd7f28ff26885d55776d035d982736dbfb74b7e1460aae26e699539c466899ffed104ff384f",
					"client_name": "NOVO NORDISK COLOMBIA S.A.S",
					"client_phone": "3149990",
					"client_address": "Bogota",
					"client_identification": null,
					"client_neighborhood": "No definido",
					"table": 13,
					"details": [
						{
							"id_detail": 9056658,
							"product_invoice": "Soda Hatsu  (2x Rosas y frambuesas)",
							"product": "Soda Hatsu  (2x Rosas y frambuesas)",
							"quantity": 2,
							"value": "$18.000",
							"name_combination": "",
							"additions": " (2x Rosas y frambuesas)"
						},
						{
							"id_detail": 9056971,
							"product_invoice": "Soda Hatsu  (1x Rosas y frambuesas)",
							"product": "Soda Hatsu  (1x Rosas y frambuesas)",
							"quantity": 1,
							"value": "$9.000",
							"name_combination": "",
							"additions": " (1x Rosas y frambuesas)"
						},
						{
							"id_detail": 9057164,
							"product_invoice": "Black Burguer",
							"product": "Black Burguer",
							"quantity": 1,
							"value": "$35.000",
							"name_combination": "",
							"additions": ""
						},
						{
							"id_detail": 9057165,
							"product_invoice": "Adicion Black Burguer x1",
							"product": "Adicion Black Burguer x1 ...        ",
							"quantity": 1,
							"value": "$17.500",
							"name_combination": "",
							"additions": ""
						},
						{
							"id_detail": 9057166,
							"product_invoice": "Rock Shirmp",
							"product": "Rock Shirmp",
							"quantity": 1,
							"value": "$37.000",
							"name_combination": "",
							"additions": ""
						},
						{
							"id_detail": 9057454,
							"product_invoice": "Salmon Al Ajillo  (1x Ensalada )",
							"product": "Salmon Al Ajillo  (1x Ensalada )",
							"quantity": 1,
							"value": "$64.000",
							"name_combination": "",
							"additions": " (1x Ensalada )"
						},
						{
							"id_detail": 9057455,
							"product_invoice": "Lomo Chimichurri Asiatico  (1x Vegetales Salteados )",
							"product": "Lomo Chimichurri Asiatico  (1x Vegetales Salteados )",
							"quantity": 1,
							"value": "$50.000",
							"name_combination": "",
							"additions": " (1x Vegetales Salteados )"
						},
						{
							"id_detail": 9057456,
							"product_invoice": "Vicente Roll",
							"product": "Vicente Roll",
							"quantity": 1,
							"value": "$46.000",
							"name_combination": "",
							"additions": ""
						},
						{
							"id_detail": 9058145,
							"product_invoice": "Cafe",
							"product": "Cafe",
							"quantity": 3,
							"value": "$21.000",
							"name_combination": "",
							"additions": ""
						}
					],
					"bebidas": [],
					"comandas": [],
					"shipping": "$0",
					"service": "(10%) $27.546",
					"subtotal": "$297.500",
					"impuesto_consumo": "$22.037",
					"subtotal_without_imp": "$275.463",
					"total_discount": "$0",
					"os": "Windows",
					"value_paid_through_rappi": "$0",
					"value_to_be_charged_rappi": "$0",
					"user_service_fee": "$0",
					"total_dinamico": 325046,
					"total": "$325.046",
					"vueltos": "",
					"pay_with": "",
					"payment_methods": "Datafono",
					"type_order": "table",
					"comanda": "3",
					"comanda2": "",
					"rango_resolucion": "",
					"type_print": "factura-domicilio",
					"qr": "",
					"qr_fac": "https:\/\/admin.vinapp.co\/QR_Fac\/qr_fac3_20_00:51:23_4974754.png"
				}
			}

			this.printImin(data.data)
		},
		printImin(data) {
			var IminPrintInstance = new IminPrinter();
			IminPrintInstance.connect().then(async (isConnect) => {
				if (isConnect) {

					//FACTURA
					IminPrintInstance.setAlignment(1);
					IminPrintInstance.printSingleBitmap(`${data.logo_company_print}`)
					IminPrintInstance.printText(`${data.business}`);
					IminPrintInstance.printText(`${data.nit_business}`);
					IminPrintInstance.printText(data.city_point);
					IminPrintInstance.printText(data.phone_point);
					IminPrintInstance.printText(data.address_point);
					IminPrintInstance.printText('');
					
					IminPrintInstance.setAlignment(0);
					if(data.document_number.includes('FE')){
						IminPrintInstance.printText(`Estado de Cuenta: ${data.document_number}`);
					}else{
						IminPrintInstance.printText(`Factura Venta Nº: ${data.document_number}`);
					}
					IminPrintInstance.printText(`Fecha: ${data.document_date}`);
					if(data.mesero != null){
						IminPrintInstance.printText(`Mesero: ${data.mesero}`);
					}

					IminPrintInstance.printText(`Nombre: ${data.client_name}`);
					if(data.client_identification == null){
						if(data.nit != null)IminPrintInstance.printText(`Cédula: ${data.nit}`);
					}else{
						IminPrintInstance.printText(`Cédula: ${data.client_identification}`);
					}
					
					IminPrintInstance.printText(`Teléfono: ${data.client_phone}`);
					//IminPrintInstance.printText(`Dirección: ${data.client_address}`);
					if(data.table>0)IminPrintInstance.printText(`Mesa: ${data.table}`);

					
					IminPrintInstance.printColumnsText(["Descripción", "Cant", "Valor"], [318, 129, 129], [0, 0, 2], [28, 28, 28], 576);

					data.details.forEach(item => {
						IminPrintInstance.printColumnsText([item.product_invoice, item.quantity, item.value], [318, 129, 129], [0, 0, 2], [28, 28, 28], 576);
					});
					
					IminPrintInstance.printColumnsText(["Subtotal:", data.subtotal], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Domicilio:", data.shipping], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Descuento:", data.total_discount], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Servicio Voluntario:", data.service], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Impuesto de consumo:", data.impuesto_consumo], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Forma de pago:", data.payment_methods], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.printColumnsText(["Total:", data.total], [346, 230], [2, 2], [28, 28], 576);
					IminPrintInstance.setAlignment(1);
					IminPrintInstance.printText('');

					IminPrintInstance.printText(`${data.text_final}`);
					if (data.qr_fac) {
						IminPrintInstance.printQrCode('https://admin.vinapp.co/fe-vinapp/'+data.id_order, 1); 
					}
					IminPrintInstance.printText('¡Gracias por su compra!');
					IminPrintInstance.printText('NIT. 901504327');
					IminPrintInstance.printText('Impreso por Vinapp');
					IminPrintInstance.printAndFeedPaper(100);
					IminPrintInstance.partialCut();

					//FIN FACTURA
				}
        
			});
      
		},
    

    async modalEditProductActive(item){
      const id_point_waiter = localStorage.getItem('id_point_waiter');
      await this.getUsedTables(id_point_waiter);
      // Asegurar que show_table_name esté actualizado desde localStorage y convertido a booleano
      const storedValue = localStorage.getItem('show_table_name');
      this.show_table_name = storedValue === 'true' || storedValue === true;
      await this.$nextTick();
      this.editProductModal = true;
      this.changeProduct.id_order = item.id_order;
      this.changeProduct.id_order_detail = item.id_order_detail;
    },
    updateTable() {
      axios
        .get('/api/update-table-order/' + this.formOrder.id_order + "/" + this.form.mesa)
        .then(res => {
          if (res.data.statusCode == 200) {
            this.getOrderDetail(this.mesaMesero.id_order);
            this.getTablesByMesero()
              .then(() => {
                // Asegurar que mesaMesero tenga un valor válido
                let nuevaMesa = this.ordersTables.find(m => m.id_order === this.formOrder.id_order);
                this.mesaMesero = nuevaMesa ? nuevaMesa : null;
              });
            this.editMesaModal = false;
          } else {
            this.errorMesaModal = true;
            this.errorupdatetable = res.data.statusText;
          }
        })
        .catch(err => {
          console.error("Error al actualizar la mesa:", err);
        });
    },
    validateChangeProductTable(){

      if(this.changeProduct.new_id_order == '0' || this.formOrder.id_table == this.changeProduct.new_id_order ){
        this.errorProductModal=true;
        this.errorupdateproduct = 'Debe seleccionar una mesa válida o diferente a la actual';
        return;
      }

      var validate_order = this.mesas_ocupadas.find(item => item.id_table == this.changeProduct.new_id_order);

      if(validate_order){
        this.changeProduct.new_id_order = validate_order.id_order;
        this.updateProductTable();
      }else{
        this.createOrder();
      }
    },
    updateProductTable(){
      axios
          .post('/api/update-product-order', this.changeProduct)
          .then(res=>{
            if(res.data.statusCode == 200){
                this.getOrderDetail(this.changeProduct.id_order)
                this.getTablesByMesero()
                  .then(() => {
                    // Asegurar que mesaMesero tenga un valor válido
                    let nuevaMesa = this.ordersTables.find(m => m.id_order === this.formOrder.id_order);
                    this.mesaMesero = nuevaMesa ? nuevaMesa : null;
                  });
                this.editProductModal=false;
              }else{
                this.errorProductModal=true;
                this.errorupdateproduct = res.data.statusText;
              }
          }).catch(()=>{
          })
    },
    createOrder(){

      axios
          .post('/api/create-product-order', this.changeProduct)
          .then(res=>{
            if(res.data.statusCode == 200){
                
                this.getOrderDetail(this.changeProduct.id_order)
                this.getTablesByMesero()
                  .then(() => {
                    // Asegurar que mesaMesero tenga un valor válido
                    let nuevaMesa = this.ordersTables.find(m => m.id_order === this.formOrder.id_order);
                    this.mesaMesero = nuevaMesa ? nuevaMesa : null;
                  });
                this.getUsedTables(this.formOrder.id_point);
                this.editProductModal=false;
              }else{
                this.errorProductModal=true;
                this.errorupdateproduct = res.data.statusText;
              }
          }).catch(()=>{
          })
    },
    saveFormNewClient(){
      if(this.form.nombres != null && this.form.nombres != '' && this.form.telefono != null && this.form.telefono != ''){

        if(this.form.fecha_nacimiento_mes.toString().length<2)this.form.fecha_nacimiento='2023-0'+this.form.fecha_nacimiento_mes+'-'
        else this.form.fecha_nacimiento='2023-'+this.form.fecha_nacimiento_mes+'-'

        if(this.form.fecha_nacimiento_dia.toString().length<2)this.form.fecha_nacimiento+='0'+this.form.fecha_nacimiento_dia
        else this.form.fecha_nacimiento+=this.form.fecha_nacimiento_dia

        this.form.fecha_nacimiento+=' 00:00:00'
        axios
          .post('/api/saveUpdateClient',this.form)
          .then(res=>{
            if(res.data.status == 200){
              localStorage.setItem('fecha_nacimiento_dia', this.form.fecha_nacimiento_dia);
              localStorage.setItem('nombre', this.form.nombres);
              localStorage.setItem('fecha_nacimiento_mes', this.form.fecha_nacimiento_mes);
              localStorage.setItem('fecha_nacimiento', this.form.fecha_nacimiento);
              localStorage.setItem('telefono', this.form.telefono);
              this.companiesFormNewClient.push(this.form.id_companie)
              localStorage.setItem('companies_form_new_client', JSON.stringify(this.companiesFormNewClient));
              this.validateformNewClient=false
              this.formNewClientModal=false
              }
            }).catch(err=>{
            })
      } else{
        this.validateformNewClient=true
      }
    },
    updateDays() {
      // Actualiza los días cuando cambia el mes seleccionado
      this.selectedDay = 1; // Restablece el día a 1
    },
    calcularValor(){
      if(this.formEdit.id_type_forma_pago_secundaria == null && parseFloat(this.formOrder.total) != this.formEdit.valor_forma_pago)this.formEdit.id_type_forma_pago_secundaria=37;
      this.formEdit.valor_forma_pago_secundaria = parseFloat(this.formOrder.total) - this.formEdit.valor_forma_pago;
    },
    updateObservationOrder(){
      if(this.formEdit.service==null)this.form.service=0;
      if(this.formEdit.valor_forma_pago_secundaria == null)this.formEdit.valor_forma_pago_secundaria=0;
      if ((parseFloat(this.formEdit.valor_forma_pago) + parseFloat(this.formEdit.valor_forma_pago_secundaria)) != parseFloat(this.formOrder.total)){
        if(parseFloat(this.formEdit.valor_forma_pago) > parseFloat(this.formOrder.total)){
          this.formEdit.valor_forma_pago=parseFloat(this.formOrder.total)
          this.formEdit.valor_forma_pago_secundaria=0
        } else{
          this.formEdit.valor_forma_pago_secundaria=parseFloat(this.formOrder.total)-parseFloat(this.formEdit.valor_forma_pago)
        }
      }
      axios
        .post('/api/order/update-observation-order',this.formEdit)
        .then(res=>{
          if(res.data.statusCode == 200){
            this.editMeseroModal=false;
            this.editMesaModal=false;
            this.errorMesaModal=false;
            this.editPayModal=false;
            this.editServiceModal=false;
            this.editObsModal=false;
            this.getOrderDetail(this.mesaMesero.id_order)
            }
          }).catch(err=>{
          })
    },
    editClient(){
      this.formEditClient.name=this.formOrder.client.name
      this.formEditClient.id_order=this.formOrder.id_order
      this.formEditClient.id_client=this.formOrder.client.id_client
      this.formEditClient.cedula=this.formOrder.client.cedula
      this.formEditClient.nit=this.formOrder.client.nit
      this.formEditClient.phone=this.formOrder.client.phone
      this.formEditClient.address=this.formOrder.client.address
      this.formEditClient.barrio=this.formOrder.client.barrio
      this.formEditClient.email=this.formOrder.client.email
      this.editClientModal=true;
    },
    updateDetailClient(){
      this.editClientModal=false;
        axios
        .post('/api/order/update-detail-client',this.formEditClient)
        .then(res=>{
          if(res.data.statusCode == 200){
            this.getOrderDetail(this.mesaMesero.id_order)
          }
        }).catch(err=>{
        })
    },
    DeleteorUpdate(tr){
      this.botonDeshabilitado=true;
        let js = tr;
        axios
          .post('/api/delete-update-order-dev',js)
          .then(res => { 
            if(res.data.status == 200){
              this.getOrderDetail(this.mesaMesero.id_order)
              if(res.data.data && res.data.data.comanda){
                if(!this.socketUnified){
                this.socketPrint.emit('new print', res.data.data);
                }else{
                  this.socketTable.emit('new print', res.data.data);
                }
              }
            }
            setTimeout(() => {
              this.botonDeshabilitado = false
            }, 1000)     
          })
          .catch(err => {
            setTimeout(() => {
              this.botonDeshabilitado = false
            }, 1000)
          });
          
    },
    accountPrint(table_selected){      
      let id_order=table_selected.id_order
      const apiUrl = process.env.VUE_APP_API_URL_BETA;
      //const apiUrl = process.env.VUE_APP_API_URL_DEV;

      axios.get(`${apiUrl}/api/socket-order/getDataPrintCount/`+id_order)
        .then(res => {      
          if(res.data.error == false){
            if(!this.socketUnified){
              this.socketPrint.emit('new print', res.data.data);
            }else{
              this.socketTable.emit('new print', res.data.data);
            }
          }else{
          }
        })
        .catch(err => {
        });
     },
    PrintCommand(table_selected,cocina,bar){        
      let id_order=table_selected.id_order
      axios.get('/api/socket-order/getDataPrintOrder'+"/"+id_order+"/"+cocina+"/"+bar)
        .then(res => {      
          if(res.data.error == false){
            if(!this.socketUnified){
              this.socketPrint.emit('new print', res.data.data);
            }else{
              this.socketTable.emit('new print', res.data.data);
            }
          }else{
          }
        })
        .catch(err => {
        });
    },
    getIdCashMovement(id_companie){
      axios.get('/api/get-open-cash/'+id_companie)
        .then(res=>{
          if(res.data.id_cash_movement)this.id_cash_movement=res.data.id_cash_movement;
          else this.id_cash_movement=null

          localStorage.setItem('id_cash_movement', this.id_cash_movement)
        }).catch(err=>{
        });
		},
    confirmPrint(order){		
      this.orderPrint = "";		
      this.orderPrint = order;
      this.confirmPrintModal=true;
    },
    printOrder(){
      this.confirmPrintModal=false;
      this.saveDocument(this.orderPrint);
    },
    saveDocument(order){
      let self = this
      var data = {};

      data.id_companie = order.id_companie;
      data.id_order = order.id_order;
      if(this.id_cash_movement)data.id_cash_movement = this.id_cash_movement;
      else{
        this.confirmPrintModalCash=true
        return false
      }
      axios.post('/api/save-documents',data)
        .then(res=>{
        if(res.data.statusCode == 200){
          if(this.kiosko){
            self.printBySocket(order.id_order, false, true);
          }else{
            this.getTablesByMesero()
            setTimeout(function() { self.printBySocket(order.id_order) }, 1000);
            this.mesaMesero=0;
          }
          
        }else{
        }
        }).catch(err=>{
        });
		},
    mesaOcupadaPorOtroMesero(numeroMesa) {
      if(!this.edit_other_table){
        const nombreMeseroMesa = this.obtenerNombreMesero(numeroMesa);
        return this.esMesaOcupada(numeroMesa) && nombreMeseroMesa !== this.nombre_mesero;
      }
    },
    esMesaOcupada(numeroMesa) {
      return this.mesas_ocupadas.some(ocupada => ocupada.id_table === numeroMesa);
    },
    obtenerNombreMesero(numeroMesa) {
      const mesaOcupada = this.mesas_ocupadas.find(ocupada => ocupada.id_table === numeroMesa);
      return mesaOcupada ? mesaOcupada.nombre_mesero : '';
    },
    cambiarNumero(){
      this.valNequiPayment = this.form.telefono
    },
    showAlert(imagen, addition, combination) {
      
      // Obtener la última imagen del array
      const ultimaImagen = imagen[imagen.length - 1];
      
      // Verificar si es una URL de DigitalOcean Spaces o contiene 'http'
      if (ultimaImagen.includes('digitaloceanspaces.com') || ultimaImagen.includes('http')) {
        this.img_landscape = ultimaImagen;
      } else {
        this.img_landscape = this.url_images + '/' + ultimaImagen;
      }
      
      this.status_landscape = true;
    },
    activarPopup(){
      this.exit_component = this.form.comentario != '' ? false : true;
      if (!this.exit_component)this.saveOrderBD(false); 
    },
    activarPopupPaymentOnline(){
      this.exit_component = this.form.comentario != '' ? false : true;
      if (!this.exit_component)this.saveOrderBDOnline(false); 
    },
    actualDay(){
      if (this.schedule_state) {
        var self = this;
        //let dia_actual = moment().format('YYYY-MM-DD HH:mm:ss');
        //const numero_dia = new Date(dia_actual).getDay();
        const numero_dia = moment().day();
        this.schedule_list.forEach((item, index) =>{
          if (index == numero_dia) {
            self.schedule_closed = item.estado;
            document.getElementById(`schedule_${numero_dia}`).classList.add("actual-day");


            //validamos el escenario cuando el restaurante esta cerrado y no permite pedidos fuera de horario
            if (!self.schedule_closed && !self.pedidos_fuera_horario && !self.mesero) {
              self.open_schedule = true;
              self.status_close_schedule = false;
            }

            //validamos el rango de horario solo si la licencia tiene horarios programados en el dia actual
            if (self.schedule_closed && !self.mesero) {

              //definimos el formato moment para las horas recibidas desde la peticion
              var format = 'HH:mm';
              var algo = moment().format(format);
              var hora_actual = moment(algo, format);
              //especificamos en una variable la hora actual para realizar la validacion
              //definimos el rango de horas sobre las cuales haremos la comparativa
              var hora_inicial = moment(item.desde, format);
              var hora_final = moment(item.hasta, format);

              var hora_inicial_pm = moment(item.desde_pm, format);
              var hora_final_pm = moment(item.hasta_pm, format);
              //Juancho
              if (hora_actual.isBetween(hora_inicial, hora_final) || hora_actual.isBetween(hora_inicial_pm, hora_final_pm)) {
              }else{
                self.schedule_closed = false;
                item.estado = false;
                if (!self.pedidos_fuera_horario && !self.mesero) {
                  self.open_schedule = true;
                  self.status_close_schedule = false;
                }
              }
            }
          }
        });
      }
    },
    validateView(){
      if (this.desktop_main_view) {
        if (window.matchMedia("(max-width: 600px)").matches){
          this.view_mobile = true;
        }
      }
    },
    sectionCategory(category) {
      this.categorySelected = category;   
      this.categorySelected.products.forEach(producto => {
        this.carrito.forEach(item => {
          if(item.id_product == producto.id){
            document.getElementById("div_cantidades2_"+producto.id).style.display="block";
            document.getElementById("product2_"+producto.id).innerHTML = item.cantidad;
          }
        })
      })
    },
    section(id){
      location.href = `#category_${id}`;
    },
    sectionMobile(id){
      location.href = `#category2_${id}`;
    },
    searchProductClone(listado){
      this.status_managment = false;
      this.carrito = listado;
      this.getTotalProductos();
      this.getTotalItems();
    },
    closeMap(){
      let autocomplete = document.getElementById('complete_direction').value;
      if (autocomplete == "" || !this.status_current_position) {
        this.visible_map = false;
        this.showProductos();
        this.form.latitude = 'No';
        this.form.longitude = 'No';
      }else{
        this.visible_map = false;
        this.showProductos();
      }
    },
    validatePosition(){

      var self = this;
      this.total+= this.domicilio;
      this.punteroMapaDomicilio = true;
      let autocomplete = document.getElementById('complete_direction').value;
      if (autocomplete != "" || this.status_current_position) {
        if (autocomplete != "") {
          this.form.direccion = autocomplete;
          this.visible_map = false;
        }
        if (this.status_current_position) {
          this.form.direccion = this.actual_ubication;
          this.visible_map = false;
        }
      }else{
        this.empty_map_fields=true;
        setTimeout(function(){
          self.empty_map_fields=false;
        },2000);
      }
    },
    getPromo(promocion){
      var self = this;
      this.categories.forEach((product) => {
        product.products.forEach((item, index) => {
          if (item.id == promocion.id_product) {
            self.agregarProductoCarrito(item.id, item.name, item.description, item.value_sale, item.status_variants, item.variantes,item.variantes_detail,item.variantes_combinations,item.status_addition,item.addition,item.addition_detail,item.address_included, item.stock, index,item.validacion_stock);
          }
        });
      });
    },
    backDelivery(){
      if (localStorage.getItem('uri_delivery')) {
        let uri = localStorage.getItem('uri_delivery');
        location.href = location.origin+""+uri;
      }
      localStorage.removeItem('uri_delivery');
      localStorage.removeItem('name_delivery');
      localStorage.removeItem('id_delivery');
    },
    call(){
      if(this.telefono_pedidos.length == 12){
        this.telefono_pedidos = this.telefono_pedidos.substr(2,12);
        window.location.href = 'tel:' + this.telefono_pedidos;
      }else{
        window.location.href = 'tel:' + this.telefono_pedidos;
      }
    },
    validarCarrito(){
      this.categories.forEach((item) => {
        item.products.forEach((p) => {
          document.getElementById("div_cantidades_"+p.id).style.display = 'none';
          document.getElementById("product_"+p.id).innerHTML = "1";
        });
      });
      this.carrito.forEach((item) => {
        document.getElementById("div_cantidades_"+item.id_product).style.display = '';
        document.getElementById("product_"+item.id_product).innerHTML = item.cantidad;
      });
      this.getTotalProductos();
      this.getTotalItems();
   
  },  
   verifyTypePayment(){
    this.valHowPay = "";
    this.checkout = false;
    this.validacionMonto = false;
    let id_type = this.form.id_type_forma_pago;
    if(id_type == 37/*Efectivo*/ ? this.howPay = true : this.howPay = false);
    if(id_type == 38 /*Transferencia*/ ? this.numberAccount = true : this.numberAccount = false);    
    if(id_type == 38)document.getElementById('select-bank').value = 0;
    if(id_type == 76/*pago en linea*/)this.checkout = true;
    if(id_type == 141){
      //this.statusCedula = true;
      this.statusEmail = true;
    }else{
      this.statusCedula = JSON.parse(localStorage.getItem('r_cedula').toLowerCase());
      this.statusEmail = JSON.parse(localStorage.getItem('r_email').toLowerCase());
    }
    if(id_type == 126){
      this.statusEmail = true;
    }else{
       this.statusEmail = JSON.parse(localStorage.getItem('r_email').toLowerCase());
    }
   },
   payNequi(){
        if (this.submitSaveOrder) {
        this.submitSaveOrder = false;

        if (this.total < 1500){
          this.validacionMonto = true
          this.submitSaveOrder = true; 
          this.exit_component = false;

          return 0;
        }

        this.validarCampos()
        if(!this.statusValidation){ 
          this.submitSaveOrder = true; 
          this.exit_component = false;
          return 0;
        }
        $(".btn-wonpi").addClass("button-loading2");
        $(".button-loading2").removeClass("send-button2");
        $(".button-loading2").addClass("rodar2");
        $(".send-text").removeClass("hide");
        $(".what").removeClass("hide");
        $(".fa-check").addClass("hide");
        var paynequi = document.getElementById("paynequi");
        paynequi.disabled = true;

        let cart = JSON.stringify(this.carrito);
        const validarAI = this.fnAddressIncluded();
        validarAI == true ? this.form['domicilio'] = 0 : this.form['domicilio'] = this.domicilio;
        if (this.domicilio > 0 && this.visible_barrio)this.form['domicilio'] = this.domicilio;
        this.form['cart'] = cart;   
        this.form['estado_domicilio'] = this.estado_domicilio;       
        this.form['total'] = this.total;
        this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total);
        this.form['os'] = this.nameOS;
        this.form['entrega'] = "";
        this.form['priority_shipping'] = this.tr_priority_shipping;
        this.form['value_priority_shipping'] = this.value_priority_shipping;
        this.form['id_zone'] = this.id_zone;
        this.form['bank_type'] = this.bank_type;
        this.form['mesa_domicilio'] = this.mesaDomicilio;
        this.form['telefono_nequi'] = this.valNequiPayment;
        this.form['tipo_transaccion'] = "NEQUI";
        if (this.delivery_app) this.form['id_companie_delivery_apps'] = localStorage.getItem('id_delivery');

        this.form['valHowPay'] = this.valHowPay.replace(".", "");
        if(this.statusFecha && !this.optMesa && !this.kiosko){
          let entrega = document.getElementById("entrega").value;
          let h = document.getElementById("horaEntrega").value;
          let m = document.getElementById("minutoEntrega").value;
          let j = document.getElementById("horarioEntrega").value;
          entrega += ` ${h}:${m} ${j}`;
          if(entrega)this.form['entrega'] = entrega;        
        }   

        var _self = this;
        axios.post('/api/transactions/save-transaction', this.form)
        .then(res => {
            if(res.data.error == false){
              localStorage.setItem('telefono_nequi', _self.valNequiPayment)
              //_self.finishOrderNequi = true
              _self.idTransactionOnline = res.data.data.code
              setTimeout(function(){
                  _self.enviarWhatsApp(false);
                setTimeout(function() {
                  _self.submitSaveOrder = true;
                  _self.finishOrderNequi = true
                }, 3000);
              },1500)
            }else{
              alert(res.data.message)
            }
            this.submitSaveOrder = true; 
        })
        .catch(err => {
          this.submitSaveOrder = true;  
        });
      }
   },

  validarBarrio(){
    this.form.barrio=this.barrio_selected;
    if (this.form.barrio == '' || this.form.barrio == null) {
      this.validacion_barrio = true
      //alert("Por favor seleccione un barrio");
      return 0;
    }
    var self = this
    this.domicilio = 0
    this.total = 0
     this.barrios_listado.forEach((b)=>{
        if (b.id.toUpperCase().replace(" ", "") == self.form.barrio.toUpperCase().replace(" ", "")) {
            self.domicilio = parseFloat(b.precio)
        }
     });
     var _self = this;
      _self.carrito.forEach((product)=>{
        if (_self.currency != "COP") {
          //_self.total += _self.formatDecimal(parseFloat(product.valor)*product.cantidad);
          _self.total += parseFloat(_self.formatDecimal((parseFloat(product.valor)*product.cantidad)+product.addition_v));
          parseFloat(_self.total);
        }else{
          _self.total += ((parseInt(product.valor)*product.cantidad)+product.addition_v);
        }       
     });
     this.visible_barrio = false
     _self.total += self.domicilio
  },
   payDaviplata(){
        if (this.submitSaveOrder) {
          this.submitSaveOrder = false;

          if (this.total < 5000){
            this.validacionMonto = true
            this.submitSaveOrder = true; 
            this.exit_component = false;

            return 0;
          }

          this.validarCampos()
          if(!this.statusValidation){ 
            this.submitSaveOrder = true; 
            this.exit_component = false;
            return 0;
          } 
        $(".btn-wonpi").addClass("button-loading2");
        $(".button-loading2").removeClass("send-button2");
        $(".button-loading2").addClass("rodar2");
        $(".send-text").removeClass("hide");
        $(".what").removeClass("hide");
        $(".fa-check").addClass("hide");
        let cart = JSON.stringify(this.carrito);
        const validarAI = this.fnAddressIncluded();
        validarAI == true ? this.form['domicilio'] = 0 : this.form['domicilio'] = this.domicilio;
        if (this.domicilio > 0 && this.visible_barrio)this.form['domicilio'] = this.domicilio;
        this.form['cart'] = cart;   
        this.form['estado_domicilio'] = this.estado_domicilio;       
        this.form['total'] = this.total;
        this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total);
        this.form['os'] = this.nameOS;
        this.form['entrega'] = "";
        this.form['priority_shipping'] = this.tr_priority_shipping;
        this.form['value_priority_shipping'] = this.value_priority_shipping;
        this.form['id_zone'] = this.id_zone;
        this.form['bank_type'] = this.bank_type;
        this.form['mesa_domicilio'] = this.mesaDomicilio;
        this.form['telefono_nequi'] = this.valNequiPayment;
        this.form['tipo_transaccion'] = "DAVIPLATA";
        if (this.delivery_app) this.form['id_companie_delivery_apps'] = localStorage.getItem('id_delivery');

        this.form['valHowPay'] = this.valHowPay.replace(".", "");
        if(this.statusFecha && !this.optMesa && !this.kiosko){
          let entrega = document.getElementById("entrega").value;
          let h = document.getElementById("horaEntrega").value;
          let m = document.getElementById("minutoEntrega").value;
          let j = document.getElementById("horarioEntrega").value;
          entrega += ` ${h}:${m} ${j}`;
          if(entrega)this.form['entrega'] = entrega;        
        }
        var _self = this;
        axios.post('/api/epayco-transactions/save-transaction', this.form)
        .then(res => {
            if(res.data.error == false){
              localStorage.setItem('id_order', res.data.id_order);
              localStorage.setItem('ref_payco', res.data.pay.data.refPayco);
              localStorage.setItem('id_session_token', res.data.pay.data.idSessionToken);
              localStorage.setItem('tipo_documento', this.form.type_document);
              localStorage.setItem('documento', this.form.documento);
              localStorage.setItem('nombres', this.form.nombres);
              localStorage.setItem('email', this.form.email);
              localStorage.setItem('telefono', this.form.telefono);
              localStorage.setItem('totalDaviplata', this.form.total);
              this.id_order_bot=res.data.id_order;
              _self.finishOrderDaviplata = true
              _self.idTransactionOnline = res.data.data.code
              this.submitSaveOrder = true; 
            }else{
              alert("Error al generar la transacción, intente nuevamente");
              this.submitSaveOrder = false; 
            }
            
        })
        .catch(err => {
          this.submitSaveOrder = false; 
          //alert("Error al generar la transacción, intente nuevamente");
        });
      }
   },
   payBancolombia(){
        if (this.submitSaveOrder) {
        this.submitSaveOrder = false;

        if (this.total < 1500){
          this.validacionMonto = true
          this.submitSaveOrder = true; 
          this.exit_component = false;

          return 0;
        }

        this.validarCampos()
        if(!this.statusValidation){ 
          this.submitSaveOrder = true; 
          this.exit_component = false;
          return 0;
        } 
        $(".btn-wonpi").addClass("button-loading2");
        $(".button-loading2").removeClass("send-button2");
        $(".button-loading2").addClass("rodar2");
        $(".send-text").removeClass("hide");
        $(".what").removeClass("hide");
        $(".fa-check").addClass("hide");
        let cart = JSON.stringify(this.carrito);
        const validarAI = this.fnAddressIncluded();
        validarAI == true ? this.form['domicilio'] = 0 : this.form['domicilio'] = this.domicilio;
        if (this.domicilio > 0 && this.visible_barrio)this.form['domicilio'] = this.domicilio;
        this.form['cart'] = cart;   
        this.form['estado_domicilio'] = this.estado_domicilio;       
        this.form['total'] = this.total;
        this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total);
        this.form['os'] = this.nameOS;
        this.form['entrega'] = "";
        this.form['priority_shipping'] = this.tr_priority_shipping;
        this.form['value_priority_shipping'] = this.value_priority_shipping;
        this.form['id_zone'] = this.id_zone;
        this.form['bank_type'] = this.bank_type;
        this.form['id_plan_sucursal'] = "Compra establecimiento";
        this.form['mesa_domicilio'] = this.mesaDomicilio;
        let pago_bancolombia_qr = false;
        if(this.form.id_type_forma_pago == '126'){
          this.form['tipo_transaccion'] = "BANCOLOMBIA";
        }
        if(this.form.id_type_forma_pago == '169'){
          pago_bancolombia_qr = true;
          this.form.id_type_forma_pago = '126';
          this.form['tipo_transaccion'] = "BANCOLOMBIA_QR";
        }
        let uri = localStorage.getItem('license_uri');
        this.form['async_payment_url'] = location.origin+'/'+uri+'/order'; //location.origin+'/'+uri+'/order'
        
        if (this.delivery_app) this.form['id_companie_delivery_apps'] = localStorage.getItem('id_delivery');

        this.form['valHowPay'] = this.valHowPay.replace(".", "");
        if(this.statusFecha && !this.optMesa && !this.kiosko){
          let entrega = document.getElementById("entrega").value;
          let h = document.getElementById("horaEntrega").value;
          let m = document.getElementById("minutoEntrega").value;
          let j = document.getElementById("horarioEntrega").value;
          entrega += ` ${h}:${m} ${j}`;
          if(entrega)this.form['entrega'] = entrega;        
        }   
        const apiUrl = process.env.VUE_APP_API_URL_BETA;
        //const apiUrl = process.env.VUE_APP_API_URL_DEV;
        axios.post(`${apiUrl}/api/transactions/save-transaction`, this.form, {

        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
         }
        })
        .then(res => { 
            if(res.data.error == false){
              if(this.kiosko && pago_bancolombia_qr){
                localStorage.setItem('qr_image_bancolombia', res.data.data.qr.qr_image);
                //this.getOrderDetail(res.data.data.id_order, true, res.data.data.qr.qr_image);
              }else{
                localStorage.setItem('qr_image_bancolombia', '');
              }
              setTimeout(() => {
                location.href = res.data.data.url;
              }, 1000);
              
            }else{
              setTimeout(() => {
                alert(`Ocurrió un error de transacción: ${res.data.message}`);
                location.reload();
              }, 500);
              
            }
            this.submitSaveOrder = true; 
        })
        .catch(err => {
          this.submitSaveOrder = true; 
          alert(`Ocurrió un error: ${err}`);
          location.reload();
        });
      }
   },
   pay(){
    this.validarCampos()
    if(!this.statusValidation) return 0;   
    var self = this;
    axios
    .get('/api/order/get-data-wompi/'+this.company.id)
    .then( res =>{
      this.formPay.wompiPublicKey = res.data.wpk;
      this.formPay.wompiCurrency = res.data.wc;
      this.formPay.wompiReference = res.data.wr;
      this.formPay.redirectUrl = res.data.wp_redirect_url;
      self.checkout = new WidgetCheckout({
        currency: self.formPay.wompiCurrency,
        amountInCents: parseFloat(String(self.total)+'00'),
        reference: self.formPay.wompiReference,
        publicKey: self.formPay.wompiPublicKey,
        redirectUrl: `${window.location.origin}${self.formPay.redirectUrl}${self.formPay.wompiReference}`
      });
      self.executeWompi();
    })
    .catch( err => {
    });
    
   },
   executeWompi(){
    var self = this;
    self.saveOrderBD(true,this.formPay.wompiReference,true);
    this.checkout.open(function ( result ) { 
      var transaction = result.transaction
      if(transaction.status == 'APPROVED'){
          self.enviarWhatsApp(true,transaction.id);
      }else{
          self.form.id_type_forma_pago = 0;
          self.checkout = false; 
      }
     
    });
   },
   validateCoupon(){    
      $('.text-coupon').addClass("hide");
      $('.loading-icon').removeClass("hide");   
      this.total = this.total+parseFloat(this.form.descuento);    
      this.form.descuento = 0;
      var self = this;
      this.coupon.id_companie = this.company.id;
      this.coupon.coupon = this.textCoupon;
      let phoneClient = localStorage.getItem('telefono'); 
      if(phoneClient ? this.coupon.phone = phoneClient : this.coupon.phone = "");
      this.coupon.total = this.total;
      if(this.domicilio > 0)this.coupon.total -= parseFloat(this.domicilio);      
      this.couponText = '';
      this.coupon.cart = JSON.stringify(this.carrito);
      axios
      .post('/api/get-coupon-client',this.coupon)
      .then((res) => {
        if(res.data.statusCode == 200){     
          this.carrito = JSON.parse(res.data.cart);     
          this.couponSuccess = true;
          this.couponText = res.data.statusText;
          this.form.id_coupon = res.data.id_coupon;
          this.coupon.id_coupon = res.data.id_coupon;          
          this.form.descuento = res.data.valueCoupon;
          this.total = this.total-parseFloat(res.data.valueCoupon);
          $('.cupon-contain').addClass("hide");      
          $('.botoncerrar').addClass("ocultarcupon");       
          setTimeout(function(){ self.couponSuccess = false; }, 2000);
          setTimeout(function(){ this.coupons = false; }, 2000);
          $('.text-coupon').removeClass("hide");
          
        }else{         
          this.couponError = true;
          this.couponText = res.data.statusText;  
           $('.text-coupon').removeClass("hide");
           $('.loading-icon').addClass("hide");                
          setTimeout(function(){ self.couponError = false; }, 3000);
        }
      })
      .catch((err) => {
      });
   },
    onFocus: function (args) {
      args.model.show(); 
    }, 
    removeItem(id_product, name) {
      this.total = 0;
      var aux = 0;
      var self = this;

      this.carrito.forEach((product) => {
        if (product.id_product === id_product && product.name_product === name) {
          if (product.descuento > 0) {
            self.form.descuento -= parseFloat(product.descuento || 0);
            if (self.form.descuento <= 0) {
              self.form.descuento = 0;
              self.form.id_coupon = "";
              self.coupons = true;
              $('.cupon-contain').removeClass("hide");
              $('.loading-icon').addClass("hide");
              $('.botoncerrar').removeClass("ocultarcupon");
              $('.text-coupon').removeClass("hide");
            }
          }

          const element = document.getElementById("div_cantidades_" + id_product);
          if (element) {
            element.style.display = 'none';
          }
          this.carrito.splice(aux, 1);
        }
        aux++;
      });

      const validarAI = this.fnAddressIncluded();

      if (this.carrito.length > 0) {
        this.carrito.forEach((product) => {
          const valor = parseFloat(product.valor || 0);
          const cantidad = parseInt(product.cantidad || 0);
          const addition = parseFloat(product.addition_v || 0);

          if (this.currency !== "COP") {
            self.total += parseFloat(self.formatDecimal((valor * cantidad) + addition));
          } else {
            self.total += (valor * cantidad) + addition;
          }
        });
      } else {
        this.showProductos();
      }

      if (this.domicilio > 0 && !validarAI && !this.optMesa && !this.optLocal) {
        this.total += parseFloat(this.domicilio || 0);
        document.getElementById('tr_domicilio').style.display = "";
      }

      if (self.form.descuento <= this.total) {
        this.total -= parseFloat(self.form.descuento || 0);
      } else {
        this.total = 0;
      }

      this.getTotalProductos();
      this.getTotalItems();
    },
    close2(){      
      document.body.style.overflow = "auto";
      document.getElementById("modalVariantesRestaurante").style.display = "none";
    },
    
    extraerValor(valor,position){
      let value = valor;
      value = value.split('_')[position];      
      return value;
    },    
    validateSumarRestar(tam1){
      var self = this; 
      var tam2 = 0;
      this.categories.forEach(function(c){
          c.products.forEach(function(p){
              if(self.modal.id_product == p.id){
                  tam2 = p.variantes_count.length;
                  if(tam1 == tam2){
                    self.validatePriceEccommerce(p.variantes_combinations);
                  }
              } 
          })
      });
      if(tam1 == tam2){
        document.getElementById('contenedor_cantidades').style.display = "";        
      }else{
        document.getElementById('contenedor_cantidades').style.display = 'none'
      }
      
    },
    validatePriceEccommerce(combinations){
        var name = '';
        var self = this; 
        this.nameEcommerce = "";
        this.arrayCombinaciones.forEach((c,i) => {
            if(i == 0){
              name = c.variant; 
            }else{
              name += ' - '+c.variant;
            }
            self.nameVariantEcommerce = name;
        });

        if(name){
          combinations.forEach((c) => {
              if(c.variant == name)self.modal.price = c.value;
          });
        }

    },
    install() {
      this.showInstallBanner = false;
      installEvent.prompt();
      installEvent.userChoice.then(() => {
        installEvent = null;
      });
    }, 
    changePoint() {
      const point = this.points.find(p => p.name === this.point_selected);
      if (!point) return;

      this.form.name_point = point.name;
      this.form.id_point = point.id_point;

      this.getUsedTables(point.id_point);
      if (!this.active_login_with_pin) this.getwaiters(this.form.id_companie, point.id_point);

      if (!this.jornada) return;

      this.setHoraEntrega();
      this.setMinutes();
      this.horarioEntrega = 'AM';
      document.getElementById('jornadaPunto').style.display = 'none';
      
      if (!this.mesero) {
        $('.out-service').show();
        $('.send-button').hide();
      }

      const horario = this.horarios[this.points.findIndex(p => p.id_point === point.id_point)];
      const now = moment();
      const diaSemana = this.toSpanishDay(moment().format('dddd'));
      horario?.forEach(h => {
        if ((h.id_tipo_horario == diaSemana || h.id_tipo_horario == 49) && !this.mesero) {
          const amA = moment(`${now.format('YYYY-MM-DD')} ${h.am_apertura}`);
          const amC = moment(`${now.format('YYYY-MM-DD')} ${h.am_cierre}`);
          const pmA = moment(`${now.format('YYYY-MM-DD')} ${h.pm_apertura}`);
          const pmC = moment(`${now.format('YYYY-MM-DD')} ${h.pm_cierre}`);

          const isOpen = now.isBetween(amA, amC) || now.isBetween(pmA, pmC);
          document.getElementById('jornadaPunto').style.display = isOpen ? 'none' : 'block';
          $('.send-button').toggle(isOpen);
          $('.out-service').toggle(!isOpen);
        }
      });
    },
    toSpanishDay(day){
      if(day == 'Monday') return 42;
      if(day == 'Tuesday') return 43;
      if(day == 'Wednesday') return 44;
      if(day == 'Thursday') return 45;
      if(day == 'Friday') return 46;
      if(day == 'Saturday') return 47;
      if(day == 'Sunday') return 48;
    },
    formatDate(date){
      date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
      return date;
    },

    validateDeliveryTime(horario,jornada){    
      var self = this; 
      //VALIDAMOS EL HORARIO DE ENTREGA
      let fecha_seleccionada = '';
      this.dateCalendar ? fecha_seleccionada = this.dateCalendar : fecha_seleccionada = document.getElementById("entrega").value;     
      //obtenemos le dia de la semana
      fecha_seleccionada = this.formatDate(fecha_seleccionada);
      fecha_seleccionada = fecha_seleccionada+'T00:00:00';
      fecha_seleccionada = moment(fecha_seleccionada).format('dddd');
      let diaSemana = this.toSpanishDay(fecha_seleccionada);   
      let puntero = false;
      if(diaSemana){
        horario.forEach(function(h){    
          //alert("voy"+ diaSemana + h.id_tipo_horario)     
          if(h.id_tipo_horario == diaSemana || h.id_tipo_horario == 49){
              puntero = true; 
              self.setMinutes();
              self.setHoraEntrega();            
            if(jornada == 'AM'){              
              self.setHoraEntrega(parseInt(h.am_apertura.split(':')[0]),parseInt(h.am_cierre.split(':')[0]));
            }else{
              self.setHoraEntrega(parseInt(h.pm_apertura.split(':')[0]),parseInt(h.pm_cierre.split(':')[0]),false);
            }
          }
        });
        if (puntero == true || self.mesero) {
          $('.send-button').show();
          $('.out-service').hide();
        }else{
          $('.out-service').show();
          $('.send-button').hide(); 
        }
      }
      //END VALIDACION
    },
    validateDeliveryMinute(horario,jornada){    
      var self = this; 
      var hora = document.getElementById('horaEntrega').value;
      //VALIDAMOS EL HORARIO DE ENTREGA
      let fecha_seleccionada = '';
      this.dateCalendar ? fecha_seleccionada = this.dateCalendar : fecha_seleccionada = document.getElementById("entrega").value;     
      //obtenemos le dia de la semana
      fecha_seleccionada = this.formatDate(fecha_seleccionada);
      fecha_seleccionada = fecha_seleccionada+'T00:00:00';
      fecha_seleccionada = moment(fecha_seleccionada).format('dddd');
      let diaSemana = this.toSpanishDay(fecha_seleccionada);   
      if(diaSemana){
        horario.forEach(function(h){
          if(h.id_tipo_horario == diaSemana || h.id_tipo_horario == 49){  
            if(jornada == 'AM'){              
                if(hora == h.am_apertura.split(':')[0]){
                  self.setMinutes(parseInt(h.am_apertura.split(':')[1]),59);
                }else if(hora == h.am_cierre.split(':')[0]){
                   self.setMinutes(0,parseInt(h.am_cierre.split(':')[1]));
                }else{
                  self.setMinutes();
                }
            }else{
                if(hora == parseInt(h.pm_apertura.split(':')[0])-12){
                  self.setMinutes(parseInt(h.pm_apertura.split(':')[1]),59);
                }else if(hora == parseInt(h.pm_cierre.split(':')[0])-12){
                   self.setMinutes(0,parseInt(h.pm_cierre.split(':')[1]));
                }else{
                  self.setMinutes();
                }
            }
          }
        });
      }
      //END VALIDACION
    },
    setDate(){
      this.dateCalendar = document.getElementById("entrega").value;
      this.setHoraEntrega();
      this.setMinutes();
      this.horarioEntrega = 'AM';
      this.verifyHorarioEntrega(this.horarioEntrega);
    },
    setMinutes(inicio = 0, fin = 59){
      document.getElementById('minutoEntrega').innerHTML = '';
      document.getElementById('minutoEntrega').innerHTML = '<option value="60" selected disabled>Minuto</option>';
      const cero = 0;
      for(inicio; inicio <= fin; inicio++){                
        if(inicio<10)document.getElementById('minutoEntrega').innerHTML += `<option value="${cero}${inicio}">${cero}${inicio}</option>`;
        else document.getElementById('minutoEntrega').innerHTML += `<option value="${inicio}">${inicio}</option>`;
      }
    }, 
    verifyHorarioEntrega(val){      
      var self = this;
        let id_point = this.form.id_point;
        if(id_point){
          this.points.forEach(function(p,i){
            if(id_point == p.id_point){               
                let horario = self.horarios[i];
                self.validateDeliveryTime(horario,val);
            }
          });
        }
     },
     setMinutesForHours(){
        var self = this;
        let id_point = this.form.id_point;
         if(id_point){
            this.points.forEach(function(p,i){
            if(id_point == p.id_point){
                let horario = self.horarios[i];
                self.validateDeliveryMinute(horario,document.getElementById('horarioEntrega').value);
            }
          });
         }
    },
    reload(){
      window.location.reload(true);
    },

    copyAccount(){   
        var combo = document.getElementById("select-bank");
        
        this.bank_name = combo.options[combo.selectedIndex].text;  
        document.getElementById('notify-copy').style.display = 'block';
        setTimeout(function(){ document.getElementById('notify-copy').style.display = 'none'; }, 3000);            
        var aux = document.createElement("input");
        aux.setAttribute("value", document.getElementById('select-bank').value);
        document.body.appendChild(aux);
        aux.select();
        aux.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(aux);
        
          
    },
    
    close(){
      document.getElementById("modalProduct").style.display = "none";    
      document.getElementById("picture-modal").style.display = "none";
      document.getElementById("picture-modal2").style.display = "none";
      document.getElementById("picture-modal3").style.display = "none";    
    },
    search2(){   
      this.product_list_aux = [];
      var texto = document.getElementById('buscar').value;
      if(texto.trim() != ""){
          if (!this.filter_option) {
              this.categories.forEach((category) =>{  
                  if(!category.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
                      document.getElementById("card_"+category.id_category).style.display = "none";
                  }else{
                      document.getElementById("card_"+category.id_category).style.display = "";
                  }
              });
          }else{
              this.product_list.forEach((product) =>{  
                  if(product.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
                      this.product_list_aux.push(product);
                  }
              });
              this.product_list_aux = this.removeDuplicates(this.product_list_aux,'id');
              
          }
              
      }else{
          //cuando queda vacio el input search
          if (!this.filter_option) {
              this.categories.forEach((category) =>{              
                document.getElementById("card_"+category.id_category).style.display = "";
              });
          }
              
      }
    },
    removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject  = {};
      for(var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }
      for(i in lookupObject) {
          newArray.push(lookupObject[i]);
      }
      return newArray;
    },
    searchold(){
      this.product_list_aux = [];
      var self=this
      var caracter = document.getElementById('buscar').value;
      //array_id_categorias_accordion
      var array1 = [];
      //array_categorias_sin_productos  
      var array2 = [];
      //array_categorias_con_productos_sin_resultados
      var array3 = [];
      if(caracter.trim() != ""){
          if (!this.filter_option) {
            this.categories.forEach((category) =>{              
                  //ocultamos las categorias que no tienen producto
                  if(category.products.length < 1){
                    array2.push(category.id_category)
                  }else{
                    array3.push({
                        'id_category' : category.id_category,
                        'encontro': false
                    });
                  }
                  category.products.forEach((product) =>{   
                      if(!array1.includes(product.id_category))array1.push(product.id_category);
                      if(!product.name.toUpperCase().includes(caracter.toUpperCase())){                                      
                        document.getElementById("card_"+product.id).style.display = "none";                  
                      }else{                  
                        document.getElementById("card_"+product.id).style.display = "";                  
                        array3.forEach((obj,index) => {
                            if(obj.id_category == product.id_category){
                              var obj2 = {
                                'id_category' : product.id_category,
                                'encontro': true
                              };
                              array3.splice(index,1,obj2);
                            }
                        });
                      }              
                  });              
              });
              array2.forEach((id)=>{
                  document.getElementById("accordionEx_"+id).style.display = "none";
              });
              array3.forEach((objeto)=>{
                  if(objeto.encontro == false){              
                   document.getElementById("accordionEx_"+objeto.id_category).style.display = "none"; 
                  }
              });
          }
          else{
            if(this.view_mobile){
              $(".mobile-view").hide();
              $(".filter-default-categorys").hide();
              $(".result-desktop-view").hide();
              $(".result-mobile-view").show();
              this.product_list.forEach((product) =>{  
                if(product.name.trim().toUpperCase().includes(caracter.trim().toUpperCase())){
                  self.product_list_aux.push(product);
                }
              });
              this.product_list_aux = this.removeDuplicates(this.product_list_aux,'id');
            }
            if(this.desktop_main_view && !this.view_mobile){
              $(".desktop-view").hide();
              $(".filter-default-categorys").hide();
              $(".result-desktop-view").show();
              this.product_list.forEach((product) =>{  
                if(product.name.trim().toUpperCase().includes(caracter.trim().toUpperCase())){
                  self.product_list_aux.push(product);
                }
              });
              this.product_list_aux = this.removeDuplicates(this.product_list_aux,'id');
            }
            else{
              let prod_ver = [];
              this.categories.forEach((category) =>{   
                let productos_visibles = []; 
                category.products.forEach((product) =>{  
                  //ocultamos las categorias que no tienen producto
                  if(category.products.length < 1){
                    array2.push(category.id_category)
                  }else{
                    productos_visibles.push(product.id);
                  }
                });
                array3.push({
                      'id_category' : category.id_category,
                      'id_products' : productos_visibles,
                      'encontro': false
                });
                  category.products.forEach((product) =>{   
                      if(!array1.includes(product.id_category))array1.push(product.id_category);
                      if(!product.name.toUpperCase().includes(caracter.toUpperCase())){                                      
                        document.getElementById("card_"+product.id).style.display = "none"; 
                      }else{     
                        prod_ver.push(product.id);
                        document.getElementById("card_"+product.id).style.display = "block";
                        array3.forEach((obj,index) => {
                            if(obj.id_category == product.id_category){
                              var obj2 = {
                                  'id_category': product.id_category,
                                  'id_products': [...obj.id_products], // Copiar el array existente
                                  'encontro': false
                              };

                              // Recorrer los productos en id_products
                              for (let i = 0; i < obj2.id_products.length; i++) {
                                  if (obj2.id_products[i] === product.id) {
                                      // Se encontró el producto en la categoría actual
                                      obj2.encontro = true;
                                      break;
                                  }
                              }

                              if (!obj2.encontro) {
                                  obj2.id_products.push(product.id);
                                  document.getElementById("card_" + product.id).style.display = "none";
                              }
                              array3.splice(index, 1, obj2);
                            }
                        });
                      }              
                  });   
                         
              });

              array2.forEach((id)=>{
                  document.getElementById("accordionEx_"+id).style.display = "none";
              });
              
              let productos_por_ver = array3.id_products;
              array3.forEach((objeto)=>{
                  if(objeto.encontro == false){              
                    document.getElementById("accordionEx_"+objeto.id_category).style.display = "none"; 
                    }else{
                      this.categories.forEach((category) =>{
                        if(category.id_category == objeto.id_category){
                          category.products.forEach((product) =>{
                          if(!prod_ver.includes(product.id)){                                      
                            document.getElementById("card_"+product.id).style.display = "none"; 
                          }else{     
                            //prod_ver.push(product.id);
                            document.getElementById("card_"+product.id).style.display = "block";
                          }
                        });
                        }
                      });
                  }
              });
              /*
              this.categories.forEach((detail)=>{
              document.getElementById("accordionEx_"+detail.id_category).style.display = "none";
              });
              this.product_list.forEach((product) =>{  
                if(product.name.trim().toUpperCase().includes(caracter.trim().toUpperCase())){
                  self.product_list_aux.push(product);
                }
              });
              this.product_list_aux = this.removeDuplicates(this.product_list_aux,'id');
              */
            }  
          }
      }else{
        //cuando queda vacio el input search
        if(this.view_mobile){
          $(".mobile-view").show();
          $(".filter-default-categorys").hide();
          $(".result-mobile-view").hide();
        } 
        if (this.desktop_main_view && !this.view_mobile) {
          $(".desktop-view").show();
          $(".filter-default-categorys").hide();
          $(".result-desktop-view").hide();
        }else{
          this.categories.forEach((category) =>{              
            document.getElementById("accordionEx_"+category.id_category).style.display = "";
               category.products.forEach((product) =>{              
                document.getElementById("card_"+product.id).style.display = "";              
              });  
          });
        }  
      }
    }, 
    search(){
      var caracter = document.getElementById('buscar').value;
      
      let origin_categories = JSON.parse(this.rawCategories);
      if(caracter.trim() == ""){
        this.categories = origin_categories;
        return;
      }
      let show_categories = [];
      origin_categories.forEach(category => {
        let show_products = [];
        category.products.forEach(product =>{
          if(product.name.toUpperCase().includes(caracter.toUpperCase())){
            show_products.push(product);
          }
        });
        if(show_products.length > 0){
          category.products = show_products;
          show_categories.push(category);
        }
      });
      this.categories = show_categories;

    },
    getBrowserInfo() {
      var ua= navigator.userAgent, tem, 
      M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
          tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
          tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    },
    printBySocket(id_order, comanda = false, kiosko = false) {
      var self = this;
      let url = `${process.env.VUE_APP_API_URL_BETA}/api/socket-order/getDataPrintOrder/${id_order}`;
      //let url = `${process.env.VUE_APP_API_URL_DEV}/api/socket-order/getDataPrintOrder/${id_order}`;
      if (comanda) url += '/true';

      axios.get(url)
        .then(res => {
          if (res.data.error == false) {
            const printData = res.data.data;
            let socketToUse = this.socketPrint;

            if (kiosko) {
              this.socketPrint.emit('new print', printData);
              this.printImin(printData);

              if (this.selectedDevice) {
                printUSB(printData);
                this.socketPrint.emit('new print', printData);
              }
              this.resetForm();
            } else if (printData.type_print !== "unidades") {
              if (this.socketUnified) {
                socketToUse = this.socketTable;
              }
              socketToUse.emit('new print', printData);
            }

            //Si estamos en entorno DEV, reseteamos antes de esperar confirmación
            if (url.includes(process.env.VUE_APP_API_URL_DEV)) {
              this.exit_component_2 = true;
              this.resetForm();
            }

            // Esperar confirmacion
            let confirmationReceived = false;
            const confirmationTimeout = setTimeout(() => {
              if (!confirmationReceived) {
                this.exit_component_3 = true; // Mostrar mensaje de error
              }
            }, 2000);
            socketToUse.on('print confirmation', () => {
              confirmationReceived = true;
              clearTimeout(confirmationTimeout);
            });

          } else {
            console.error('Error al obtener datos de impresión.');
          }
          
        })
        .catch(err => {
          console.error('Error en la petición:', err);
        });
    },

    async paginaDePrueba(data) {
      if (data.bebidas.length > 0) {
        data.bebidas.forEach(item => {
          data.details.push(item);
        });
      }

      const ejemploDatos = {
        header: {
          title: 'PAGINA DE PRUEBA',
          company: `${this.license.name}`,
          nit: data.nit_business || 'No definido',
          city: data.city_point || 'VALLEDUPAR',
          phone: this.license.phone || 'No definido',
          address: this.license.address || 'No definido',
          resolution: data.resolution || 'No definida',
          prefix: 'HABILITADA DESDE 1 AL 10000 CON PREFIJO: CO'
        },
        orderNumber: data.document_number || 'No definido',
        date: data.document_date || 'No definida',
        seller: data.vendedor || 'No definido',
        customerName: data.client_name || 'No definido',
        customerNit: data.client_identification || 'No definido',
        customerAddress: data.client_address || 'No definido',
        items: [],
        service: data.service,
        shipping: data.shipping,
        subtotal: data.subtotal,
        total_discount: data.total_discount,
        tax: data.impuesto_consumo == null ? 0 : parseFloat(data.impuesto_consumo.replace('$', '').replace(',', '').trim()),
        subtotalWithTax: data.subtotal_without_imp,
        paymentMethod: data.payment_methods || 'Efectivo',
        total: data.total,
        cufe: data.tascode || 'No disponible'
      };

      // Reemplazamos el map con un ciclo for      
      for (const detail of data.details) {
        ejemploDatos.items.push({
          description: detail.product_invoice || 'Producto no disponible',
          price: detail.value,
          quantity: detail.quantity || 1
        });
      }

      this.preview = this.formatearTicket(ejemploDatos);

      try {
        await this.selectedDevice.open();
        await this.selectedDevice.selectConfiguration(1);
        await this.selectedDevice.claimInterface(0);

        const commands = new Uint8Array([
          0x1b, 0x40,
          0x1b, 0x61, 0x00,
          ...new TextEncoder().encode(this.preview),
          0x0a, 0x0a, 0x0a,
          0x1d, 0x56, 0x41, 0,
        ]);

        await this.selectedDevice.transferOut(1, commands);
        this.updateStatus('status', 'Página de prueba enviada correctamente');
      } catch (error) {
        this.updateStatus('status', 'Ocurrió un error al imprimir', true);
      }
    },
    formatearTicket(datos) {
      const linea = '-'.repeat(45) + '\n';
      const anchoMax = 45;
      let ticket = '';

      // Encabezado centrado
      const encabezado = [
        datos.header.title,
        datos.header.company,
        `Nit: ${datos.header.nit}`,
        `Ciudad: ${datos.header.city}`,
        `Telefono: ${datos.header.phone}`,
        `Direccion: ${datos.header.address}`,
        datos.header.resolution,
        datos.header.prefix
      ].join('\n');

      ticket += this.centrarTexto(encabezado, anchoMax) + '\n';
      ticket += linea;

      const detalleFactura = [
        `Factura Electronica de Venta: ${datos.orderNumber}`,
        `Fecha: ${datos.date}`,
        `Vendedor: ${datos.seller}`,
        `Nombre: ${datos.customerName}`,
        `Nit: ${datos.customerNit}`,
        `Direccion: ${datos.customerAddress}`,
      ];

      detalleFactura.forEach(lineaDetalle => {
        ticket += lineaDetalle + '\n'; // Alinear a la derecha usando el ancho máximo
      });

      ticket += linea;

      // Productos (formato de columnas fijas)
      ticket += 'Descripcion               Cant       Valor\n';
      datos.items.forEach(item => {
        const descripcion = item.description.substring(0, 20).padEnd(20);
        const cantidad = item.quantity.toString().padStart(10);
        const valor = item.price.padStart(15);
        ticket += `${descripcion}${cantidad}${valor}\n`;
      });
      ticket += linea;

      // Totales alineados a la derecha
      const totales = [
        `Subtotal: ${datos.subtotalWithTax}`,
        `Imp. Consumo: ${datos.tax}`,
        `Propina: ${datos.service}`,
        `Domicilio: ${datos.shipping}`,
        `Descuento: ${datos.total_discount}`,
        `Total: ${datos.total}`,
        `Forma de pago: ${datos.paymentMethod}`,
        //`Subtotal sin Imp: ${datos.subtotal}`,
        
      ];

      totales.forEach(lineaTotal => {
        ticket += lineaTotal.padStart(anchoMax) + '\n'; // Alinear a la derecha
      });

      ticket += linea;

      // Pie de página
      const pieDePagina = [
        'Qr para descargar su factura.',
        `No. Factura Electronica: ${datos.orderNumber}`,
        `Cufe: ${datos.cufe}`,
        '',
        '¡Gracias por su compra!',
        'Impreso por VinApp'
      ];

      // Aplicar centrado a cada línea del pie de página
      const pieDePaginaCentrado = this.centrarTexto(pieDePagina.join('\n'), anchoMax);
      ticket += pieDePaginaCentrado;

      return ticket;
    },
    centrarTexto(texto, ancho) {
      const partes = texto.split('\n'); // Dividir en líneas
      return partes.map(linea =>
        linea
          .padStart(linea.length + Math.floor((ancho - linea.length) / 2), ' ') // Centrar
          .padEnd(ancho, ' ') // Asegurar ancho total
      ).join('\n');
    },

    async getUsedTables(id_point){
      try {
        const res = await axios.get('/api/company/getusedtables/'+this.form.id_companie+'/'+id_point);
        this.mesas = res.data.info.mesas;
        this.mesas_ocupadas = res.data.info.mesas_ocupadas;
        if(res.data.info.bancolombia_qr == true)this.formPay.payOnline = true;
        this.status_qr_bancolombia = res.data.info.bancolombia_qr;
        if(res.data.info.current_box && res.data.info.current_box != ''){
          this.id_cash_movement=res.data.info.current_box.id_cash_movement;
          localStorage.setItem('id_cash_movement', this.id_cash_movement)
        }
        // Actualizar show_table_name si está disponible en la respuesta
        if(res.data.info.show_table_name !== undefined){
          this.show_table_name = res.data.info.show_table_name;
          localStorage.setItem('show_table_name', res.data.info.show_table_name);
        } else {
          // Si no está en la respuesta, actualizar desde localStorage y convertir a booleano
          const storedValue = localStorage.getItem('show_table_name');
          this.show_table_name = storedValue === 'true' || storedValue === true;
        }
      } catch(err) {
        console.error('Error en getUsedTables:', err);
      }
    },
    setImageWithFallback(elementId, path, serverPrimary, serverFallback) {
      const img = document.getElementById(elementId);
      const primaryUrl = serverPrimary + path;
      const fallbackUrl = serverFallback + path;

      img.src = primaryUrl;

      img.onerror = function () {
        if (img.src !== fallbackUrl) {
          img.src = fallbackUrl;
        }
      };
    },
    async setupCompanie() {
        this.getBrowserInfo = 'Webview o Browser';                  
        var data = new FormData();
        data.append('uri',this.$route.params.id);
        data.append('browser',this.getBrowserInfo); 
        data.append('os',this.nameOS); 
        axios.post('/api/company/getDataStoreCompaniev2',data,{
        headers: {
          "Access-Control-Allow-Origin": "*"
         }
        })
        .then(res => {          
          if(res.data.error == false){
            this.license = res.data.info;
              //this.$route.params.id+'/'+this.getBrowserInfo+'/'+this.nameOS 
              var self = this;
              //NUEVO SETUP
               this.mantenimiento = res.data.info.mantenimiento;
                if (this.mantenimiento) {
                  document.getElementById('content').style.display = 'none'
                  var body = document.body;     
                  setTimeout(function(){ body.classList.add("loaded"); },0);
                  return false;
                }
              localStorage.setItem('show_table_name', res.data.info.show_table_name);
              this.show_table_name = res.data.info.show_table_name;
              this.print_waiter_bill = res.data.info.print_waiter_bill;
              this.multiply_addition_product = res.data.info.multiply_addition_product;
              this.active_login = res.data.info.active_login;
              this.select_waiters = res.data.info.select_waiters;
              this.observacion_xproducto = res.data.info.observacion_xproducto;
              this.show_category_kiosko = res.data.info.show_category_kiosko;
              this.mesas_ocupadas = res.data.info.mesas_ocupadas;
              this.pedidos_fuera_horario = res.data.info.pedidos_fuera_horario;
              this.print_comanda_mesero = res.data.info.print_comanda_mesero;
              this.priority_shipping = res.data.info.priority_shipping;
              this.pay_epayco = res.data.info.pay_epayco;
              this.auto_take_delivery = res.data.info.auto_take_delivery;
              this.value_priority_shipping = res.data.info.value_priority_shipping;
              this.old_price_status = res.data.info.previous_prime;
              this.incremento_datafono_companie = res.data.info.incremento_datafono_companie;
              localStorage.setItem('old_price_status', this.old_price_status);
              this.schedule_state  = res.data.info.schedules_status;
              this.schedule_list = res.data.info.schedules;
              setTimeout(function(){ self.actualDay(); },1500); 
              this.default_categorys = res.data.info.default_categorys;
              this.filter_option = res.data.info.filter_option;
              this.activate_observation = res.data.info.activate_observation;
              localStorage.setItem('individual_addition', res.data.info.individual_additions);
              localStorage.setItem('filter_option', this.filter_option);
              localStorage.setItem('an_addition',res.data.info.an_addition) 
              localStorage.setItem('id_company',res.data.info.id)  
              localStorage.setItem('id_point_companie', this.id_point_companie);
              this.restaurant_list = res.data.restaurantes;
              this.close_store = res.data.info.close_store;
              this.delete_product_waiter = res.data.info.delete_product_waiter;
              this.kiosko_dataphone = res.data.info.kiosko_dataphone;
              this.payonlineaddress = res.data.info.payonlineaddress;
              this.edit_tables_waiter = res.data.info.edit_tables_waiter;
              this.change_table_waiter = res.data.info.change_table_waiter;
              this.close_store_text = res.data.info.close_store_text;
              this.color_botones = res.data.info.color_botones;
              this.input_nit = res.data.info.input_nit;
              this.edit_other_table = res.data.info.edit_other_table;
              localStorage.setItem('edit_other_table', res.data.info.edit_other_table);
              if(res.data.info.active_login && this.mesero && !res.data.info.active_login_with_pin){
                localStorage.setItem('select_waiters', res.data.info.select_waiters);
                this.activeLogin = res.data.info.active_login;
                localStorage.setItem('active_login_with_code', res.data.info.active_login_with_code);
                if(localStorage.getItem('code_login')){
                  this.login(res.data.info.id, localStorage.getItem('code_login'))
                } else{
                  this.loginStatus=false
                }
              }
              else this.loginStatus=true;
              this.active_login_with_pin = res.data.info.active_login_with_pin;
              if(this.active_login_with_pin)this.login_with_pin = true;

              this.enable_waiter_print =  res.data.info.enable_waiter_print;
              this.activate_pick_it_up = res.data.info.activate_pick_it_up;
              this.status_contraentrega = res.data.info.status_contraentrega;
              this.seguimiento_pedido_wpp = res.data.info.seguimiento_pedido_wpp;
              this.wa_redirect = res.data.info.wa_redirect;
              this.wa_redirect_auto = res.data.info.wa_redirect_auto;
              if(this.mesero)this.wa_redirect_auto = false;
              this.desktop_main_view = res.data.info.desktop_view;
              this.letter_main_view = res.data.info.letter_view;
              localStorage.setItem('activate_observation',res.data.info.activate_observation)
              localStorage.setItem('contraentrega', this.status_contraentrega);
              localStorage.setItem('seguimiento_pedido_wpp', this.seguimiento_pedido_wpp);
              localStorage.setItem('wa_redirect', this.wa_redirect);
              localStorage.setItem('wa_redirect_auto', this.wa_redirect_auto);
              localStorage.setItem('custom_dominio', res.data.info.dominio);
              this.delivery_time = res.data.info.delivery_time;
              localStorage.setItem('delivery_time', this.delivery_time);
              document.getElementById("main_loader").style.borderTopColor = this.color_botones;
              var styleElem = document.head.appendChild(document.createElement("style"));
              styleElem.innerHTML = `#main_loader:before {content: '';position: absolute;top: 5px;left: 5px;right: 5px;bottom: 5px;border-radius: 50%;border: 3px solid transparent;border-top-color: ${this.color_botones};animation: spin 3s linear infinite;} #main_loader:after {content: '';position: absolute;top: 15px;left: 15px;right: 15px;bottom: 15px;border-radius: 50%;border: 3px solid transparent;border-top-color: ${this.color_botones};animation: spin 2s linear infinite;}`;

              
              if (!this.close_store){
                body = document.body;     
                setTimeout(function(){ body.classList.add("loaded"); },0);
                return false;
              }
              //END NUEVO SETUP
              this.companie_name = res.data.info.name; 

              const logos = res.data.info.logos;
              const backUrl = "https://back.vinapp.co";
              const betaUrl = "https://beta.vinapp.co";

              this.setImageWithFallback("logo0", logos[0], backUrl, betaUrl);
              this.setImageWithFallback("logo4", logos[0], backUrl, betaUrl);
              this.setImageWithFallback("logo2", logos[2], backUrl, betaUrl);
              this.setImageWithFallback("logo1", logos[1], backUrl, betaUrl);
              this.setImageWithFallback("logo5", logos[1], backUrl, betaUrl);
              this.setImageWithFallback("logo6", logos[2], backUrl, betaUrl);
              this.setImageWithFallback("logo7", logos[0], backUrl, betaUrl);
              
              this.logo_company = this.url_images+res.data.info.logos[0];
              localStorage.setItem('logo_company', this.logo_company)

              if(res.data.info.active_modal_video_app && res.data.info.modal_video_app[0] != '' && !this.mesero){
                var url_image = process.env.VUE_APP_API_URL + "/";
                this.mediaUrl = url_image + res.data.info.modal_video_app[0];
                this.loader_video = true;
              }
              
              
              this.portadas = res.data.info.portadas;
              this.direccion = res.data.info.address;
              this.horario = res.data.info.horario;
              //recibimos los parametros de portadas de portadas status
              this.banner_promo_status = res.data.info.banner_prom;
              //alert(this.company.banner_prom)
              this.portadas_promo = res.data.info.portada_prom;
              let id_companie = res.data.info.id;
              let type_id = res.data.info.type;    
              this.view_other_tables = res.data.info.view_other_tables;
              this.portPrint = res.data.info.port_print;
              this.portDashboard = res.data.info.port_dashboard;     
              this.socketUnified = res.data.info.socket_unified;
              this.form.id_companie = id_companie;
              if (res.data.info.mesas.length > 0) {
                this.mesas_cache = res.data.info.mesas;  
              }
              //MESERO
              if(this.mesero && res.data.info.mesas.length > 0) {
                this.mesas = res.data.info.mesas;              
                this.form.mesa = this.mesas[0].number_table;     
                if(!this.socketUnified){
                  this.socketPrint = io(`${process.env.VUE_APP_API_URL}:${this.portPrint}`, { transports: ['websocket'], upgrade: false });
                }
                if(this.nombre_mesero){
                  this.getTablesByMesero();
                  this.form.nombre_mesero=this.nombre_mesero;
                }
                if(res.data.info.view_other_tables){
                  this.getTablesByMesero();
                }
              }
              //ACTIVAR MODAL FORMULARIO PARA CLIENTE NUEVO
              if(res.data.info.form_new_client_app && this.$route.params.mesa){
                if(!this.companiesFormNewClient.includes(res.data.info.id)){
                  this.formNewClientModal=true
                }
              }
              if(res.data.info.form_new_client_app_delivery && !this.$route.params.mesa){
                if(!this.companiesFormNewClient.includes(res.data.info.id)){
                  this.formNewClientModal=true
                }
              }
              //END MESERO

              //EXCEPCION OLAYA PARK QR 
                if(res.data.info.id == 6846 && this.$route.params.mesa)this.olayaPark = true;
              //END 

              if(!this.socketUnified){              
                this.socketTable = io(`${process.env.VUE_APP_API_URL}:${this.portDashboard}`,{transports: ['websocket'], upgrade: false})
              }else{              
                this.portDashboard = this.portPrint;
                this.socketTable = io(`${process.env.VUE_APP_API_URL}:${this.portDashboard}`,{transports: ['websocket'], upgrade: false})
              }
              localStorage.setItem('tipo', type_id);
              
              //document.getElementById("home").style.display = "";
              body = document.body;     
              setTimeout(function(){ body.classList.add("loaded"); },500);            
              if(type_id!=27)this.getCategory(id_companie);
              if (type_id==27)this.getCategoriesDev(id_companie);
              this.validateView();
              if(!this.reset_page)this.categoriesDone = true;
              this.getIdCashMovement(id_companie);
            }
          })
        .catch(err => {    
        });
      
    }, 
    capitalize(s){
    return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
    },
    getCategoriesDev(id_companie){
      var data = new FormData();
      data.append('id_companie',id_companie);
      axios.post('/api/category/postOptimizedCategoriesEcommerceV2',data) 
       .then(res => {    
        var body = document.body;     
        setTimeout(function(){ body.classList.add("loaded"); },0);
        this.categories = res.data.categories;
        this.newSetupCompanie(res.data.licencia);
        localStorage.setItem('url_images', this.url_images);
        document.getElementById('content').style.display = 'block'; 
        if(this.company.type == 27 /*Eccommerce*/){
            this.data = {
              store : this.store,
              company : this.company, 
              uri: '',
              //api: `${process.env.VUE_APP_API_URL}/api/`,
              //api: `${process.env.VUE_APP_API_URL_DEV}/api/`,
              api: `${process.env.VUE_APP_API_URL_BETA}/api/`,
              url_images: this.url_images,
              portadas: this.portadas,
              categories: this.categories,
              colorBotones: this.color_botones,
              portadas_promo: this.portadas_promo,
              status_promo: this.banner_promo_status
            }
            this.Ecommerce = true;
            //alert(this.company.fecha_nacimiento)
            localStorage.setItem('Email-checkout', this.company.email);
            localStorage.setItem('fecha_nacimiento',this.company.fecha_nacimiento);
            localStorage.setItem('hora_entrega',this.company.hora);
            localStorage.setItem('fecha_entrega',this.company.fecha_hora)
            localStorage.setItem('Cedula-checkout', this.company.cedula);
            localStorage.setItem('Domicilio', this.store.valor_domicilio);
            localStorage.setItem('Nombre_comercial', this.company.name);
            localStorage.setItem('Telefono_pedidos', this.store.telefono_pedidos);
            localStorage.setItem('id_companie', this.company.id);
            localStorage.setItem('cash',this.company.cash);
            localStorage.setItem('transfer',this.company.transfer);
            localStorage.setItem('dataphone',this.company.dataphone);
            localStorage.setItem('imagen_gift',this.company.imagen_gift);
            localStorage.setItem('ciudades_entrega',JSON.stringify(res.data.ciudades_entrega));
          }
          //this.initMap(); 
        this.loading = false;
       })
       .catch(err => {    
       });
    },
    setStock(id_product, index, status_variants){
      var unidades = 0;
      this.categories[index].products.forEach((product)=> {
        product.stock.forEach((item) => {
          if (item.id == id_product){
            if (!status_variants) {
              unidades = item.stock;  
            }else{
              unidades += item.stock;
            }
          }  
        });
      })
      if (unidades < 0) unidades = 0;
      return unidades;
    },
    validateStock2(product){
        return product.stock.filter(element => element.stock > 0).length > 0 ? false : true
    },
    getStockSumatory(product){
       let sumatory = 0
       product.stock.forEach((element) => {
          sumatory += element.stock
       })
       return sumatory
    },
    updateMesaTimers() {
      // Recorre las mesas y actualiza el tiempo transcurrido
      this.ordersTables.forEach(mesa => {
        if (mesa.creacion) {
          const createdAt = new Date(mesa.creacion);
          const now = new Date();
          const diff = Math.floor((now - createdAt) / 1000); // segundos
          this.$set(this.mesaTimers, mesa.number_table, this.formatTime(diff));
        }
      });
    },
    formatTime(seconds) {
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      return (
        (h > 0 ? String(h).padStart(2, '0') + ':' : '') +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0')
      );
    },
    newSetupCompanie(data){
      var self = this;
      this.store = data.store_data;
      //formas de pago
      this.cash = data.companie_data.cash;
      this.barrios_listado = data.companie_data.barrios.map((item)=> {
        return {
          id: item.nombre,
          text: `${ item.nombre } - ${ new Intl.NumberFormat("de-DE").format(item.precio) }`,
          precio: item.precio
        }
      })

      this.activar_barrio = data.companie_data.activar_barrio;
      this.transfer = data.companie_data.transfer;
      this.dataphone = data.companie_data.dataphone;
      this.companie_decimales = data.companie_data.decimales;
      


      localStorage.setItem('cash', this.cash);
      localStorage.setItem('transfer', this.transfer);
      localStorage.setItem('dataphone', this.dataphone);
      localStorage.setItem('companie_id', this.company.id);
      if(this.mesero)this.form.id_type_forma_pago = data.companie_data.id_type_forma_pago_default;
      //PAGO EN LINEA
      this.formPay.payOnline = data.companie_data.pay_online;
      localStorage.setItem('status_pay_online', this.formPay.payOnline);
      //END PAGO EN LINEA
      this.company = data.companie_data;
      this.custom_quantity = this.company.custom_quantity;
      localStorage.setItem('custom_quantity', this.custom_quantity);
      this.status_map = this.company.delivery_zone;
      localStorage.setItem('status_map', this.status_map);
      this.transfer_support = this.company.transfer_support;
      this.inventory_day = this.company.inventory_day;
      this.currency = this.company.currency;
      this.finish_order = this.company.finish_template;
      this.telefono_pedidos = data.store_data.telefono_pedidos;            
      this.seguimiento_pedido = this.company.seguimiento_pedido;
      localStorage.setItem('seguimiento_pedido', this.seguimiento_pedido);
      localStorage.setItem('currency', this.currency);
      localStorage.setItem('license_uri', this.store.uri);
      this.delivery_message = this.company.delivery_message; 
      this.combination_default_first = this.company.combination_default_first; 
      if(this.company.managment_table)this.managmentTable = true;           
      this.banks = this.company.banks;
      localStorage.setItem('banks_accounts', JSON.stringify(this.banks));
      document.getElementById("title-page").innerHTML = this.company.name+" - "+this.capitalize(this.company.ciudad);
      if(this.company.ciudad && this.status_map){
        this.setAdrress(this.company.ciudad, 2);
      }
      localStorage.setItem('telefono_pedidos', this.store.telefono_pedidos);
      localStorage.setItem('nombre_comercial', this.store.name);
      this.splash = data.store_data.splash;

      this.descripcion = data.store_data.descripcion;
      if (!this.descripcion) {
        document.getElementById("meta-description").content= this.store.name;
      }else{
        document.getElementById("meta-description").content= this.descripcion;
      } 
      
      this.color_botones = data.store_data.color_botones
      localStorage.setItem('color_licencia', this.color_botones)
      this.color_letra = data.store_data.color_letra
      //if(data.store_data.valor_domicilio)this.domicilio = data.store_data.valor_domicilio;
      if(data.store_data.valor_domicilio){
        if (this.delivery_app) {
          this.domicilio = JSON.parse(localStorage.getItem('delivery_cost'));  
        }else{
          this.domicilio = data.store_data.valor_domicilio;
        }  
      }
      localStorage.setItem('domicilio', this.store.valor_domicilio);    
      if(this.estado_domicilio || this.estado_domicilio_mesero == true)this.form.direccion = localStorage.getItem('direccion');
      this.form.nombres = localStorage.getItem('nombre');
      this.form.telefono = localStorage.getItem('telefono');
      this.form.email = localStorage.getItem('email');

      //LOGICA PARA LOS PUNTOS DE VENTAS
          this.points = data.points;
          localStorage.setItem('puntos', JSON.stringify(this.points));   
          //salvamos el telefono del punto principal
          this.telefonoPuntoPrincipal = this.points[0].telefono_pedidos;               
          this.idPuntoPrincipal = this.points[0].id_point;
          localStorage.setItem('id_point', this.points[0].id_point);
          if(this.points.length > 1)this.multipuntos = true;
          //Se carga el id del punto de la compañia es unipunto y cuando la mesa 
          if(this.points.length == 1 || this.form.mesa > 0){
            this.form.id_point = this.points[0].id_point;
          }   

          if(this.points.length == 1 && !this.active_login_with_pin){
            this.getwaiters(this.form.id_companie, this.form.id_point);
          } 
        
          //end              
      //FIN LOGICA
      this.statusCedula = data.companie_data.cedula;
      this.statusEmail = data.companie_data.email;
      this.statusNacimiento = data.companie_data.fecha_nacimiento;
      this.statusFecha = data.companie_data.fecha_hora;
      this.statusBarrio = data.companie_data.barrio;
      this.priority = data.companie_data.priority;
      this.coupons = data.companie_data.coupons;
      localStorage.setItem('r_cedula', this.statusCedula);
      localStorage.setItem('r_email', this.statusEmail);
      localStorage.setItem('r_barrio', this.statusBarrio);
      localStorage.setItem('company_coupon', data.companie_data.coupons);
      if(this.statusEmail)this.form.email = localStorage.getItem('email');
      if(this.statusCedula)this.form.cedula= localStorage.getItem('cedula');
      if(this.statusBarrio)this.form.barrio= localStorage.getItem('barrio');     
      if(this.statusFecha){
        setTimeout(function(){  
            self.setMinutes();
        }, 500);
      }   
      //end formas
      //autoservicio
      this.autoservicio = data.store_data.autoservicio;            
      this.jornada = data.companie_data.jornada;
      localStorage.setItem('autoservicio', this.autoservicio);
      localStorage.setItem('btn-mesa', data.companie_data.boton_mesa);
      localStorage.setItem('btn-recogerlo', data.companie_data.boton_recogerlo);
      localStorage.setItem('btn-domicilio', data.companie_data.boton_domicilio);
      //logica para enable or disabled los botones de los canales de atención
      if(!data.companie_data.boton_mesa)document.getElementById("btn-mesa").disabled=true;
      if(!data.companie_data.boton_recogerlo)document.getElementById("btn-recogerlo").disabled=true;
      if(!data.companie_data.boton_domicilio){
          document.getElementById("btn-domicilio").disabled=true;
          document.getElementById("check-recogerlo").style.display = "";
          document.getElementById("check-mesa").style.display = "none";
          document.getElementById("check-domicilio").style.display = "none";                
          this.formaEntrega.mesas = false;
          this.formaEntrega.domicilio = false;
          this.formaEntrega.recogerlo = true; 
          this.estado_domicilio = false;
          this.optLocal = true;
      }
      document.getElementById("icon-ios").href = data.store_data.icon_ios;
      document.getElementById("titulo").style = `color:${data.store_data.color_letra}`;
   
      //se cargan los horarios y se valida que la jornada este habiltada
      if(data.horarios.length > 0 && this.jornada){
        this.horarios = data.horarios;
        localStorage.setItem('horarios', JSON.stringify(this.horarios));
        localStorage.setItem('jornada', this.jornada);
      } 
      if(data.companie_data.type!=27)document.getElementById("manifest").href = data.store_data.manifest;
      
    },
    getCategory(id_companie){
     let puntero = false;
     var data = new FormData();
     data.append('id_companie',id_companie);
     if (this.mesero || this.$route.params.mesa)puntero = true
      //alert(puntero)
     data.append('mesero',puntero); 
     data.append('id_point_companie', this.id_point_companie);

     const apiUrl = process.env.VUE_APP_API_URL_BETA;
     //const apiUrl = process.env.VUE_APP_API_URL_DEV;
     axios.post(`/api/category/getOptimizedCategoriesV2`, data, {
        headers: {
          "Access-Control-Allow-Origin": "*"
         }
        }) 
     .then(res => {
      this.categoriesDone = false;
      var self=this
      self.product_list=[]
      this.categories = res.data.categories;
      if(self.kiosko){
        this.sectionCategory(res.data.categories[0])
        this.wa_redirect_auto = false;
        this.recogerPedido();
      }

      if(this.show_category_kiosko){
        this.sectionCategory(res.data.categories[0])
      }
      this.rawCategories= JSON.stringify(res.data.categories);
      this.newSetupCompanie(res.data.licencia);
      
      //this.barrios_listado = res.data.licencia.companie_data.barrios
      if (this.categories.length > 5) {
        this.style1 = true;
        this.primer_array = this.categories.slice(0,5);
        this.segundo_array = this.categories.slice(5, this.categories.length)
      }
      if (this.inventory_day) {
        this.categories.forEach((item) => {
          item.products.map((product) =>{
            product.sale_off = this.validateStock2(product);
            product.stock_sumatory = this.getStockSumatory(product)
          });
        });
      }
      this.categories.forEach((detail) => {
        detail.products.forEach((detail2)=>{
          self.product_list.push(detail2)
        })
      });
      localStorage.setItem('url_images', this.url_images);
      document.getElementById('content').style.display = 'block';

      if(this.company.type == 77){
        this.data_message = {
          name : this.company.name,
          horario : this.store.horario,
          address : this.company.address,
          logo: this.store.logos[1],
          portada: this.store.portadas[1],
          categorias: this.categories,
          color: this.store.color_botones,
          domicilio: this.store.valor_domicilio
        }  
        localStorage.setItem('telefono_pedidos', this.store.telefono_pedidos);
        localStorage.setItem('nombre_comercial', this.store.name);
        localStorage.setItem('number_guide', this.company.number_guide);
        localStorage.setItem('companie_id', this.company.id);
        this.status_message = true;
      }

      if (this.seguimiento_pedido) {
        localStorage.setItem('telefono_pedidos', this.store.telefono_pedidos);
        localStorage.setItem('nombre_comercial', this.store.name);
      }

      //Validamos el case cuando la company sea una Delivery App
      if (this.company.type == 99) {
        this.info_delivery = {
          id_mensajeria: this.company.id,
          nombre : this.company.name,
          horario : this.store.horario,
          direccion : this.company.address,
          logo: this.store.logos[1],
          portada: this.store.portadas[1],
          color: this.store.color_botones,
          restaurantes: this.restaurant_list,
          servicios: this.categories,
          domicilio: this.store.valor_domicilio
        }
        localStorage.setItem('telefono_pedidos', this.store.telefono_pedidos);
        localStorage.setItem('nombre_comercial', this.store.name);
        localStorage.setItem('number_guide', this.company.number_guide);
        localStorage.setItem('companie_id', this.company.id);
        if (localStorage.getItem('delivery_user') && localStorage.getItem('delivery_phone')) {
          this.status_delivery = true;
        }else{
          this.status_delivery_login = true;
        }
        //this.status_delivery_checkout = true;
      }

      if(this.company.type == 27 /*Eccommerce*/){
            //this.$router.push({ name: 'Ecommerce', params: { company: this.company, store: res.data.store_data}})
            this.data = {
              store : this.store,
              company : this.company, 
              uri: '',
              //api: `${process.env.VUE_APP_API_URL}/api/`,
              //api: `${process.env.VUE_APP_API_URL_DEV}/api/`,
              api: `${process.env.VUE_APP_API_URL_BETA}/api/`,
              url_images: this.url_images,
              portadas: this.portadas,
              categories: this.categories,
              colorBotones: this.color_botones,
              portadas_promo: this.portadas_promo,
              status_promo: this.banner_promo_status
            }
            this.Ecommerce = true;
            //alert(this.company.fecha_nacimiento)
            localStorage.setItem('Email-checkout', this.company.email);
            localStorage.setItem('fecha_nacimiento',this.company.fecha_nacimiento);
            localStorage.setItem('hora_entrega',this.company.hora);
            localStorage.setItem('fecha_entrega',this.company.fecha_hora)
            localStorage.setItem('Cedula-checkout', this.company.cedula);
            localStorage.setItem('Domicilio', this.store.valor_domicilio);
            localStorage.setItem('Nombre_comercial', this.company.name);
            localStorage.setItem('Telefono_pedidos', this.store.telefono_pedidos);
            localStorage.setItem('id_companie', this.company.id);
            localStorage.setItem('cash',this.company.cash);
            localStorage.setItem('transfer',this.company.transfer);
            localStorage.setItem('dataphone',this.company.dataphone);
            localStorage.setItem('imagen_gift',this.company.imagen_gift);
          }  
          //this.initMap();  
      this.loading = false;
     })
     .catch(err => {    
     });
    },
    formatPrice(value) {
        if(this.currency == "COP" && !this.companie_decimales){
          let val = (value/1).toFixed(0).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }else{
          return parseFloat(Math.round(value * 100) / 100).toFixed(2);
        }
      
        
    },
    async constructObjectProduct(id_product, name_product, description, value, statusVariants, variants, variant_detail, variant_combination, statusAddition, additions, addition_detail) {
      let stock = [];

      if (this.inventory_day) {
          const category = this.categories.find(cat => cat.products.some(prod => prod.id === id_product));
          if (category) {
              const product = category.products.find(prod => prod.id === id_product);
              if (product && product.stock.length > 0) {
                  stock = product.stock;
              }
          }
      }

      try {
          const apiUrl = process.env.VUE_APP_API_URL_BETA;
          //const apiUrl = process.env.VUE_APP_API_URL_DEV;
          const res = await axios.get(`${apiUrl}/api/category/getOptimizedDetailProduct/${id_product}`);
          this.objProductSidebar = {
            'id_product' : id_product,
            'name_product' : name_product,
            'description' : description,
            'value' : value,
            'addition_v': 0,
            'statusVariants' : statusVariants,
            'variants' : res.data.variants,        //
            'variant_detail' : res.data.variantes_detail,  //
            'variant_combination' : res.data.variantes_combinations,  //
            'statusAdditions': statusAddition,
            'additions' : res.data.addition,  //
            'addition_detail' : res.data.addition_detail,  //
            'stock' : stock,
            'inventory_day': this.inventory_day,
            'observation_optional': ""
          };
      } catch (error) {
          this.objProductSidebar = {
            'id_product' : id_product,
            'name_product' : name_product,
            'description' : description,
            'value' : value,
            'addition_v': 0,
            'statusVariants' : statusVariants,
            'variants' : variants,        //
            'variant_detail' : variant_detail,  //
            'variant_combination' : variant_combination,  //
            'statusAdditions': statusAddition,
            'additions' : additions,  //
            'addition_detail' : addition_detail,  //
            'stock' : stock,
            'inventory_day': this.inventory_day,
            'observation_optional': ""
          };
      }
    },

    async agregarProductoCarrito(id_product, name_product, description, value, statusVariants, variants, variant_detail, variant_combination, statusAddition, additions, addition_detail, address_included, stock, index) {  
      if (this.schedule_state && !this.pedidos_fuera_horario && !this.schedule_closed && !this.mesero) {
          alert('Hola! En el momento no estamos en servicio, más tarde podremos recibir tu pedido');
          return;
      }

      if (!this.v_restar_producto) {
          this.v_restar_producto = true;
          return;
      }

      if (this.observacion_xproducto) statusAddition = true;

      if ((statusVariants || statusAddition) && [26, 72].includes(this.company.type)) {
          this.objProductSidebar = "";
          await this.constructObjectProduct(id_product, name_product, description, value, statusVariants, variants, variant_detail, variant_combination, statusAddition, additions, addition_detail);
          
          this.data = {
              color: this.color_botones,
              product: this.objProductSidebar,  // Ahora objProductSidebar tendrá los datos correctos
              combination_default_first: this.combination_default_first,
              multiply_addition_product: this.multiply_addition_product
          };

          if (this.inventory_day && stock.reduce((sum, item) => sum + item.stock, 0) === 0) {
              return false;
          }

          this.addNewDataSidebar = true;
          return false;
      }

      let nuevo = !this.carrito.some(product => product.id_product === id_product);
      if (nuevo) {
          let unidades = stock.reduce((sum, st) => sum + st.stock, 0);
          if (this.inventory_day && unidades <= 0) {
              return false;
          }

          if ([26, 40, 72].includes(this.company.type)) {
              let product = {
                  id_product,
                  name_product,
                  addition_v: 0,
                  valor: value,
                  cantidad: 1,
                  descuento: 0,
                  combination: false,
                  addition: [],
                  estado: false,
                  address_included,
                  observation_optional: ""
              };
              this.carrito.push(product);
          }
      }

      this.setStock(id_product, index, statusVariants);
      this.getTotalProductos();
      this.getTotalItems();
    },

    updateStockSumatory(id_product, action, quantity){
      this.categories.forEach((item) => {
          item.products.map((product) =>{
            if (product.id == id_product) {
                switch(action.toLowerCase()){
                  case "sumar":
                    product.stock_sumatory += quantity
                    break;

                  case "restar":
                    product.stock_sumatory -= quantity
                    break;
                }
            }
          });
      });
    },
    getValueStockSumatory(id_product){
      var cantidad = 0;
      this.categories.forEach((item) => {
          item.products.forEach((product) =>{
            if(product.id == id_product){
              cantidad = parseInt(product.stock_sumatory);
            }
          });
      });

      return cantidad;
    },
    sumarCantidad(id_product){   
      let pos = 0
      let cantidad_producto = 0;
      var new_product;
      var self = this;
      this.carrito.forEach((product)=>{
        if(product.id_product == id_product){
        if (self.inventory_day) {
          if (self.getValueStockSumatory(id_product) > 0) {
            new_product = {
              'id_product' : product.id_product,
              'name_product' : product.name_product,
              'valor': product.valor,
              'addition_v': 0,
              'cantidad' : (product.cantidad + 1),
              'descuento': 0,
              'combination': false,
              'addition': [],
              'estado' : false,
              'address_included' : product.address_included
            }
            cantidad_producto = new_product.cantidad
            this.carrito.splice(pos, 1, new_product);            
            this.updateStockSumatory(id_product, "restar", 1);
          }else{
            document.getElementById("product_"+id_product).innerHTML = new_product.cantidad;
            document.getElementById("product2_"+id_product).innerHTML = new_product.cantidad;
            document.getElementById("product3_"+id_product).innerHTML = new_product.cantidad;
          }

        }else{
          new_product = {
              'id_product' : product.id_product,
              'name_product' : product.name_product,
              'valor': product.valor,
              'addition_v': 0,
              'cantidad' : (product.cantidad + 1),
              'descuento': 0,
              'combination': false,
              'addition': [],
              'estado' : false,
              'address_included' : product.address_included
            }
            cantidad_producto = new_product.cantidad
            this.carrito.splice(pos, 1, new_product);                
          }
        }    
        pos++;
      });
      if(this.modal.cantidad == 0 && this.company.type == 27 /*eccomerce*/){
            new_product = {
              'id_product' : id_product,
              'name_product' : this.modal.name,
              'addition_v': 0,
              'valor': this.modal.price,
              'cantidad' : 1,
              'combination': false,
              'addition': [],
              'estado' : false
            }
            cantidad_producto = new_product.cantidad
            this.carrito.push(new_product);
      }
      if(this.company.type == 26 /*restaurante*/|| this.company.type == 40 /*Otros*/ || this.company.type == 72/*Carnicería*/){
        document.getElementById("product_"+id_product).innerHTML = cantidad_producto;
        document.getElementById("product2_"+id_product).innerHTML = cantidad_producto;
        document.getElementById("product3_"+id_product).innerHTML = cantidad_producto;
      }
      if(this.company.type == 27)this.modal.cantidad = cantidad_producto;
      this.getTotalProductos();
      this.getTotalItems();
      

    },
    restarCantidadDesktop(id_product){
      var pos = 0
      var cantidad_producto = 0;
      var self = this;
      var new_product=null
      this.carrito.forEach((product,index)=>{
        if(product.id_product == id_product){
          new_product = {
            'id_product' : product.id_product,
            'name_product' : product.name_product,
            'valor' : product.valor,
            'addition_v': 0,
            'cantidad' : (product.cantidad - 1),
            'descuento': 0,
            'combination': false,
            'addition': [],
            'estado' : false,
            'address_included' : product.address_included
          }
          cantidad_producto = new_product.cantidad
          pos=index;
        }
      });
      if(cantidad_producto == 0){
        setTimeout(function(){
          self.carrito.splice(pos,1); 
          document.getElementById("product2_"+id_product).innerHTML = "1";
          document.getElementById("product3_"+id_product).innerHTML = "1";
          document.getElementById("div_cantidades2_"+id_product).style.display = "none";
          document.getElementById("div_cantidades3_"+id_product).style.display = "none";
        },500);
      }else{
        this.carrito.splice(pos, 1, new_product);
        if (self.inventory_day) {
          this.updateStockSumatory(id_product, "sumar", 1);
        }
        if (cantidad_producto == 1) {
          document.getElementById("product2_"+id_product).innerHTML = "1"
          document.getElementById("product3_"+id_product).innerHTML = "1"
        }else{
          document.getElementById("product2_"+id_product).innerHTML = cantidad_producto
          document.getElementById("product3_"+id_product).innerHTML = cantidad_producto
        }
      }
      this.getTotalProductos();
      this.getTotalItems();
    },
    restarCantidad(id_product){ 
      let pos = 0
      let cantidad_producto = 0;
      var self = this; 
      this.v_restar_producto = false;           
      this.carrito.forEach((product)=>{
        if(product.id_product == id_product){ 
          var new_product = {
            'id_product' : product.id_product,
            'name_product' : product.name_product,
            'valor' : product.valor,
            'addition_v': 0,
            'cantidad' : (product.cantidad - 1),
            'descuento': 0,
            'combination': false,
            'addition': [],
            'estado' : false,
            'address_included' : product.address_included
          }
          cantidad_producto = new_product.cantidad
          this.carrito.splice(pos, 1, new_product);
          if (self.inventory_day) {
            this.updateStockSumatory(id_product, "sumar", 1);
          }  

          if(cantidad_producto == 0){
            //aca se elimina del carrito el producto                        
            this.carrito.splice(pos,1);    
            if(this.company.type == 26 /*restaurante*/|| this.company.type == 40 /*Otros*/ || this.company.type == 72/*Carnicería*/){

              setTimeout(function(){
                document.getElementById("div_cantidades_"+id_product).style.display = "none";
                document.getElementById("product_"+id_product).innerHTML = "1";
              },500);
              
            }else{
              //no se cierra el modal se deja en cantidad 1 pero se elimina el producto del carrito
              document.getElementById("modalProduct").style.display = "none";  
            }
          }else{            
            if(cantidad_producto == 1){
              if(this.company.type == 26 /*restaurante*/|| this.company.type == 40 /*Otros*/ || this.company.type == 72/*Carnicería*/){
                document.getElementById("product_"+id_product).innerHTML = "1"
              }
              if(this.company.type == 27)this.modal.cantidad = 1;
            }else{
              if(this.company.type == 26 /*restaurante*/|| this.company.type == 40 /*Otros*/ || this.company.type == 72/*Carnicería*/){
                document.getElementById("product_"+id_product).innerHTML = cantidad_producto
              }
              if(this.company.type == 27)this.modal.cantidad = cantidad_producto;
            }
          }
        }
        pos++
      })

      this.getTotalProductos();
      this.getTotalItems();
    },
    verPedido(){
       
      this.tr_priority_shipping = false;
      this.estado_domicilio_mesero = false
      const validarAI = this.fnAddressIncluded();      
      if(this.form.id_coupon){
        $('.botoncerrar').addClass("ocultarcupon");   
        this.validateCoupon();
      }
      this.total = 0;
      document.getElementById('jornadaPunto').style.display = 'none';  
      document.getElementById("menu").style.display = "none"
      document.getElementById("detalle_company").style.display = "none"
      document.getElementById("pedido").style.display = "";
      //sucede cuando en la url viene el numero de la mesa.
      if(this.form.mesa != 0){
        this.estado_domicilio = false;
        this.mesaPedido(false);
        document.getElementById("btn-recogerlo").disabled = true;
        document.getElementById("btn-domicilio").disabled = true;
        if(this.mesero)document.getElementById("btn-domicilio").disabled = false;
        if (this.activate_pick_it_up) document.getElementById("btn-recogerlo").disabled = false;
      }

      if(this.olayaPark){
        document.getElementById("btn-domicilio").disabled = false;
      }
     
      if (this.activar_barrio && !this.mesero){
        const url = location.pathname;
        let split = url.split('/');
        let numeroEnURL = parseInt(split[2]);

        if (!isNaN(numeroEnURL) && numeroEnURL >= 1 && numeroEnURL <= 999) {
          this.visible_barrio = false;
        } else {
          this.visible_barrio = true;
        }
      }else{
        this.openMapDetail();
      }
      
      var _self = this;
      _self.carrito.forEach((product)=>{
        if (_self.currency != "COP") {
          //_self.total += _self.formatDecimal(parseFloat(product.valor)*product.cantidad);
          _self.total += parseFloat(_self.formatDecimal((parseFloat(product.valor)*product.cantidad)+product.addition_v));
          parseFloat(_self.total);
        }else{
          if(!this.companie_decimales){
            _self.total += ((parseInt(product.valor)*product.cantidad)+product.addition_v);
          }else{
            _self.total += ((parseFloat(product.valor)*product.cantidad)+product.addition_v);
          }
        }       
      });
      //validamos si hay productos con domicilio incluido
      if(_self.estado_domicilio && !validarAI){
        if (_self.currency != "COP") {
          parseFloat(this.domicilio)
          _self.total += parseFloat(this.formatDecimal(this.domicilio));
        }else{
          if(!this.companie_decimales){
            this.total += parseInt(this.domicilio);
          }else{
            this.total += parseFloat(this.domicilio);
          }
          
        }
      } 
      if(this.form.descuento>0){
        if(!this.companie_decimales){
          this.total += parseInt(this.form.descuento); 
        }else{
          this.total += parseFloat(this.form.descuento); 
        }
      }

      if(this.kiosko){
        this.recogerPedido();
        this.estado_domicilio = false;
        this.estado_domicilio_mesero = false;
      }

      if(this.mesero == true)this.mesaPedido();
      
    },
    checkBox_priority_shipping(){
      if(this.tr_priority_shipping){
        this.total += parseInt(this.value_priority_shipping);
      } else{
        this.total -= parseInt(this.value_priority_shipping);
      }
    },
    fnAddressIncluded(){ 
      let status = false;     
      const validar = this.carrito.filter(item => item.address_included == true);
        if(validar.length > 0){   
            this.addressIncluded = true;
            document.getElementById("tr_domicilio").style.display = "none";
            status = true;
        }else{ 
            this.addressIncluded = false;
        }        
        return status;
    },
    setHoraEntrega(inicio = 1,fin = 12,validar = true){            
        document.getElementById('horaEntrega').innerHTML = '';
        document.getElementById('horaEntrega').innerHTML = '<option value="13" selected="selected" disabled="disabled">Hora</option>';
        if(!validar){
          inicio = inicio -= 12;
          fin = fin -= 12; 
        }        
        for(inicio; inicio <= fin; inicio++){            
          if(inicio < 10) inicio = '0'+inicio;                    
          document.getElementById('horaEntrega').innerHTML += `<option value="${inicio}">${inicio}</option>`;
        }
    },
    getTotalProductos() {
      var _self = this;
      _self.total_productos = 0;

      _self.carrito.forEach((product) => {
        const valor = parseFloat(product.valor || 0);
        const cantidad = parseInt(product.cantidad || 0);
        const addition = parseFloat(product.addition_v || 0);

        if (_self.currency === "COP") {
          _self.total_productos += (valor * cantidad) + addition;
        } else {
          _self.total_productos += parseFloat(_self.formatDecimal((valor * cantidad) + addition));
        }
      });

      _self.saveApiConversion(this.$route.params.id, 'AddToCart', _self.total_productos);
      return _self.total_productos;
    },

    formatDecimal(valor){
      valor = parseFloat(Math.round(valor * 100) / 100).toFixed(2);
      return valor;
    },
    getTotalItems() {
      this.items = 0;

      this.carrito.forEach((product) => {
        this.items += parseInt(product.cantidad || 0);
      });
    },

    recogerPedido(){
      var self = this;
      this.mesaDomicilio = false;
      this.showSelectTable=false;
      this.valida_mesa = false
      if (this.activate_pick_it_up && this.mesero) this.form.mesa=0
      const validarAI = this.fnAddressIncluded();
      if(this.estado_domicilio && !validarAI)this.total -= parseInt(this.domicilio);
      this.estado_domicilio = false;
      if(this.domicilio > 0)document.getElementById("tr_domicilio").style.display = "none";
      document.getElementById("check-recogerlo").style.display = "";
      document.getElementById("check-mesa").style.display = "none";
      document.getElementById("check-domicilio").style.display = "none";    
      if(this.form.mesa == 0){
          this.formaEntrega.domicilio = false;
          this.formaEntrega.mesas = false;
          this.formaEntrega.recogerlo = true;    
      }
      this.form.direccion = "Recogerlo";
      this.form.barrio="";
      if(this.multipuntos)this.banderaMesaMultiPuntos = true;
      this.optMesa = false;
      this.optLocal = true;
      setTimeout(function(){ self.setMinutes();}, 500);   
    },
    mesaPedido(status = true){
      const validarAI = this.fnAddressIncluded();
      this.mesaDomicilio = false;
      this.optMesa = true;
      this.showSelectTable=true;
      this.optLocal = false;
      if(this.mesero && this.estado_domicilio)this.total += parseInt(this.domicilio)
      if (status){
        this.mesas= this.mesas_cache
        this.valida_mesa = true;
      }
      if(this.estado_domicilio && status && !validarAI)this.total -= parseInt(this.domicilio);
      this.estado_domicilio = false;
      if(this.domicilio > 0)document.getElementById("tr_domicilio").style.display = "none";
      document.getElementById("check-recogerlo").style.display = "none";
      document.getElementById("check-mesa").style.display = "";
      document.getElementById("check-domicilio").style.display = "none";

      if(this.form.mesa == 0){
        this.formaEntrega.mesas = true;
        this.formaEntrega.domicilio = false;
        this.formaEntrega.recogerlo = false;  
      }
      if(this.multipuntos){
        //validamos el cambio de multipuntos cuando viene de [domicilios, recogerlo],
        //para mesa se debe poner el numero de pedidos de la companie.
        //this.telefono_pedidos = this.telefonoPuntoPrincipal;  
        //this.form.id_point = this.idPuntoPrincipal;
        this.banderaMesaMultiPuntos = true;
      }

      if(this.olayaPark){
        this.form.mesa = this.$route.params.mesa;
      }
    },
    enviarDomicilio(){
      var self = this;
      this.form.direccion = localStorage.getItem('direccion');
      this.form.barrio = localStorage.getItem('barrio');
      this.valida_mesa = false;
      this.showSelectTable=false;
      this.mesaDomicilio = false;
      const validarAI = this.fnAddressIncluded();      
      if(!this.estado_domicilio && this.domicilio > 0){        
        if(!validarAI){
          document.getElementById("tr_domicilio").style.display = "";        
          this.total += parseInt(this.domicilio);          
        }
      }

      
      document.getElementById("check-recogerlo").style.display = "none";
      document.getElementById("check-mesa").style.display = "none";
      document.getElementById("check-domicilio").style.display = "";
      if(this.form.mesa == 0){
        this.formaEntrega.domicilio = true;
        this.formaEntrega.recogerlo = false;
        this.formaEntrega.mesas = false;  
      }      
      this.estado_domicilio = true;      
      if(this.multipuntos)this.banderaMesaMultiPuntos = true;
      this.optMesa = false;
      this.optLocal = false;
      if(this.mesero){
        this.form.mesa = 0;      
        this.total -= parseInt(this.domicilio);  
        this.estado_domicilio = false;
        this.estado_domicilio_mesero = true;
        this.mesaDomicilio = true; 
        if(this.domicilio > 0)document.getElementById("tr_domicilio").style.display = "none";
      }

      if(this.olayaPark){
        this.form.mesa = 0;
      }
      setTimeout(function(){ self.setMinutes();}, 500);     
    },
    showProductos(){
      document.getElementById("menu").style.display = ""
      document.getElementById("detalle_company").style.display = ""
      document.getElementById("pedido").style.display = "none";
    },
    setPointOptions() {
      if (!this.multipuntos) return;

      // Si hay punto preasignado (mesero)
      if (this.id_punto_mesero) {
        this.point_selected = this.id_punto_mesero;
        this.$nextTick(() => this.changePoint());
      } else {
        this.point_selected = '0'; // Default option
      }
    },
    confirmarPedido() {
      if (!this.mesero && (this.formaEntrega.domicilio || this.formaEntrega.recogerlo) && this.multipuntos) {
        this.point_selected = '0'; // para forzar el <option disabled selected>
        this.form.name_point = '';
        this.form.id_point = '';
      }
      
      if (this.incremento_datafono_companie > 0) {
        this.incremento_datafono = parseFloat(this.total_productos) * (parseFloat(this.incremento_datafono_companie) / 100);
      }

      if (this.statusFecha && !this.optMesa && !this.kiosko) {
        $('.send-button').show();
        $('.out-service').hide();
        this.setHoraEntrega();
        this.setMinutes();
        this.horarioEntrega = 'AM';
        document.getElementById('jornadaPunto').style.display = 'none';
      }

      document.getElementById("menu").style.display = "none";
      document.getElementById("detalle_company").style.display = "none";

      if (this.active_login_with_pin && this.mesero && this.orderExistSelected) {
        $(".pin-button").addClass("button-loading rodar").removeClass("boton-detalle").css("width", "auto");
        $(".pin-text, label", ".pin-button").addClass("hide");
      } else {
        document.getElementById("pedido").style.display = "none";
        document.getElementById("datos-personales").style.display = "";
      }

      const selectedPoint = this.points.find(p => p.id_point == parseInt(this.id_point_companie));
      if (selectedPoint) this.id_punto_mesero = selectedPoint.name;

      // Set tipo entrega
      if (this.formaEntrega.domicilio) this.form.id_type_platform_delivery = 154;
      if (this.formaEntrega.recogerlo) this.form.id_type_platform_delivery = 159;
      if (this.formaEntrega.mesas) this.form.id_type_platform_delivery = 155;

      // Establecer puntos disponibles
      this.setPointOptions();

      if (this.horarios.length > 0 && !this.multipuntos && this.statusFecha && !this.optMesa && !this.kiosko) {
        this.verifyHorarioEntrega(document.getElementById('horarioEntrega').value);
      }

      if (!this.status_map && this.formaEntrega.domicilio && this.form.mesa == 0) {
        navigator.geolocation?.getCurrentPosition(
          ubicacion => {
            this.form.latitude = ubicacion.coords.latitude;
            this.form.longitude = ubicacion.coords.longitude;
          },
          error => { /* silencio */ }
        );
      }

      if (this.mesero && !this.active_login_with_pin) this.form.mesa = 0;

      if (this.active_login_with_pin && this.mesero && this.orderExistSelected) {
        this.saveOrderBD(false);
      }
    },
    openMapDetail(){
      var self = this;
      // this.visible_map = true;   
      if (this.status_map) {
        this.domicilio = 0;
        if(this.formaEntrega.domicilio && this.form.mesa == 0){
          if (this.form.latitude == 'No'  && this.form.longitude == 'No') {
            this.visible_map = true;   
            const ubicacion_success = function(ubicacion) {
              if (ubicacion) {
                const lat = ubicacion.coords.latitude;
                const lng = ubicacion.coords.longitude;        
                self.form.latitude = lat;
                self.form.longitude = lng;
                self.setDirection(self.form.latitude, self.form.longitude);
              }
            }
            const ubicacion_error = function(error) {   
            }   
            //solo para domicilios
            if(navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(ubicacion_success,ubicacion_error);
            }
          }else{
            this.setDevileryCost(this.seguimiento_id_companie, this.form.latitude, this.form.longitude);
          }
        } 
      }
    },
    setDirection(latitude, longitude){
      var self = this;
      var Http = new XMLHttpRequest();
      var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=AIzaSyAZVmTOt9PmUdHQ1lYyCdWvKKM8OOJqavc';
      Http.open('POST', url);
      Http.send();
      Http.onreadystatechange = () => {
        var arreglo = JSON.parse(Http.responseText);
        var resultado = arreglo.results[0];
        self.actual_ubication = resultado.formatted_address;
        self.place_aux = arreglo.results[0];
      }
    },
    setAdrress(place, codigo){
      /*var self = this;
      var Http = new XMLHttpRequest();
      var url = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBrfn5eoVpPslQCD4A1fR2CtM6xO_qg5Fk&address=' + place;
      Http.open('POST', url);
      Http.send();
      Http.onreadystatechange = (e) => {
        var arreglo = JSON.parse(Http.responseText);
        var resultado = arreglo.results[0];
        self.form.latitude = resultado.geometry.location.lat;
        self.form.longitude = resultado.geometry.location.lng;
        self.setDevileryCost(self.seguimiento_id_companie, self.form.latitude, self.form.longitude);
      }*/
      var self = this;
      var geocoder = new google.maps.Geocoder();
      if(codigo == 1){
        geocoder.geocode({address: place}, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var result = results[0].geometry.location; // el primer resultado es el más relevante
            self.form.latitude = result.lat();
            self.form.longitude = result.lng();
            self.setDevileryCost(self.seguimiento_id_companie, self.form.latitude, self.form.longitude);
          } else {
          }
        });
      }
      if(codigo == 2){
        geocoder.geocode({address: place}, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var result = results[0].geometry.location; // el primer resultado es el más relevante
            
            self.mapLatitude = result.lat();
            self.mapLongitude = result.lng();
            self.initMap();
          } else {
          }
        });
      }
    },
    setDevileryCost(id_companie, latitud, longitud){
      var data = new FormData();
      data.append('id_companie',id_companie);
      data.append('lat',latitud); 
      data.append('long',longitud);
      axios.post('/api/post-address-v2', data) 
       .then(res => {
        var self =this;
          if (res.data.sql == 0) {
            this.out_zone = true;
            this.domicilio = 0;
            this.delivery_message = true;
            setTimeout(function(){
              self.out_zone = false;
            },2000);
          }else{
            this.domicilio = 0;
            this.id_zone = res.data.sql.id_zone;
            this.zone_name = res.data.sql.name;
            this.domicilio = parseFloat(res.data.sql.cost);
            
          }   
          if (this.punteroMapaDomicilio)this.total += parseInt(this.domicilio);
       })
       .catch(err => {    
       });
    },
    initMap(){
      var self = this;
      /*const componentForm = [
        'location',
        'locality',
        'administrative_area_level_1',
        'country',
        'postal_code',
      ];*/
      //var bounds = new google.maps.LatLngBounds();
      //lat: 10.471864459868115, lng: -73.26583531981072
      // Creamos el mapa
      if(this.mapLatitude && this.mapLongitude){
        var centerInfo ={
          lat: this.mapLatitude,
          lng: this.mapLongitude
        }
      }else{
        centerInfo ={
          lat: 10.4742449,
          lng: -73.2436335
        }
      }

      var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 13.8,
        mapTypeControl: false,
        fullscreenControl: false,
        center: centerInfo, // Centramos el mapa al area
        mapTypeId: 'terrain',
      });
      var options = {
        //types: ['establishment'],
        componentRestrictions: {country: "co"}
      };

      const marker = new google.maps.Marker({map: map, draggable: false});
      const autocompleteInput = document.getElementById('complete_direction');
      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, options);

      autocomplete.addListener('place_changed', function () {
        marker.setVisible(false);
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert('Sin detalles disponibles para: \'' + place.name + '\'');
          return;
        }
        var drinkSelect = document.getElementById('id_btn_confirmar');
        setTimeout(function(){
         drinkSelect.disabled = false; 
        }, 500);
        self.renderAddress(map,marker,place);
        self.setAdrress(place.formatted_address, 1);
        //self.fillInAddress(place, componentForm);
        //self.getCoordinates(place.name);
      });
    },
    fillInAddress(place, componentForm){
      const addressNameFormat = {
          'street_number': 'short_name',
          'route': 'long_name',
          'locality': 'long_name',
          'administrative_area_level_1': 'short_name',
          'country': 'long_name',
          'postal_code': 'short_name',
        };
        const getAddressComp = function (type) {
          for (const component of place.address_components) {
            if (component.types[0] === type) {
              return component[addressNameFormat[type]];
            }
          }
          return '';
        };
        //document.getElementById('location').value = getAddressComp('street_number') + ' '
                  + getAddressComp('route');
        for (const component of componentForm) {
          // Location field is handled separately above as it has different logic.
          if (component !== 'complete_direction') {
            document.getElementById(component).value = getAddressComp(component);
          }
        }
    },
    renderAddress(mapa, marker, place){
      mapa.setCenter(place.geometry.location);
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);
    },
    SetcurrentPosition(){
      if (this.map_contador == 0) {
        $(".esfere").show();
        $(".esfere").addClass("blue-color");
        $(".actual-position-container").addClass("border");
        $(".circle").addClass("border");
        //creamos la instacia del mapa y el marcador para redigir la posicion en el mapa cuando en usuario seleccione su ubicacion actual
        var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 13.8,
          mapTypeControl: false,
          fullscreenControl: false,
          center: {lat: 10.471864459868115, lng: -73.26583531981072}, // Centramos el mapa al area
          mapTypeId: 'terrain',
        });
        var drinkSelect = document.getElementById('id_btn_confirmar');
        setTimeout(function(){
          drinkSelect.disabled = false; 
        }, 500);
        const marker = new google.maps.Marker({map: map, draggable: false});
        this.renderAddress(map, marker, this.place_aux);
        this.map_contador++;
        this.status_current_position = true;
        this.setDevileryCost(this.seguimiento_id_companie, this.form.latitude, this.form.longitude);
      }else{
        $(".esfere").hide();
        $(".esfere").removeClass("blue-color");
        $(".actual-position-container").removeClass("border");
        $(".circle").removeClass("border");
        this.map_contador = 0;
        this.status_current_position = false;
      }
    }, 
    volverAlPedido(){
      document.getElementById("pedido").style.display = "";
      document.getElementById("datos-personales").style.display = "none";      
      if(this.points.length > 1 && this.form.mesa == 0){
        //Se carga el id del punto de la compañia
        this.form.id_point = this.points[0].id_point;  
      }
    },
    validarCampos(){     
      this.statusValidation = true;

      

      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (this.kiosko) {
        if (!this.form.nombres) {
          this.statusValidation = false;
          document.getElementById("validateNombre").style.display = "block";
        } else {
          document.getElementById("validateNombre").style.display = "none";
        }

        if(!this.form.cedula && this.statusCedula){             
          this.statusValidation = false;
          document.getElementById("validateCedula").style.display = "block";
        }
        if(this.form.cedula && this.statusCedula){      
          document.getElementById("validateCedula").style.display = "none";
        }

        if(this.form.id_type_forma_pago == 0){           
          this.statusValidation = false;
          document.getElementById("validateForma").style.display = "block";
        }else{
          document.getElementById("validateForma").style.display = "none";
        }

        if(!this.form.telefono && !this.mesero && !this.mode_mesa){           
          this.statusValidation = false;
          document.getElementById("validateTelefono").style.display = "block";
        }else{
          document.getElementById("validateTelefono").style.display = "none";
        }
        if(!this.form.email && !this.mesero && (this.statusEmail || this.formPay.payOnline) && !this.mode_mesa){    
          this.statusValidation = false;
          document.getElementById("validateEmail").style.display = "block";
          if(re.test(this.form.email)!=true){
            this.statusValidation = false;
            document.getElementById("validateEmail1").style.display = "block";
          } else{
            document.getElementById("validateEmail1").style.display = "none";
          }
        }


        return; // Detenemos aquí las demás validaciones
      }



      if(!this.form.nombres && !this.mesero){             
        this.statusValidation = false;
        document.getElementById("validateNombre").style.display = "block";
      }else{
        document.getElementById("validateNombre").style.display = "none";
      }
      if(!this.form.cedula && this.statusCedula && !this.mesero){             
        this.statusValidation = false;
        document.getElementById("validateCedula").style.display = "block";
      }
      if(this.form.cedula && this.statusCedula){      
        document.getElementById("validateCedula").style.display = "none";
      }

      if (!this.form.fecha_nacimiento && this.statusNacimiento) {
        this.statusValidation = false;
        document.getElementById("validatenacimiento").style.display = "block";
      }
      if (this.form.fecha_nacimiento && this.statusNacimiento) {
        document.getElementById("validatenacimiento").style.display = "none";
      }
      if(!this.form.telefono && !this.mesero && !this.mode_mesa){           
        this.statusValidation = false;
        document.getElementById("validateTelefono").style.display = "block";
      }else{
        document.getElementById("validateTelefono").style.display = "none";
      }
      if(!this.form.email && !this.mesero && (this.statusEmail || this.formPay.payOnline) && !this.mode_mesa){    
        this.statusValidation = false;
        document.getElementById("validateEmail").style.display = "block";
        if(re.test(this.form.email)!=true){
          this.statusValidation = false;
          document.getElementById("validateEmail1").style.display = "block";
        } else{
          document.getElementById("validateEmail1").style.display = "none";
        }
      }
      if(!this.form.barrio && this.statusBarrio && !this.mesero && this.estado_domicilio){             
        this.statusValidation = false;
        document.getElementById("validateBarrio").style.display = "block";
      }
      if(this.form.email && (this.statusEmail || this.formPay.payOnline)){
        document.getElementById("validateEmail").style.display = "none";
        if(re.test(this.form.email)!=true){
          this.statusValidation = false;
          document.getElementById("validateEmail1").style.display = "block";
        } else{
          document.getElementById("validateEmail1").style.display = "none";
        }
      }
      if(this.form.barrio && this.statusBarrio && !this.mesero && this.estado_domicilio){      
        document.getElementById("validateBarrio").style.display = "none";
      }
      if(!this.form.direccion && this.estado_domicilio){         
         this.statusValidation = false;
         document.getElementById("validateDireccion").style.display = "block";
      }else if(this.estado_domicilio){
          document.getElementById("validateDireccion").style.display = "none";
      }

      if(this.statusFecha && !this.optMesa && !this.kiosko){             
        if(document.getElementById("horaEntrega").value != 13 && document.getElementById("minutoEntrega").value != 60){
            document.getElementById("validateFecha").style.display = "none";            
        }else{
          document.getElementById("validateFecha").style.display = "block";
          this.statusValidation = false;
        }
      }

      if(this.form.id_point == 0 && this.multipuntos && (this.formaEntrega.domicilio || this.formaEntrega.recogerlo || this.formaEntrega.mesas)){         
         this.statusValidation = false;
         document.getElementById("validatePunto").style.display = "block";
      }else if(this.form.id_point != 0 && this.multipuntos && (this.formaEntrega.domicilio || this.formaEntrega.recogerlo || this.formaEntrega.mesas)){
          document.getElementById("validatePunto").style.display = "none";
      } 

      if(this.form.id_type_forma_pago == 0 && !this.mesero && !this.mode_mesa){           
        this.statusValidation = false;
        document.getElementById("validateForma").style.display = "block";
      }else{
        document.getElementById("validateForma").style.display = "none";
      }
      
      if(this.howPay && !this.mesero){ 
        if (this.valHowPay == '') {
          this.statusValidation = false; 
          document.getElementById("validateCuantoPaga").style.display = "block";
        }else{
          document.getElementById("validateCuantoPaga").style.display = "none";
        }
      }

      if(this.form.mesa == 0 && this.mesas.length > 0 && (this.mesero || this.valida_mesa) && this.showSelectTable){ 
        this.statusValidation = false; 
        document.getElementById("validateMesa").style.display = "block";
      }else{
        document.getElementById("validateMesa").style.display = "none";
      }

      if(this.multipuntos && this.banderaMesaMultiPuntos){       
          //Tomamos el id del punto para buscar el telefono del domicilio
          let self = this;
          var idPoint = this.form.id_point;
          var name_point = this.form.name_point;
          this.points.forEach(function(point){
            if(point.name == name_point){              
              self.telefono_pedidos = point.telefono_pedidos;
              self.namePoint = point.name;
            }
          });
      } else{
        this.telefono_pedidos=this.store.telefono_pedidos;
      }
      if(this.telefono_pedidos)localStorage.setItem('telefono_pedidos',this.telefono_pedidos);
      
    },
    onCedulaInput() {
      if (
        this.statusCedula &&
        this.input_nit &&
        (this.orderExistSelected == null || this.orderExistSelected == undefined)
      ) {
        if (this.form.cedula && this.form.cedula.toString().trim() !== '') {
          this.form.nit = '';
          this.nitBlocked = true;
        } else {
          this.nitBlocked = false;
        }
      }
    },
    onNitInput() {
      if (
        this.statusCedula &&
        this.input_nit &&
        (this.orderExistSelected == null || this.orderExistSelected == undefined)
      ) {
        if (this.form.nit && this.form.nit.toString().trim() !== '') {
          this.form.cedula = '';
          this.cedulaBlocked = true;
        } else {
          this.cedulaBlocked = false;
        }
      }
    },
    enviarWhatsApp(wompi,wompi_id = "",retornar = false){  
      var self = this;
      var prioridades = [];
      var txtPrioridad = "";
      var txtOrder="";
      if(this.priority){
        this.carrito.forEach((item) => {
            let id_product = item.id_product;
            self.categories.forEach((c) => {
                c.products.forEach((p) => {
                    if(p.id == id_product){
                      prioridades.push(p.priority)
                    }
                });
            });
        }); 
        //ORDENAMOS LAS PRIO
        prioridades.sort(function (a, b) {
          if (a > b) {
            return 1;
          }
          if (a < b) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      }
      //validamos el numero del pedido
      if(this.multipuntos && this.banderaMesaMultiPuntos){       
          //Tomamos el id del punto para buscar el telefono del domicilio
          let self = this;
          var idPoint = this.form.id_point;
          var name_point = this.form.name_point;
          this.points.forEach(function(point){
            if(point.name == name_point){              
              self.telefono_pedidos = point.telefono_pedidos;
              self.namePoint = point.name;
            }
          });
      }
      /*
      if(this.multipuntos && this.banderaMesaMultiPuntos){       
          //Tomamos el id del punto para buscar el telefono del domicilio
          var idPoint = this.form.id_point;          
          let self = this;
          this.points.forEach(function(point){
            if(point.id_point == idPoint){              
              self.telefono_pedidos = point.telefono_pedidos;
              self.namePoint = point.name;
            }
          });  
      }
      */
      //construimos el mensaje para wapp
      //se agregan los espacios al nombre de la empresa      
      this.mensaje = '';
      let comentario = document.getElementById("comentario").value;
      let nombre_comercial = this.company.name;
      nombre_comercial = nombre_comercial.replace(" ","%20");
      let nombre = document.getElementById("nombre").value;
      localStorage.setItem('nombre',nombre);
      let telefono = document.getElementById("telefono").value;
      localStorage.setItem('telefono',telefono);
      if(this.statusEmail)localStorage.setItem('email',this.form.email);
      if(this.statusCedula)localStorage.setItem('cedula',this.form.cedula);
      if(this.statusBarrio)localStorage.setItem('barrio',this.form.barrio);
      if (this.id_order_bot) {
         txtOrder ="Orden "+this.id_order_bot+" ";
      }
      nombre = nombre.replace(" ","%20");      
      var value = 0;
      var reemplazar="";
      var barrio_u="";
      if(prioridades.length > 0)txtPrioridad = `*${prioridades[0]}*%0A`;
      /*if (this.nameOS =='iOS') {
          this.mensaje += `
          https://api.whatsapp.com/send?phone=${this.telefono_pedidos}&text=${txtOrder}${txtPrioridad}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
      }else{
        this.mensaje += `
         https://wa.me/${this.telefono_pedidos}?text=${txtOrder}${txtPrioridad}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
      }*/
      this.mensaje += `
          https://api.whatsapp.com/send?phone=${this.telefono_pedidos}&text=${txtOrder}${txtPrioridad}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
      if(this.estado_domicilio){        
        let direccion = document.getElementById("direccion_pedido").value;
        localStorage.setItem('direccion',direccion);
        var direccion_pedido = encodeURIComponent(direccion);
        //direccion = direccion.replace("#",'%23');
        //direccion = direccion.split(' ');
       /* let tamaño = direccion.length;

        direccion.forEach((parte,index)=>{
            index += 1;
            if(index < tamaño){
              direccion_pedido += `${parte}%20`
            }else{
              direccion_pedido += `${parte}`
            }
        });*/        
        //this.mensaje += `%20a%20la%20dirección%20*${direccion_pedido}*`;
      }else{
        if(this.form.mesa != 0 || this.optMesa){
          //para recibir en la mesa.
          if(!this.autoservicio && !this.mesaDomicilio)this.mensaje += `%20para%20recibir%20en%20la%20mesa.`;

          if(this.mesaDomicilio)this.mensaje += `%20para%20llevar.`;   

        }else{
          //van a pasar por el pedido
          this.mensaje += `%20para%20recoger%20en%20el%20local.`;
        }
      } 
      if(this.estado_domicilio){       
        this.mensaje += '%0A%0A';  
        this.mensaje += `*Dirección:*%20${direccion_pedido}`;
      }
      if(this.statusBarrio && this.estado_domicilio){
        this.mensaje += '%0A';//un espacio  
         barrio_u = encodeURIComponent(this.form.barrio);
         this.mensaje +=  `*Barrio:*%20${barrio_u}`;
      }
      if(this.statusCedula){
        this.mensaje += '%0A';//un espacio  
         this.mensaje +=  `*Cédula:*%20${this.form.cedula}`;
      } 
      if(this.statusEmail){
        this.mensaje += '%0A';//un espacio  
         this.mensaje +=  `*Email:*%20${this.form.email}`;
      }     
      if(this.statusFecha && !this.optMesa && !this.kiosko){
        this.mensaje += '%0A';//un espacio  
        let entrega = document.getElementById("entrega").value;
        let h = document.getElementById("horaEntrega").value;
        let m = document.getElementById("minutoEntrega").value;
        let j = document.getElementById("horarioEntrega").value;
        this.mensaje += `*Fecha de Entrega:*%20${entrega} ${h}:${m} ${j}`;        
      }        
      if(this.estado_domicilio){
        this.mensaje += '%0A';//un espacio  
      }else{
        if(this.optMesa){
          this.mensaje += '%0A'; //dos espacio  
        }else{
          this.mensaje += '%0A%0A'; //dos espacio  
        }
        
      }
      this.mensaje += '*Celular:*%20'+this.form.telefono;
      this.mensaje += '%0A%0A';
      this.mensaje += '*Detalle de la orden:*';
      this.mensaje += '%0A';
      this.carrito.forEach((item)=>{
        value = 0;
        this.mensaje += `-%20${item.cantidad}%20x%20`;
        reemplazar = item.name_product;
        //reemplazar = reemplazar.replace(" ","%20");
        reemplazar = encodeURIComponent(reemplazar);
       
        if (this.currency != "COP") {
          value = parseFloat(this.formatDecimal((parseFloat(item.valor)*item.cantidad)+item.addition_v));
          parseFloat(value)
        }else{
          if(!this.companie_decimales){
            value = (parseInt(item.valor)*item.cantidad)+item.addition_v;
          }else{
            value = (parseFloat(item.valor)*item.cantidad)+item.addition_v;
          }
        }
        
        if(this.company.type == 72/*Carnicia*/){
          this.mensaje += `-%20${reemplazar}`;
        }else{
          if (this.currency != "COP") {
            this.mensaje += `-%20${reemplazar}%20(%24%20${parseFloat(value)})`;
          }else{
            this.mensaje += `-%20${reemplazar}%20(%24%20${new Intl.NumberFormat("de-DE").format(value)})`;
            if (item.observation_optional) {
              this.mensaje += '%0A';
              this.mensaje += `*Observaciones%3A*%20${item.observation_optional}`;
            } 
          }
          
        }
        
        this.mensaje += '.%0A%0A';
      });

      if(this.form.descuento > 0){
        this.mensaje += `*Descuento%3A*%20%24%20${new Intl.NumberFormat("de-DE").format(this.form.descuento)}`;
        this.mensaje += '%0A%0A'; 
      }
      if((this.formaEntrega.domicilio || this.formaEntrega.recogerlo || this.formaEntrega.mesas) && this.multipuntos){
        this.mensaje += `*Punto de Atención%3A*%20${this.namePoint}`;
        this.mensaje += '%0A'; 
      }
      if(this.form.mesa != 0 && !this.autoservicio){
       this.mensaje += `*Mesa%3A*%20${this.form.mesa}`;
       this.mensaje += '%0A%0A'; 
      }
      //validamos el domicilio
      const validarAI = this.fnAddressIncluded();
      if(this.estado_domicilio && this.domicilio > 0 && !validarAI){  
        this.mensaje += this.form.id_companie != 7717 ? `-%20Envío a domicilio%20%24%20${this.domicilio}` : `-%20Servicio%20%24%20${this.domicilio}`;
        
        this.mensaje += '.%0A';
      }
      if(this.tr_priority_shipping && this.value_priority_shipping > 0){      
      this.mensaje += `-%20Prioritario ⚡%20%24%20${this.value_priority_shipping}`;
      this.mensaje += '.%0A';
      }
      var textForma = this.form.id_type_forma_pago;      
      this.formasPago.forEach(function(f){
          if(textForma == f.id)textForma = f.text;
      });
      //definimos la forma de pago.      
      this.mensaje += `*Forma de Pago%3A*%20${textForma}`;
      let cuenta = "";
      //let banco = "";
      if (this.form.id_type_forma_pago == 38) {
        cuenta = document.getElementById('select-bank').value;
        /*this.banks.forEach((item) =>{
          if (item.account == cuenta) {
            banco = item.bank;
          }
        });*/
        this.mensaje += '%0A';
        this.mensaje += `*Banco%3A*%20${this.bank_name}`;
        this.mensaje += '%0A';
          this.mensaje += `*Numero de cuenta%3A*%20${cuenta}`;
      }
      this.mensaje += '%0A%0A';   
      //¿con cuanto pagas?
      if(this.howPay){
      if(this.valHowPay){
        this.mensaje += `*Paga con%3A*%20%24%20${this.valHowPay}`;  
      }else{
        this.mensaje += `*Paga con%3A*%20Sin definir.`;  
      }
      
      this.mensaje += '%0A%0A';   
      }

      if(wompi && !retornar){
        this.mensaje += `*Pago en Wompi*`; 
        this.mensaje += '%0A';
        this.mensaje += `*Id de la transacción%3A*%20${wompi_id}`;
        //this.mensaje += `*Referencia de pago%3A*%20${this.formPay.wompiReference}`;
        this.mensaje += '%0A%0A'; 
        this.form.id_type_forma_pago = 0;
        this.checkout = false;  
      }

      if(retornar){
        this.mensaje += `*Pago en Wompi*`; 
        this.mensaje += '%0A';
        this.mensaje += `*Id de la transacción%3A*%20reemplazar`;
        this.mensaje += '%0A%0A';
      }

      if (this.status_map) {
        if (this.domicilio > 0 ) {
          this.mensaje +=  `*Nombre de la zona%3A*%20${this.zone_name}`;
          this.mensaje += '%0A';
          if (this.form.latitude != 'No' && this.form.longitude != 'No') {
            this.mensaje +=  `(https://www.google.com/maps?q=${this.form.latitude},${this.form.longitude})`;
          }
          this.mensaje += '%0A';
        }
      }

      if(this.company.type != 72/*Carnicia*/){
        if (this.currency != "COP") {
          this.mensaje += `*Total del pedido%3A%20%24%20${parseFloat(this.total)}*`;
        }else{
          this.mensaje += `*Total del pedido%3A%20%24%20${new Intl.NumberFormat("de-DE").format(this.total)}*`;
        }      
        
        this.mensaje += '%0A%0A';    
      }
      if (this.delivery_app) {
        let mensajeria = localStorage.getItem('name_delivery');
        this.mensaje += `*Mensajería encargada%3A*%20${mensajeria}`;
        this.mensaje += '%0A';
      }
      this.mensaje += `*Comentario%3A*%20${comentario}`;
      /*if (this.seguimiento_pedido_wpp || this.seguimiento_pedido) {
        this.mensaje += '%0A';
        this.mensaje += `*Puedes ver el progreso de tu pedido en el siguiente enlace:*`;
        this.mensaje += '%0A';
        if (this.dominio) {
          this.mensaje += `${location.origin}`+`/`+`${this.$route.params.id}`;
        }else{
          this.mensaje += `${location.origin}`;
        } 
      }*/
      if(this.estado_domicilio && this.domicilio == 0 && this.delivery_message){
        this.mensaje += '%0A%0A';  
        this.mensaje += `El valor del domicilio será confirmado en un momento de acuerdo a la dirección`;
      }
      this.mensaje += '%0A%0A';
      this.mensaje += `Gracias.`; 
      if(this.optLocal){
        this.mensaje += '%0A%0A';
        this.mensaje += `¿En cuanto tiempo puedo recoger mi pedido?`; 
      }
      //document.getElementById('wapp').disabled = false;
      setTimeout(function() { 
              $(".button-loading").addClass("send-button");
              $(".send-button").removeClass("button-loading");
              $(".send-text").removeClass("hide");
              $(".what").removeClass("hide");
              $(".fa-check").addClass("hide");

      }, 4000); 
      if(retornar)return this.mensaje;
      if (this.wa_redirect_auto) {
        if (wompi) this.mensaje += '%0A*Pago confirmado en Wompi*';

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const isInstagram = navigator.userAgent.includes("Instagram");

        if (isInstagram) {
          const aceptar = confirm("¿Deseas redirigirte a WhatsApp para completar tu pedido?");
          if (aceptar) {
            window.location.href = this.mensaje;
          }
          return; // detener aquí, Instagram no debe pasar al bloque safari/chrome
        }
        
        if (isSafari) {
          window.location.href = this.mensaje; // redirige directamente
        } else {
          window.open(this.mensaje, "_blank"); // abre nueva pestaña
        }
      }
    },
    linkToWhatsapp(){
      this.mensaje = '';
      window.open(this.mensaje,'_blank');  
    },
    emitSocketTable(id_order,id_table){   
      var self = this;
      this.socketTable.emit("setup order",{id_companie : self.company.id, id_point: self.form.id_point,id_order : id_order, id_table : id_table});
    },  
    saveApiConversion(uri,event,valor){
       let data={
        uri:uri,
        event:event,
        valor:valor
       }
       axios.post('/api/api-conversion',data)
       .then(res=>{
       }).catch(err=>{
       });
    }, 
    apiConversionP(/*id, index*/){
      
     /*if(index == 0){
      if ($(`#accordionEx_${id} i`).hasClass("rodar2")) {
        $(`#accordionEx_${id} i`).removeClass("rodar2");
      }else{
        $(`#accordionEx_${id} i`).addClass("rodar2");
      }
     }else{
        if ($(`#accordionEx_${id} i`).hasClass("rodar2")){
          $(`#accordionEx_${id} i`).removeClass("rodar2");
          $(`#headingTwo${id}`).removeClass("opacidad");
        }else{
          $(`#accordionEx_${id} i`).addClass("rodar2");
          $(`#headingTwo${id}`).addClass("opacidad");
        }
     }*/ 
     this.saveApiConversion(this.$route.params.id,'CustomizeProduct',0);
    },
    applyMethodPay(){
      if(this.status_qr_bancolombia){
        this.saveOrderBD(true);
      }else{
        this.payBancolombia();
      }
    },
    saveOrderBD(pay_online,wp_reference = "",wp_wapp = false){

      
      if(this.form.nombre_mesero){
        localStorage.setItem('nombre_mesero', this.form.nombre_mesero);
      }
      if(!this.mesero){
        if(this.form.nombres)localStorage.setItem('nombre', this.form.nombres);
        if(this.form.telefono)localStorage.setItem('telefono', this.form.telefono);
        if(this.form.email)localStorage.setItem('email', this.form.email);
      } else{
        localStorage.setItem('nombre', '');
        localStorage.setItem('telefono', '');
        localStorage.setItem('email', '');
      }
      if (this.submitSaveOrder) {
        this.submitSaveOrder = false
        this.validarCampos()
        if(!this.statusValidation){ 
          this.submitSaveOrder = true; 
          this.exit_component = false;
          return 0;
          
        }       

        if(!pay_online/* && !(this.form.mesa>0 && (this.form.id_companie == 7275 || this.form.id_companie == 6663  || this.form.id_companie == 6583 || this.form.id_companie == 7264))*/){
            $(".send-button").addClass("button-loading");
            $(".button-loading").removeClass("send-button");
            $(".button-loading").addClass("rodar");
            $(".send-text").addClass("hide");
            $(".what").addClass("hide");
        }

        if(this.form.id_type_forma_pago == '169'){
          this.form.id_type_forma_pago = '126';
          $(".btn-wonpi").addClass("button-loading2");
          $(".button-loading2").removeClass("send-button2");
          $(".button-loading2").addClass("rodar2");
          $(".send-text").removeClass("hide");
          $(".what").removeClass("hide");
          $(".fa-check").addClass("hide");
        }
        //this.carrito.forEach((d)=>{self.saveApiConversion(,'AddToCart',parseInt(d.valor)*d.cantidad)})
        let cart = JSON.stringify(this.carrito);
        const validarAI = this.fnAddressIncluded();

        if(this.form.id_type_forma_pago == '39'){
          //this.incremento_datafono = parseFloat(this.total_productos) * parseFloat(this.incremento_datafono_companie / 100);
          this.total = parseFloat(this.total) + this.incremento_datafono;
          //this.incremento_datafono = 0;
        }else{
          this.incremento_datafono = 0;
        }

         
        validarAI == true ? this.form['domicilio'] = 0 : this.form['domicilio'] = this.domicilio;
        if (this.domicilio > 0 && this.visible_barrio)this.form['domicilio'] = this.domicilio;
        this.form['cart'] = cart;   
        this.form['estado_domicilio'] = this.estado_domicilio;       
        this.form['total'] = this.total;
        this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total);
        this.form['os'] = this.nameOS;
        this.form['entrega'] = "";
        this.form['priority_shipping'] = this.tr_priority_shipping;
        this.form['value_priority_shipping'] = this.value_priority_shipping;
        this.form['wp_reference'] = wp_reference;
        this.form['id_zone'] = this.id_zone;
        this.form['bank_type'] = this.bank_type;
        this.form['incremento_datafono'] = this.incremento_datafono;
        
        this.form['mesa_domicilio'] = this.mesaDomicilio;
        if(this.mesero)this.form['platform'] = 'Mesero';
        else this.form['platform'] = 'App';
        if (this.delivery_app) this.form['id_companie_delivery_apps'] = localStorage.getItem('id_delivery');
        if(wp_wapp)this.form['wp_wapp'] = this.enviarWhatsApp(false,null,true);
        
        this.id_order_bot = null;
        this.form['valHowPay'] = this.valHowPay.replace(".", "");
        if(this.statusFecha && !this.optMesa && !this.kiosko){
          let entrega = document.getElementById("entrega").value;
          let h = document.getElementById("horaEntrega").value;
          let m = document.getElementById("minutoEntrega").value;
          let j = document.getElementById("horarioEntrega").value;
          entrega += ` ${h}:${m} ${j}`;
          if(entrega)this.form['entrega'] = entrega;     
        }   

          var _self = this;
          axios.post('/api/order/save-order-end',this.form)
          .then(res => {
              //VALIDACION PARA IMPRIMIR COMANDA ENSEGUIDA SI LA FORMA DE PAGO ES EFECTIVO EN PUNTO Y COMA
              /*if((_self.form.id_companie == 6874 || _self.form.id_companie == 6663) && _self.form.id_type_forma_pago=='37' && this.print_comanda_mesero){
                _self.printBySocket(res.data.new_id_order)
              }*/
              this.saveApiConversion(this.$route.params.id,'Purchase',this.total);
              if(this.kiosko == true){
                _self.getOrderDetail(res.data.new_id_order, true);
                return;
              }else{
                localStorage.setItem('kiosko', false);
              }


              if(_self.managmentTable){                    
                  _self.emitSocketTable(res.data.new_id_order,res.data.new_id_table);        
              }  
              if((this.formaEntrega.domicilio || this.formaEntrega.recogerlo) && this.mesero && (this.form.mesa == 0) && (/*_self.form.id_companie == 6663 || */_self.form.id_companie == 6634)){ //printdomi printreco
                _self.printBySocket(res.data.new_id_order, true);
              }
              if((_self.mesero && this.mesas.length > 0) || (this.enable_waiter_print && _self.mesero) && this.print_comanda_mesero){
                _self.printBySocket(res.data.new_id_order);
              }
              if(_self.auto_take_delivery && !_self.mesero && this.print_comanda_mesero){
                _self.printBySocket(res.data.new_id_order);
              }
              if(this.$route.params.mesa > 0){
                _self.printBySocket(res.data.new_id_order);
              }

              //Seguimiento del pedido
              this.id_order_bot = res.data.new_id_order;
              if(this.wa_redirect_auto && !pay_online && !this.mesero)this.enviarWhatsApp(false);
              if (this.seguimiento_pedido_wpp || this.seguimiento_pedido){
                localStorage.setItem('id_order', res.data.new_id_order);
                localStorage.setItem('id_punto', this.form.id_point);
                if (this.$route.params.mesa > 0) {
                  localStorage.setItem(`id_estado_order_${this.seguimiento_id_companie}_${this.form.mesa}`,91);
                }else{
                  localStorage.setItem(`id_estado_order_${this.seguimiento_id_companie}`,91);
                }
                this.status_tracking=true
              }
              //End Segumiento
              if ((this.form.mesa>0 && (this.form.id_companie == 7275/* || this.form.id_companie == 6663 */ || this.form.id_companie == 6583 || this.form.id_companie == 7264))) {
                setTimeout(() => {

                  this.exit_component_2 = true
                  $(".button-loading").removeClass("rodar");
                  $(".button-loading").addClass("send-button");
                  $(".button-loading").removeClass("button-loading");
                  $(".send-text").removeClass("hide");
                  $(".what").removeClass("hide");

                  $(".pin-button").removeClass("rodar");
                  $(".pin-button").addClass("boton-detalle");
                  $(".pin-button").removeClass("button-loading");
                  $(".pin-text").removeClass("hide");
                  $("label", ".pin-button").removeClass("hide");
                  $(".pin-button").css("width", "100%");
                }, 2000);
              }else{
                if(!pay_online && !this.mesero){
                  $(".fa-check").removeClass("hide");
                  $(".button-loading").removeClass("rodar");
                  if(this.finish_order)this.finishOrder = true; 
                  let uri = localStorage.getItem('license_uri');
                  setTimeout(function(){
                    
                    if(this.kiosko){
                      _self.printBySocket(res.data.new_id_order);
                    }else{
                      if(!_self.wa_redirect_auto)location.href = location.origin+'/'+uri+'/order/'+res.data.new_id_order;
                      setTimeout(function() {
                        _self.submitSaveOrder = true;
                        location.reload();
                      }, 4000);
                    }
                    
                   },1500) 
                }else{
                    setTimeout(function() {
                      $(".button-loading").removeClass("rodar");
                      $(".button-loading").addClass("send-button");
                      $(".button-loading").removeClass("button-loading");
                      $(".send-text").removeClass("hide");
                      $(".what").removeClass("hide");
                      $(".pin-button").removeClass("rodar");
                      $(".pin-button").addClass("boton-detalle");
                      $(".pin-button").removeClass("button-loading");
                      $(".pin-text").removeClass("hide");
                      $("label", ".pin-button").removeClass("hide");
                      $(".pin-button").css("width", "100%");

                      
                      _self.submitSaveOrder = true;
                      _self.exit_component_2 = true;
                      

                    }, 3000);
                    
                }
              }
          })
         .catch(err => {
            _self.submitSaveOrder = true; 
         });
      }
    },
    saveOrderBDPaymentOnline(pay_online,wp_reference = "",wp_wapp = false){ 
      if (this.submitSaveOrder) {
        this.submitSaveOrder = false
        this.validarCampos()
        if(!this.statusValidation){ 
          this.submitSaveOrder = true; 
          this.exit_component = false;
          return 0;
        }       
        if(!pay_online){
            $(".send-button").addClass("button-loading");
            $(".button-loading").removeClass("send-button");
            $(".button-loading").addClass("rodar");
            $(".send-text").addClass("hide");
            $(".what").addClass("hide");
        }
        //this.carrito.forEach((d)=>{self.saveApiConversion(,'AddToCart',parseInt(d.valor)*d.cantidad)})
        let cart = JSON.stringify(this.carrito);
        const validarAI = this.fnAddressIncluded();
        validarAI == true ? this.form['domicilio'] = 0 : this.form['domicilio'] = this.domicilio;
        if (this.domicilio > 0 && this.visible_barrio)this.form['domicilio'] = this.domicilio;
        this.form['cart'] = cart;   
        this.form['estado_domicilio'] = this.estado_domicilio;       
        this.form['total'] = this.total;
        this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total);
        this.form['os'] = this.nameOS;
        this.form['entrega'] = "";
        this.form['wp_reference'] = wp_reference;
        this.form['id_zone'] = this.id_zone;
        this.form['bank_type'] = this.bank_type;
        this.form['mesa_domicilio'] = this.mesaDomicilio;
        if (this.delivery_app) this.form['id_companie_delivery_apps'] = localStorage.getItem('id_delivery');
        if(wp_wapp)this.form['wp_wapp'] = this.enviarWhatsApp(false,null,true);

        this.form['valHowPay'] = this.valHowPay.replace(".", "");
        if(this.statusFecha && !this.optMesa && !this.kiosko){
          let entrega = document.getElementById("entrega").value;
          let h = document.getElementById("horaEntrega").value;
          let m = document.getElementById("minutoEntrega").value;
          let j = document.getElementById("horarioEntrega").value;
          entrega += ` ${h}:${m} ${j}`;
          if(entrega)this.form['entrega'] = entrega;        
        }   

          var _self = this;
          axios.post('/api/order/save-order-end',this.form)
          .then(res => {
              this.saveApiConversion(this.$route.params.id,'Purchase',this.total);
              if(_self.managmentTable){                    
                  _self.emitSocketTable(res.data.new_id_order,res.data.new_id_table);        
              }  
              if((!_self.mesero && this.mesas.length > 0) || (this.enable_waiter_print && _self.mesero && this.print_comanda_mesero)){
                _self.printBySocket(res.data.new_id_order);
              }
              //Seguimiento del pedido
              
              if (this.seguimiento_pedido_wpp || this.seguimiento_pedido){
                localStorage.setItem('id_order', res.data.new_id_order);
                localStorage.setItem('id_punto', this.form.id_point);
                if (this.$route.params.mesa > 0) {
                  localStorage.setItem(`id_estado_order_${this.seguimiento_id_companie}_${this.form.mesa}`,91);
                }else{
                  localStorage.setItem(`id_estado_order_${this.seguimiento_id_companie}`,91);
                }
                this.status_tracking=true
              }
              //End Segumiento
              if(!pay_online && !this.mesero){
                $(".fa-check").removeClass("hide");
                $(".button-loading").removeClass("rodar");
                if(this.finish_order)this.finishOrder = true; 
                setTimeout(function(){
                  _self.enviarWhatsApp(false);
                  setTimeout(function() {
                    _self.submitSaveOrder = true;
                    location.reload();
                  }, 3000);
                 },1500) 
              }else{
                setTimeout(function(){
                  setTimeout(function() {
                    _self.submitSaveOrder = true;
                    _self.exit_component_2 = true;
                  }, 3000);
                 },1500) 
              }
              
          })
         .catch(err => {
            _self.submitSaveOrder = true;
         });
      }
    },
    Close(){    
      document.getElementById('pwa-ios-notify').style.display = 'none'; 
    },
    checkValue(str, max){
      if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
      }
      return str;
    },
    getCountOrderProcess(){
      if (localStorage.getItem('telefono') && this.seguimiento_pedido_wpp) {
        let telephone = localStorage.getItem('telefono');
        var self=this
        axios
          .get('/api/get-count-order-process/'+telephone+"/"+this.seguimiento_id_companie)
          .then( res =>{
            this.countOrderProcess = res.data;
            if (this.countOrderProcess>0)self.status_managment = true; 
          })
          .catch( err => {
          });
        }
    },
    validateDate(){
      //var nacimiento = document.getElementById('nacimiento');
      var input = _self.form.fecha_nacimiento;
      var _self = this;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = this.checkValue(values[0], 12);
      if (values[1]) values[1] = this.checkValue(values[1], 31);
      var output = values.map(function(v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      _self.form.fecha_nacimiento = output.join('').substr(0, 14);
    },
    getTablesByMesero() {  
      return axios.get('/api/get-by-point-dev-mesero/' + this.form.id_companie + '/' + this.nombre_mesero + '/' + this.form.id_user_mesero)
        .then(res => {
          if (res.data.result.length > 0) {
            this.ordersTables = res.data.result;
            if (res.data.point_name != "") this.id_punto_mesero = res.data.point_name;
          } else {
            this.ordersTables = [];
          }
        })
        .catch(err => {
          console.error("Error al obtener mesas:", err);
          this.ordersTables = [];
        });
    },
    login(id_company, code_login){
            axios.get('/api/company/validate-code/'+id_company+'/'+code_login)
            .then(res=>{
                if(res.data.status==200){
                  this.loginStatus=true;
                  this.popupActivoModeMesero=true;
                  localStorage.setItem('loginStatus', true);
                } else{
                  localStorage.setItem('loginStatus', false);
                  this.loginStatus=false
                }
            }).catch(err=>{
                localStorage.setItem('loginStatus', false);
            });
        },
        getwaiters(id_company, id_point){
          axios
          .get('/api/waiters/'+id_company+'/'+id_point)
          .then(res => {
            this.waiters = res.data;
          })
          .catch(err => {
          });
        },
        updateWaiter(event) {
          const selectedId = event.target.value;
          if(selectedId == "0"){
            return;
          }
          const selectedWaiter = this.waiters.find(w => w.id == selectedId);
          if (selectedWaiter) {
              this.form.id_user_mesero = selectedWaiter.id;
              this.form.nombre_mesero = selectedWaiter.name;
          } else {
              this.form.id_user_mesero = null;
              this.form.nombre_mesero = "";
          }
        },
    getOrderDetail(id_order, kiosko = false, qr_image = null){
      if(!kiosko)this.categoriesDone = true;
      if(id_order){
        axios
        .get('/api/orders/get-data/'+id_order)
          .then(res => {
            this.formOrder=res.data;
            if(this.formOrder.id_type_forma_pago != '39')this.formOrder.qr_bancomlombia = this.status_qr_bancolombia;
            if(qr_image != null){
              this.formOrder.qr_image = qr_image;
            }
            if(kiosko && (this.form.id_type_forma_pago == '39' || this.form.id_type_forma_pago == '169' || this.form.id_type_forma_pago == '126')){
              this.await_payment=true;
            }else{
              if(this.formOrder.id_type_forma_pago)this.formOrder.type_forma_pago=this.listFormaPago.find(item => item.id === this.formOrder.id_type_forma_pago).value;
              this.formOrder.id_type_forma_pago_secundaria=res.data.id_type_forma_pago_secundaria;
              if(this.formOrder.id_type_forma_pago_secundaria){
                this.formOrder.type_forma_pago_secundaria = this.listFormaPago.find(item => item.id === this.formOrder.id_type_forma_pago_secundaria).value;
              } else{
                this.formOrder.type_forma_pago_secundaria=null;
              }
              this.getUsedTables(res.data.id_point);
              this.formEdit.nombre_mesero = res.data.nombre_mesero;
              this.formEdit.id_table = res.data.id_table;
              this.formEdit.id_order=res.data.id_order;
              this.formEdit.valor_forma_pago = parseFloat(res.data.valor_forma_pago);
              this.formEdit.service=res.data.service;
              this.formEdit.shipping=0;
              this.formEdit.total_discount=res.data.total_discount;
              this.formEdit.id_type_forma_pago=res.data.id_type_forma_pago;
              this.formEdit.observacion=res.data.commentary;
              this.formEdit.id_type_forma_pago_secundaria=res.data.id_type_forma_pago_secundaria;
              if(res.data.valor_forma_pago==null || res.data.valor_forma_pago==0 || res.data.valor_forma_pago=='')this.formEdit.valor_forma_pago = parseFloat(res.data.total)
              if(this.formEdit.id_type_forma_pago_secundaria != null){
                if(res.data.valor_forma_pago_secundaria != null){
                  this.formEdit.valor_forma_pago_secundaria =parseFloat(res.data.valor_forma_pago_secundaria);
                } else{
                  this.formEdit.valor_forma_pago_secundaria = parseFloat(res.data.total) - parseFloat(res.data.valor_forma_pago);
                }
              } else{
                this.formEdit.id_type_forma_pago_secundaria=0
              }
              this.categoriesDone = false;
            }
          })
          .catch(err => {
            this.categoriesDone = false;
          });
      } else{
        this.categoriesDone = false;
      }
    },
    
  },   
  created(){
    if(this.$route.params.mesa && this.$route.params.mesa == "home"){
      this.$router.push({ name: 'Linktree'})     
    }
    if(this.$route.params.mesa && this.$route.params.mesa == "bold"){
      this.$router.push({ name: 'Bold'})     
    }
    if(this.$route.params.mesa && this.$route.params.mesa == "reservation"){
      this.$router.push({ name: 'Schedule'})     
    }
  },
  mounted(){
    if(this.form.fecha_nacimiento_mes==null)this.form.fecha_nacimiento_mes = new Date().getMonth() + 1;
    if(this.form.fecha_nacimiento_dia==null)this.form.fecha_nacimiento_dia = new Date().getDate();

    $(".result-mobile-view").hide();
    $(".result-desktop-view").hide();

    //VALIDACION PARA CUANDO ENTRE A VINAPP.CO ENVIAR A INFO
    if(location.pathname === '/' || location.pathname === '' )location.href="https://info.vinapp.co";
    var self = this;
    /*jQuery(document).ready(function($){
      $(document).ready(function() {
          $('.mi-selector').select2();
      });
    });*/
    $(".esfere").hide();
    setTimeout(function(){
      $(".carousel-inner .carousel-item:nth-child(1)").addClass("active");
    },2000);
    var drinkSelect = document.getElementById('id_btn_confirmar');
    setTimeout(function(){
         drinkSelect.disabled = true; 
        }, 500);
    /*setTimeout(function(){
      self.initMap();
    },4000);*/
    setTimeout(function(){
      var nacimiento = document.getElementById('nacimiento');


      function checkValue(str, max) {
        if (str.charAt(0) !== '0' || str == '00') {
          var num = parseInt(str);
          if (isNaN(num) || num <= 0 || num > max) num = 1;
          str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
        }
        return str;
      }


      nacimiento.addEventListener('input', function() {
      //this.type = 'text';
      var input = nacimiento.value;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = checkValue(values[0], 12);
      if (values[1]) values[1] = checkValue(values[1], 31);
      var output = values.map(function(v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      nacimiento.value = output.join('').substr(0, 14);
    });

    nacimiento.addEventListener('blur', function() {
      //this.type = 'text';
      var input = nacimiento.value;
      var values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      });
      var output = '';
      
      if (values.length == 3) {
        var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
        var month = parseInt(values[0]) - 1;
        var day = parseInt(values[1]);
        var d = new Date(year, month, day);
        if (!isNaN(d)) {
          //document.getElementById('result').innerText = d.toString();
          var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
          output = dates.map(function(v) {
            v = v.toString();
            return v.length == 1 ? '0' + v : v;
          }).join(' / ');
        }
      }
      nacimiento.value = output;
    });
    },8000)
    




     $('.out-service').hide();
        $('.loading-icon').addClass("hide");
        $('.botonmostrar').click(function(){
        $('.cupon-contain').removeClass("ocultarcupon");
        $('.botoncerrar').removeClass("ocultarcupon");
        $('.botonmostrar').addClass("ocultarcupon");
      });

      $('.botoncerrar').click(function(){
        $('.botoncerrar').addClass("ocultarcupon");
        $('.cupon-contain').addClass("ocultarcupon");
        $('.botonmostrar').removeClass("ocultarcupon");
      });
    if(location.pathname.includes('punto=')){
    
      const pathname = location.pathname;
      const regex = /punto=([^\/]*)/;
      const match = pathname.match(regex);
      if (match && match[1]) {
        const puntoValue = match[1];
        this.id_point_companie = puntoValue;
        this.$route.params.mesa = undefined;
        this.$route.params.punto = puntoValue;

        const regexMesa = /punto=[^\/]*\/([^\/]*)/;
        const matchMesa = pathname.match(regexMesa);
        if (matchMesa && matchMesa[1]) {
          this.$route.params.mesa = matchMesa[1];
        }
      }
    }
    if(this.$route.params.mesa){
        this.mode_mesa = true;
        this.form.mesa = this.$route.params.mesa;                
        this.formaEntrega.mesas = true;
        this.formaEntrega.domicilio = false;
        this.formaEntrega.recogerlo = false;       
    }
    //validacion
    if(location.search == "?mesero"){
      this.mesero = true;
      this.nombre_mesero=localStorage.getItem('nombre_mesero')
      this.loginStatus=localStorage.getItem('loginStatus')
    }

    if(location.search.includes('kiosko')){
      this.kiosko = true;
      this.style1 = true;
      localStorage.setItem('kiosko', true);
    }else{
      this.kiosko = false;
      localStorage.setItem('kiosko', false);
    }

    
    if (location.search == "?delivery") {
      this.delivery_app = true;
      
      document.getElementById("btn-mesa").disabled=true;
      document.getElementById("btn-recogerlo").disabled=true; 
    }
    this.setupCompanie();
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault();
      installEvent = e;
      this.showInstallBanner = true;
      if (this.showInstallBanner) {
        $('.notify-schedule').addClass("gotop");
        $('.my-orders').addClass("gotop");
      }else{
        $('.notify-schedule').removeClass("gotop");
        $('.my-orders').removeClass("gotop");
      }
    });
    setTimeout(function(){ self.getCountOrderProcess()  }, 1000);
    
      
      // Detects if device is on iOS 
      const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();      
        return /iphone|ipad|ipod/.test( userAgent );
      } 
      const isFacebookApp = ()  => {
          const ua = navigator.userAgent || navigator.vendor || window.opera;
          return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
      }
      // Detects if device is in standalone mode
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
      // Checks if should display install popup notification:
      if (isIos() && !isInStandaloneMode()){
        if(!navigator.userAgent.includes("Instagram") && !isFacebookApp()){
          document.getElementById('pwa-ios-notify').style.display = 'block'; 
          document.getElementById('pwa-ios-notify').style.zIndex = "3" ;
          setTimeout(function(){ document.getElementById('pwa-ios-notify').style.display = 'none'; }, 15000);
        }
      }

      if(location.search.includes('print')){
        this.print_page = true;
      }
      this.loadPrinter();

      if (this.mesero) {
        this.mesaPedido();
      }
      this.updateMesaTimers();
      setInterval(() => {
        this.updateMesaTimers();
      }, 1000);

      

      
  }//fin mounted
}
</script>
<style>
.wrapper{
    max-width: 250px;
    margin: 0 auto;
}
.e-date-wrapper .e-input-group-icon.e-date-icon{
  font-size: 22px !important;
}
.e-date-wrapper .e-time-icon.e-icons::before{
   font-size: 22px !important;
}
.e-input-group:not(.e-float-icon-left), .e-input-group.e-control-wrapper:not(.e-float-icon-left){
  border: none !important;
}
@import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import "../../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
</style>
